import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: number;
  DateTime: any;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int'];
};

export type AggregateApplyCircles = {
  __typename?: 'AggregateApplyCircles';
  _avg?: Maybe<ApplyCirclesAvgAggregate>;
  _count?: Maybe<ApplyCirclesCountAggregate>;
  _max?: Maybe<ApplyCirclesMaxAggregate>;
  _min?: Maybe<ApplyCirclesMinAggregate>;
  _sum?: Maybe<ApplyCirclesSumAggregate>;
};

export type AggregateCircleComments = {
  __typename?: 'AggregateCircleComments';
  _avg?: Maybe<CircleCommentsAvgAggregate>;
  _count?: Maybe<CircleCommentsCountAggregate>;
  _max?: Maybe<CircleCommentsMaxAggregate>;
  _min?: Maybe<CircleCommentsMinAggregate>;
  _sum?: Maybe<CircleCommentsSumAggregate>;
};

export type AggregateCircleGenres = {
  __typename?: 'AggregateCircleGenres';
  _avg?: Maybe<CircleGenresAvgAggregate>;
  _count?: Maybe<CircleGenresCountAggregate>;
  _max?: Maybe<CircleGenresMaxAggregate>;
  _min?: Maybe<CircleGenresMinAggregate>;
  _sum?: Maybe<CircleGenresSumAggregate>;
};

export type AggregateCircleMembers = {
  __typename?: 'AggregateCircleMembers';
  _avg?: Maybe<CircleMembersAvgAggregate>;
  _count?: Maybe<CircleMembersCountAggregate>;
  _max?: Maybe<CircleMembersMaxAggregate>;
  _min?: Maybe<CircleMembersMinAggregate>;
  _sum?: Maybe<CircleMembersSumAggregate>;
};

export type AggregateCircleSkills = {
  __typename?: 'AggregateCircleSkills';
  _avg?: Maybe<CircleSkillsAvgAggregate>;
  _count?: Maybe<CircleSkillsCountAggregate>;
  _max?: Maybe<CircleSkillsMaxAggregate>;
  _min?: Maybe<CircleSkillsMinAggregate>;
  _sum?: Maybe<CircleSkillsSumAggregate>;
};

export type AggregateCircles = {
  __typename?: 'AggregateCircles';
  _avg?: Maybe<CirclesAvgAggregate>;
  _count?: Maybe<CirclesCountAggregate>;
  _max?: Maybe<CirclesMaxAggregate>;
  _min?: Maybe<CirclesMinAggregate>;
  _sum?: Maybe<CirclesSumAggregate>;
};

export type AggregateCommercials = {
  __typename?: 'AggregateCommercials';
  _avg?: Maybe<CommercialsAvgAggregate>;
  _count?: Maybe<CommercialsCountAggregate>;
  _max?: Maybe<CommercialsMaxAggregate>;
  _min?: Maybe<CommercialsMinAggregate>;
  _sum?: Maybe<CommercialsSumAggregate>;
};

export type AggregateFavoriteProductions = {
  __typename?: 'AggregateFavoriteProductions';
  _avg?: Maybe<FavoriteProductionsAvgAggregate>;
  _count?: Maybe<FavoriteProductionsCountAggregate>;
  _max?: Maybe<FavoriteProductionsMaxAggregate>;
  _min?: Maybe<FavoriteProductionsMinAggregate>;
  _sum?: Maybe<FavoriteProductionsSumAggregate>;
};

export type AggregateGenres = {
  __typename?: 'AggregateGenres';
  _avg?: Maybe<GenresAvgAggregate>;
  _count?: Maybe<GenresCountAggregate>;
  _max?: Maybe<GenresMaxAggregate>;
  _min?: Maybe<GenresMinAggregate>;
  _sum?: Maybe<GenresSumAggregate>;
};

export type AggregateGoodProductions = {
  __typename?: 'AggregateGoodProductions';
  _avg?: Maybe<GoodProductionsAvgAggregate>;
  _count?: Maybe<GoodProductionsCountAggregate>;
  _max?: Maybe<GoodProductionsMaxAggregate>;
  _min?: Maybe<GoodProductionsMinAggregate>;
  _sum?: Maybe<GoodProductionsSumAggregate>;
};

export type AggregateLatestProductions = {
  __typename?: 'AggregateLatestProductions';
  _avg?: Maybe<LatestProductionsAvgAggregate>;
  _count?: Maybe<LatestProductionsCountAggregate>;
  _max?: Maybe<LatestProductionsMaxAggregate>;
  _min?: Maybe<LatestProductionsMinAggregate>;
  _sum?: Maybe<LatestProductionsSumAggregate>;
};

export type AggregateNotices = {
  __typename?: 'AggregateNotices';
  _avg?: Maybe<NoticesAvgAggregate>;
  _count?: Maybe<NoticesCountAggregate>;
  _max?: Maybe<NoticesMaxAggregate>;
  _min?: Maybe<NoticesMinAggregate>;
  _sum?: Maybe<NoticesSumAggregate>;
};

export type AggregatePopularProductions = {
  __typename?: 'AggregatePopularProductions';
  _avg?: Maybe<PopularProductionsAvgAggregate>;
  _count?: Maybe<PopularProductionsCountAggregate>;
  _max?: Maybe<PopularProductionsMaxAggregate>;
  _min?: Maybe<PopularProductionsMinAggregate>;
  _sum?: Maybe<PopularProductionsSumAggregate>;
};

export type AggregateProductionGenres = {
  __typename?: 'AggregateProductionGenres';
  _avg?: Maybe<ProductionGenresAvgAggregate>;
  _count?: Maybe<ProductionGenresCountAggregate>;
  _max?: Maybe<ProductionGenresMaxAggregate>;
  _min?: Maybe<ProductionGenresMinAggregate>;
  _sum?: Maybe<ProductionGenresSumAggregate>;
};

export type AggregateProductionSeries = {
  __typename?: 'AggregateProductionSeries';
  _avg?: Maybe<ProductionSeriesAvgAggregate>;
  _count?: Maybe<ProductionSeriesCountAggregate>;
  _max?: Maybe<ProductionSeriesMaxAggregate>;
  _min?: Maybe<ProductionSeriesMinAggregate>;
  _sum?: Maybe<ProductionSeriesSumAggregate>;
};

export type AggregateProductionTags = {
  __typename?: 'AggregateProductionTags';
  _avg?: Maybe<ProductionTagsAvgAggregate>;
  _count?: Maybe<ProductionTagsCountAggregate>;
  _max?: Maybe<ProductionTagsMaxAggregate>;
  _min?: Maybe<ProductionTagsMinAggregate>;
  _sum?: Maybe<ProductionTagsSumAggregate>;
};

export type AggregateProductions = {
  __typename?: 'AggregateProductions';
  _avg?: Maybe<ProductionsAvgAggregate>;
  _count?: Maybe<ProductionsCountAggregate>;
  _max?: Maybe<ProductionsMaxAggregate>;
  _min?: Maybe<ProductionsMinAggregate>;
  _sum?: Maybe<ProductionsSumAggregate>;
};

export type AggregateSeries = {
  __typename?: 'AggregateSeries';
  _avg?: Maybe<SeriesAvgAggregate>;
  _count?: Maybe<SeriesCountAggregate>;
  _max?: Maybe<SeriesMaxAggregate>;
  _min?: Maybe<SeriesMinAggregate>;
  _sum?: Maybe<SeriesSumAggregate>;
};

export type AggregateTags = {
  __typename?: 'AggregateTags';
  _avg?: Maybe<TagsAvgAggregate>;
  _count?: Maybe<TagsCountAggregate>;
  _max?: Maybe<TagsMaxAggregate>;
  _min?: Maybe<TagsMinAggregate>;
  _sum?: Maybe<TagsSumAggregate>;
};

/**
 *
 * サークル参加申込
 */
export type ApplyCircles = {
  __typename?: 'ApplyCircles';
  circle: Circles;
  /** 対象サークル */
  circleId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  /** サークル応募連番ID */
  id: Scalars['BigInt'];
  skill: Skills;
  /** 対象スキル */
  skillId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  /** 申し込んでる会員 */
  userId: Scalars['BigInt'];
};

export type ApplyCirclesAvgAggregate = {
  __typename?: 'ApplyCirclesAvgAggregate';
  circleId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  skillId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type ApplyCirclesCircleIdUserIdSkillIdCompoundUniqueInput = {
  circleId: Scalars['BigInt'];
  skillId: Scalars['BigInt'];
  userId: Scalars['BigInt'];
};

export type ApplyCirclesCountAggregate = {
  __typename?: 'ApplyCirclesCountAggregate';
  _all: Scalars['Int'];
  circleId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  skillId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ApplyCirclesCreateInput = {
  circle: CirclesCreateNestedOneWithoutAppliersInput;
  id?: InputMaybe<Scalars['BigInt']>;
  skill: SkillsCreateNestedOneWithoutApplyCirclesInput;
  user: UsersCreateNestedOneWithoutApplyCirclesInput;
};

export type ApplyCirclesCreateManySkillInput = {
  circleId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
  userId: Scalars['BigInt'];
};

export type ApplyCirclesCreateManySkillInputEnvelope = {
  data: Array<ApplyCirclesCreateManySkillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ApplyCirclesCreateManyUserInput = {
  circleId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
  skillId: Scalars['BigInt'];
};

export type ApplyCirclesCreateManyUserInputEnvelope = {
  data: Array<ApplyCirclesCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ApplyCirclesCreateNestedManyWithoutSkillInput = {
  connect?: InputMaybe<Array<ApplyCirclesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApplyCirclesCreateOrConnectWithoutSkillInput>>;
  create?: InputMaybe<Array<ApplyCirclesCreateWithoutSkillInput>>;
  createMany?: InputMaybe<ApplyCirclesCreateManySkillInputEnvelope>;
};

export type ApplyCirclesCreateOrConnectWithoutSkillInput = {
  create: ApplyCirclesCreateWithoutSkillInput;
  where: ApplyCirclesWhereUniqueInput;
};

export type ApplyCirclesCreateOrConnectWithoutUserInput = {
  create: ApplyCirclesCreateWithoutUserInput;
  where: ApplyCirclesWhereUniqueInput;
};

export type ApplyCirclesCreateWithoutSkillInput = {
  circle: CirclesCreateNestedOneWithoutAppliersInput;
  id?: InputMaybe<Scalars['BigInt']>;
  user: UsersCreateNestedOneWithoutApplyCirclesInput;
};

export type ApplyCirclesCreateWithoutUserInput = {
  circle: CirclesCreateNestedOneWithoutAppliersInput;
  id?: InputMaybe<Scalars['BigInt']>;
  skill: SkillsCreateNestedOneWithoutApplyCirclesInput;
};

export type ApplyCirclesListRelationFilter = {
  every?: InputMaybe<ApplyCirclesWhereInput>;
  none?: InputMaybe<ApplyCirclesWhereInput>;
  some?: InputMaybe<ApplyCirclesWhereInput>;
};

export type ApplyCirclesMaxAggregate = {
  __typename?: 'ApplyCirclesMaxAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  skillId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type ApplyCirclesMinAggregate = {
  __typename?: 'ApplyCirclesMinAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  skillId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type ApplyCirclesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApplyCirclesOrderByWithRelationInput = {
  circle?: InputMaybe<CirclesOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  skill?: InputMaybe<SkillsOrderByWithRelationInput>;
  skillId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum ApplyCirclesScalarFieldEnum {
  CircleId = 'circleId',
  CreatedAt = 'createdAt',
  Id = 'id',
  SkillId = 'skillId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ApplyCirclesScalarWhereInput = {
  AND?: InputMaybe<Array<ApplyCirclesScalarWhereInput>>;
  NOT?: InputMaybe<Array<ApplyCirclesScalarWhereInput>>;
  OR?: InputMaybe<Array<ApplyCirclesScalarWhereInput>>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ApplyCirclesSumAggregate = {
  __typename?: 'ApplyCirclesSumAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  skillId?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type ApplyCirclesUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ApplyCirclesUpdateManyWithWhereWithoutUserInput = {
  data: ApplyCirclesUpdateManyMutationInput;
  where: ApplyCirclesScalarWhereInput;
};

export type ApplyCirclesUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ApplyCirclesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApplyCirclesCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ApplyCirclesCreateWithoutUserInput>>;
  createMany?: InputMaybe<ApplyCirclesCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ApplyCirclesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApplyCirclesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApplyCirclesWhereUniqueInput>>;
  set?: InputMaybe<Array<ApplyCirclesWhereUniqueInput>>;
  update?: InputMaybe<Array<ApplyCirclesUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ApplyCirclesUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ApplyCirclesUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ApplyCirclesUpdateWithWhereUniqueWithoutUserInput = {
  data: ApplyCirclesUpdateWithoutUserInput;
  where: ApplyCirclesWhereUniqueInput;
};

export type ApplyCirclesUpdateWithoutUserInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ApplyCirclesUpsertWithWhereUniqueWithoutUserInput = {
  create: ApplyCirclesCreateWithoutUserInput;
  update: ApplyCirclesUpdateWithoutUserInput;
  where: ApplyCirclesWhereUniqueInput;
};

export type ApplyCirclesWhereInput = {
  AND?: InputMaybe<Array<ApplyCirclesWhereInput>>;
  NOT?: InputMaybe<Array<ApplyCirclesWhereInput>>;
  OR?: InputMaybe<Array<ApplyCirclesWhereInput>>;
  circle?: InputMaybe<CirclesRelationFilter>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  skill?: InputMaybe<SkillsRelationFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ApplyCirclesWhereUniqueInput = {
  circleId_userId_skillId?: InputMaybe<ApplyCirclesCircleIdUserIdSkillIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']>;
  divide?: InputMaybe<Scalars['BigInt']>;
  increment?: InputMaybe<Scalars['BigInt']>;
  multiply?: InputMaybe<Scalars['BigInt']>;
  set?: InputMaybe<Scalars['BigInt']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type BigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

/**
 *
 * サークルへのコメント（投稿）
 */
export type CircleComments = {
  __typename?: 'CircleComments';
  circle: Circles;
  circleId: Scalars['BigInt'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  disabled?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
};

export type CircleCommentsAvgAggregate = {
  __typename?: 'CircleCommentsAvgAggregate';
  circleId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type CircleCommentsCountAggregate = {
  __typename?: 'CircleCommentsCountAggregate';
  _all: Scalars['Int'];
  circleId: Scalars['Int'];
  comment: Scalars['Int'];
  createdAt: Scalars['Int'];
  disabled: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CircleCommentsCreateInput = {
  circle: CirclesCreateNestedOneWithoutCircleCommentsInput;
  comment: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  user: UsersCreateNestedOneWithoutCircleCommentsInput;
};

export type CircleCommentsCreateManyUserInput = {
  circleId: Scalars['BigInt'];
  comment: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CircleCommentsCreateManyUserInputEnvelope = {
  data: Array<CircleCommentsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CircleCommentsCreateOrConnectWithoutUserInput = {
  create: CircleCommentsCreateWithoutUserInput;
  where: CircleCommentsWhereUniqueInput;
};

export type CircleCommentsCreateWithoutUserInput = {
  circle: CirclesCreateNestedOneWithoutCircleCommentsInput;
  comment: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CircleCommentsListRelationFilter = {
  every?: InputMaybe<CircleCommentsWhereInput>;
  none?: InputMaybe<CircleCommentsWhereInput>;
  some?: InputMaybe<CircleCommentsWhereInput>;
};

export type CircleCommentsMaxAggregate = {
  __typename?: 'CircleCommentsMaxAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disabled?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CircleCommentsMinAggregate = {
  __typename?: 'CircleCommentsMinAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disabled?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CircleCommentsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CircleCommentsOrderByWithRelationInput = {
  circle?: InputMaybe<CirclesOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrder>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum CircleCommentsScalarFieldEnum {
  CircleId = 'circleId',
  Comment = 'comment',
  CreatedAt = 'createdAt',
  Disabled = 'disabled',
  Id = 'id',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type CircleCommentsScalarWhereInput = {
  AND?: InputMaybe<Array<CircleCommentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<CircleCommentsScalarWhereInput>>;
  OR?: InputMaybe<Array<CircleCommentsScalarWhereInput>>;
  circleId?: InputMaybe<BigIntFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CircleCommentsSumAggregate = {
  __typename?: 'CircleCommentsSumAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CircleCommentsUpdateManyMutationInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type CircleCommentsUpdateManyWithWhereWithoutUserInput = {
  data: CircleCommentsUpdateManyMutationInput;
  where: CircleCommentsScalarWhereInput;
};

export type CircleCommentsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CircleCommentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CircleCommentsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CircleCommentsCreateWithoutUserInput>>;
  createMany?: InputMaybe<CircleCommentsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CircleCommentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CircleCommentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CircleCommentsWhereUniqueInput>>;
  set?: InputMaybe<Array<CircleCommentsWhereUniqueInput>>;
  update?: InputMaybe<Array<CircleCommentsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CircleCommentsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CircleCommentsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CircleCommentsUpdateWithWhereUniqueWithoutUserInput = {
  data: CircleCommentsUpdateWithoutUserInput;
  where: CircleCommentsWhereUniqueInput;
};

export type CircleCommentsUpdateWithoutUserInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type CircleCommentsUpsertWithWhereUniqueWithoutUserInput = {
  create: CircleCommentsCreateWithoutUserInput;
  update: CircleCommentsUpdateWithoutUserInput;
  where: CircleCommentsWhereUniqueInput;
};

export type CircleCommentsWhereInput = {
  AND?: InputMaybe<Array<CircleCommentsWhereInput>>;
  NOT?: InputMaybe<Array<CircleCommentsWhereInput>>;
  OR?: InputMaybe<Array<CircleCommentsWhereInput>>;
  circle?: InputMaybe<CirclesRelationFilter>;
  circleId?: InputMaybe<BigIntFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CircleCommentsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * サークルのジャンル
 */
export type CircleGenres = {
  __typename?: 'CircleGenres';
  circle: Circles;
  circleId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  genre: Genres;
  genreId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CircleGenresAvgAggregate = {
  __typename?: 'CircleGenresAvgAggregate';
  circleId?: Maybe<Scalars['Float']>;
  genreId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type CircleGenresCircleIdGenreIdCompoundUniqueInput = {
  circleId: Scalars['BigInt'];
  genreId: Scalars['BigInt'];
};

export type CircleGenresCountAggregate = {
  __typename?: 'CircleGenresCountAggregate';
  _all: Scalars['Int'];
  circleId: Scalars['Int'];
  createdAt: Scalars['Int'];
  genreId: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CircleGenresCreateInput = {
  circle: CirclesCreateNestedOneWithoutCircleGenresInput;
  genre: GenresCreateNestedOneWithoutCircleGenresInput;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CircleGenresCreateManyCircleInput = {
  genreId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CircleGenresCreateManyCircleInputEnvelope = {
  data: Array<CircleGenresCreateManyCircleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CircleGenresCreateNestedManyWithoutCircleInput = {
  connect?: InputMaybe<Array<CircleGenresWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CircleGenresCreateOrConnectWithoutCircleInput>>;
  create?: InputMaybe<Array<CircleGenresCreateWithoutCircleInput>>;
  createMany?: InputMaybe<CircleGenresCreateManyCircleInputEnvelope>;
};

export type CircleGenresCreateOrConnectWithoutCircleInput = {
  create: CircleGenresCreateWithoutCircleInput;
  where: CircleGenresWhereUniqueInput;
};

export type CircleGenresCreateWithoutCircleInput = {
  genre: GenresCreateNestedOneWithoutCircleGenresInput;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CircleGenresListRelationFilter = {
  every?: InputMaybe<CircleGenresWhereInput>;
  none?: InputMaybe<CircleGenresWhereInput>;
  some?: InputMaybe<CircleGenresWhereInput>;
};

export type CircleGenresMaxAggregate = {
  __typename?: 'CircleGenresMaxAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  genreId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CircleGenresMinAggregate = {
  __typename?: 'CircleGenresMinAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  genreId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CircleGenresOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CircleGenresOrderByWithRelationInput = {
  circle?: InputMaybe<CirclesOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  genre?: InputMaybe<GenresOrderByWithRelationInput>;
  genreId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum CircleGenresScalarFieldEnum {
  CircleId = 'circleId',
  CreatedAt = 'createdAt',
  GenreId = 'genreId',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type CircleGenresScalarWhereInput = {
  AND?: InputMaybe<Array<CircleGenresScalarWhereInput>>;
  NOT?: InputMaybe<Array<CircleGenresScalarWhereInput>>;
  OR?: InputMaybe<Array<CircleGenresScalarWhereInput>>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  genreId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CircleGenresSumAggregate = {
  __typename?: 'CircleGenresSumAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  genreId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
};

export type CircleGenresUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type CircleGenresUpdateManyWithWhereWithoutCircleInput = {
  data: CircleGenresUpdateManyMutationInput;
  where: CircleGenresScalarWhereInput;
};

export type CircleGenresUpdateManyWithoutCircleNestedInput = {
  connect?: InputMaybe<Array<CircleGenresWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CircleGenresCreateOrConnectWithoutCircleInput>>;
  create?: InputMaybe<Array<CircleGenresCreateWithoutCircleInput>>;
  createMany?: InputMaybe<CircleGenresCreateManyCircleInputEnvelope>;
  delete?: InputMaybe<Array<CircleGenresWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CircleGenresScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CircleGenresWhereUniqueInput>>;
  set?: InputMaybe<Array<CircleGenresWhereUniqueInput>>;
  update?: InputMaybe<Array<CircleGenresUpdateWithWhereUniqueWithoutCircleInput>>;
  updateMany?: InputMaybe<Array<CircleGenresUpdateManyWithWhereWithoutCircleInput>>;
  upsert?: InputMaybe<Array<CircleGenresUpsertWithWhereUniqueWithoutCircleInput>>;
};

export type CircleGenresUpdateWithWhereUniqueWithoutCircleInput = {
  data: CircleGenresUpdateWithoutCircleInput;
  where: CircleGenresWhereUniqueInput;
};

export type CircleGenresUpdateWithoutCircleInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type CircleGenresUpsertWithWhereUniqueWithoutCircleInput = {
  create: CircleGenresCreateWithoutCircleInput;
  update: CircleGenresUpdateWithoutCircleInput;
  where: CircleGenresWhereUniqueInput;
};

export type CircleGenresWhereInput = {
  AND?: InputMaybe<Array<CircleGenresWhereInput>>;
  NOT?: InputMaybe<Array<CircleGenresWhereInput>>;
  OR?: InputMaybe<Array<CircleGenresWhereInput>>;
  circle?: InputMaybe<CirclesRelationFilter>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  genre?: InputMaybe<GenresRelationFilter>;
  genreId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CircleGenresWhereUniqueInput = {
  circleId_genreId?: InputMaybe<CircleGenresCircleIdGenreIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * サークルのメンバー（会員）
 */
export type CircleMembers = {
  __typename?: 'CircleMembers';
  circle: Circles;
  circleId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  skill: Skills;
  /** 対象スキル */
  skillId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
};

export type CircleMembersAvgAggregate = {
  __typename?: 'CircleMembersAvgAggregate';
  circleId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  skillId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type CircleMembersCircleIdUserIdSkillIdCompoundUniqueInput = {
  circleId: Scalars['BigInt'];
  skillId: Scalars['BigInt'];
  userId: Scalars['BigInt'];
};

export type CircleMembersCountAggregate = {
  __typename?: 'CircleMembersCountAggregate';
  _all: Scalars['Int'];
  circleId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  skillId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CircleMembersCreateInput = {
  circle: CirclesCreateNestedOneWithoutMembersInput;
  id?: InputMaybe<Scalars['BigInt']>;
  skill: SkillsCreateNestedOneWithoutCircleMembersInput;
  user: UsersCreateNestedOneWithoutCircleMembersInput;
};

export type CircleMembersCreateManySkillInput = {
  circleId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
  userId: Scalars['BigInt'];
};

export type CircleMembersCreateManySkillInputEnvelope = {
  data: Array<CircleMembersCreateManySkillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CircleMembersCreateManyUserInput = {
  circleId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
  skillId: Scalars['BigInt'];
};

export type CircleMembersCreateManyUserInputEnvelope = {
  data: Array<CircleMembersCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CircleMembersCreateNestedManyWithoutSkillInput = {
  connect?: InputMaybe<Array<CircleMembersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CircleMembersCreateOrConnectWithoutSkillInput>>;
  create?: InputMaybe<Array<CircleMembersCreateWithoutSkillInput>>;
  createMany?: InputMaybe<CircleMembersCreateManySkillInputEnvelope>;
};

export type CircleMembersCreateOrConnectWithoutSkillInput = {
  create: CircleMembersCreateWithoutSkillInput;
  where: CircleMembersWhereUniqueInput;
};

export type CircleMembersCreateOrConnectWithoutUserInput = {
  create: CircleMembersCreateWithoutUserInput;
  where: CircleMembersWhereUniqueInput;
};

export type CircleMembersCreateWithoutSkillInput = {
  circle: CirclesCreateNestedOneWithoutMembersInput;
  id?: InputMaybe<Scalars['BigInt']>;
  user: UsersCreateNestedOneWithoutCircleMembersInput;
};

export type CircleMembersCreateWithoutUserInput = {
  circle: CirclesCreateNestedOneWithoutMembersInput;
  id?: InputMaybe<Scalars['BigInt']>;
  skill: SkillsCreateNestedOneWithoutCircleMembersInput;
};

export type CircleMembersListRelationFilter = {
  every?: InputMaybe<CircleMembersWhereInput>;
  none?: InputMaybe<CircleMembersWhereInput>;
  some?: InputMaybe<CircleMembersWhereInput>;
};

export type CircleMembersMaxAggregate = {
  __typename?: 'CircleMembersMaxAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  skillId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CircleMembersMinAggregate = {
  __typename?: 'CircleMembersMinAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  skillId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CircleMembersOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CircleMembersOrderByWithRelationInput = {
  circle?: InputMaybe<CirclesOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  skill?: InputMaybe<SkillsOrderByWithRelationInput>;
  skillId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum CircleMembersScalarFieldEnum {
  CircleId = 'circleId',
  CreatedAt = 'createdAt',
  Id = 'id',
  SkillId = 'skillId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type CircleMembersScalarWhereInput = {
  AND?: InputMaybe<Array<CircleMembersScalarWhereInput>>;
  NOT?: InputMaybe<Array<CircleMembersScalarWhereInput>>;
  OR?: InputMaybe<Array<CircleMembersScalarWhereInput>>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CircleMembersSumAggregate = {
  __typename?: 'CircleMembersSumAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  skillId?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CircleMembersUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type CircleMembersUpdateManyWithWhereWithoutUserInput = {
  data: CircleMembersUpdateManyMutationInput;
  where: CircleMembersScalarWhereInput;
};

export type CircleMembersUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CircleMembersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CircleMembersCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CircleMembersCreateWithoutUserInput>>;
  createMany?: InputMaybe<CircleMembersCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CircleMembersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CircleMembersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CircleMembersWhereUniqueInput>>;
  set?: InputMaybe<Array<CircleMembersWhereUniqueInput>>;
  update?: InputMaybe<Array<CircleMembersUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CircleMembersUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CircleMembersUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CircleMembersUpdateWithWhereUniqueWithoutUserInput = {
  data: CircleMembersUpdateWithoutUserInput;
  where: CircleMembersWhereUniqueInput;
};

export type CircleMembersUpdateWithoutUserInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type CircleMembersUpsertWithWhereUniqueWithoutUserInput = {
  create: CircleMembersCreateWithoutUserInput;
  update: CircleMembersUpdateWithoutUserInput;
  where: CircleMembersWhereUniqueInput;
};

export type CircleMembersWhereInput = {
  AND?: InputMaybe<Array<CircleMembersWhereInput>>;
  NOT?: InputMaybe<Array<CircleMembersWhereInput>>;
  OR?: InputMaybe<Array<CircleMembersWhereInput>>;
  circle?: InputMaybe<CirclesRelationFilter>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  skill?: InputMaybe<SkillsRelationFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CircleMembersWhereUniqueInput = {
  circleId_userId_skillId?: InputMaybe<CircleMembersCircleIdUserIdSkillIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * サークルが求めるスキル
 */
export type CircleSkills = {
  __typename?: 'CircleSkills';
  circle: Circles;
  circleId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  level: Scalars['Int'];
  num: Scalars['Int'];
  required: Scalars['Boolean'];
  skill: Skills;
  skillId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CircleSkillsAvgAggregate = {
  __typename?: 'CircleSkillsAvgAggregate';
  circleId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  num?: Maybe<Scalars['Float']>;
  skillId?: Maybe<Scalars['Float']>;
};

export type CircleSkillsCircleIdSkillIdCompoundUniqueInput = {
  circleId: Scalars['BigInt'];
  skillId: Scalars['BigInt'];
};

export type CircleSkillsCountAggregate = {
  __typename?: 'CircleSkillsCountAggregate';
  _all: Scalars['Int'];
  circleId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  level: Scalars['Int'];
  num: Scalars['Int'];
  required: Scalars['Int'];
  skillId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CircleSkillsCreateInput = {
  circle: CirclesCreateNestedOneWithoutCircleSkillsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  level?: InputMaybe<Scalars['Int']>;
  num?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  skill: SkillsCreateNestedOneWithoutCircleSkillsInput;
};

export type CircleSkillsCreateManyCircleInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  level?: InputMaybe<Scalars['Int']>;
  num?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  skillId: Scalars['BigInt'];
};

export type CircleSkillsCreateManyCircleInputEnvelope = {
  data: Array<CircleSkillsCreateManyCircleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CircleSkillsCreateNestedManyWithoutCircleInput = {
  connect?: InputMaybe<Array<CircleSkillsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CircleSkillsCreateOrConnectWithoutCircleInput>>;
  create?: InputMaybe<Array<CircleSkillsCreateWithoutCircleInput>>;
  createMany?: InputMaybe<CircleSkillsCreateManyCircleInputEnvelope>;
};

export type CircleSkillsCreateOrConnectWithoutCircleInput = {
  create: CircleSkillsCreateWithoutCircleInput;
  where: CircleSkillsWhereUniqueInput;
};

export type CircleSkillsCreateWithoutCircleInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  level?: InputMaybe<Scalars['Int']>;
  num?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  skill: SkillsCreateNestedOneWithoutCircleSkillsInput;
};

export type CircleSkillsListRelationFilter = {
  every?: InputMaybe<CircleSkillsWhereInput>;
  none?: InputMaybe<CircleSkillsWhereInput>;
  some?: InputMaybe<CircleSkillsWhereInput>;
};

export type CircleSkillsMaxAggregate = {
  __typename?: 'CircleSkillsMaxAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  level?: Maybe<Scalars['Int']>;
  num?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  skillId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CircleSkillsMinAggregate = {
  __typename?: 'CircleSkillsMinAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  level?: Maybe<Scalars['Int']>;
  num?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  skillId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CircleSkillsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CircleSkillsOrderByWithRelationInput = {
  circle?: InputMaybe<CirclesOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  level?: InputMaybe<SortOrder>;
  num?: InputMaybe<SortOrder>;
  required?: InputMaybe<SortOrder>;
  skill?: InputMaybe<SkillsOrderByWithRelationInput>;
  skillId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum CircleSkillsScalarFieldEnum {
  CircleId = 'circleId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Level = 'level',
  Num = 'num',
  Required = 'required',
  SkillId = 'skillId',
  UpdatedAt = 'updatedAt'
}

export type CircleSkillsScalarWhereInput = {
  AND?: InputMaybe<Array<CircleSkillsScalarWhereInput>>;
  NOT?: InputMaybe<Array<CircleSkillsScalarWhereInput>>;
  OR?: InputMaybe<Array<CircleSkillsScalarWhereInput>>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  level?: InputMaybe<IntFilter>;
  num?: InputMaybe<IntFilter>;
  required?: InputMaybe<BoolFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CircleSkillsSumAggregate = {
  __typename?: 'CircleSkillsSumAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  level?: Maybe<Scalars['Int']>;
  num?: Maybe<Scalars['Int']>;
  skillId?: Maybe<Scalars['BigInt']>;
};

export type CircleSkillsUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  level?: InputMaybe<IntFieldUpdateOperationsInput>;
  num?: InputMaybe<IntFieldUpdateOperationsInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CircleSkillsUpdateManyWithWhereWithoutCircleInput = {
  data: CircleSkillsUpdateManyMutationInput;
  where: CircleSkillsScalarWhereInput;
};

export type CircleSkillsUpdateManyWithoutCircleNestedInput = {
  connect?: InputMaybe<Array<CircleSkillsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CircleSkillsCreateOrConnectWithoutCircleInput>>;
  create?: InputMaybe<Array<CircleSkillsCreateWithoutCircleInput>>;
  createMany?: InputMaybe<CircleSkillsCreateManyCircleInputEnvelope>;
  delete?: InputMaybe<Array<CircleSkillsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CircleSkillsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CircleSkillsWhereUniqueInput>>;
  set?: InputMaybe<Array<CircleSkillsWhereUniqueInput>>;
  update?: InputMaybe<Array<CircleSkillsUpdateWithWhereUniqueWithoutCircleInput>>;
  updateMany?: InputMaybe<Array<CircleSkillsUpdateManyWithWhereWithoutCircleInput>>;
  upsert?: InputMaybe<Array<CircleSkillsUpsertWithWhereUniqueWithoutCircleInput>>;
};

export type CircleSkillsUpdateWithWhereUniqueWithoutCircleInput = {
  data: CircleSkillsUpdateWithoutCircleInput;
  where: CircleSkillsWhereUniqueInput;
};

export type CircleSkillsUpdateWithoutCircleInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  level?: InputMaybe<IntFieldUpdateOperationsInput>;
  num?: InputMaybe<IntFieldUpdateOperationsInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CircleSkillsUpsertWithWhereUniqueWithoutCircleInput = {
  create: CircleSkillsCreateWithoutCircleInput;
  update: CircleSkillsUpdateWithoutCircleInput;
  where: CircleSkillsWhereUniqueInput;
};

export type CircleSkillsWhereInput = {
  AND?: InputMaybe<Array<CircleSkillsWhereInput>>;
  NOT?: InputMaybe<Array<CircleSkillsWhereInput>>;
  OR?: InputMaybe<Array<CircleSkillsWhereInput>>;
  circle?: InputMaybe<CirclesRelationFilter>;
  circleId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  level?: InputMaybe<IntFilter>;
  num?: InputMaybe<IntFilter>;
  required?: InputMaybe<BoolFilter>;
  skill?: InputMaybe<SkillsRelationFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CircleSkillsWhereUniqueInput = {
  circleId_skillId?: InputMaybe<CircleSkillsCircleIdSkillIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * サークル
 */
export type Circles = {
  __typename?: 'Circles';
  _count?: Maybe<CirclesCount>;
  appliers: Array<ApplyCircles>;
  circleComments: Array<CircleComments>;
  circleGenres: Array<CircleGenres>;
  circleSkills: Array<CircleSkills>;
  closed?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  expire?: Maybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id: Scalars['BigInt'];
  members: Array<CircleMembers>;
  postFacebook: Scalars['Boolean'];
  postInstagram: Scalars['Boolean'];
  postTwitter: Scalars['Boolean'];
  productions: Array<Productions>;
  published?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
};


/**
 *
 * サークル
 */
export type CirclesAppliersArgs = {
  cursor?: InputMaybe<ApplyCirclesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplyCirclesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplyCirclesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplyCirclesWhereInput>;
};


/**
 *
 * サークル
 */
export type CirclesCircleCommentsArgs = {
  cursor?: InputMaybe<CircleCommentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleCommentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleCommentsWhereInput>;
};


/**
 *
 * サークル
 */
export type CirclesCircleGenresArgs = {
  cursor?: InputMaybe<CircleGenresWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleGenresScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleGenresWhereInput>;
};


/**
 *
 * サークル
 */
export type CirclesCircleSkillsArgs = {
  cursor?: InputMaybe<CircleSkillsWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleSkillsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleSkillsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleSkillsWhereInput>;
};


/**
 *
 * サークル
 */
export type CirclesMembersArgs = {
  cursor?: InputMaybe<CircleMembersWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleMembersScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleMembersOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleMembersWhereInput>;
};


/**
 *
 * サークル
 */
export type CirclesProductionsArgs = {
  cursor?: InputMaybe<ProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionsWhereInput>;
};

export type CirclesAvgAggregate = {
  __typename?: 'CirclesAvgAggregate';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type CirclesCount = {
  __typename?: 'CirclesCount';
  appliers: Scalars['Int'];
  circleComments: Scalars['Int'];
  circleGenres: Scalars['Int'];
  circleSkills: Scalars['Int'];
  members: Scalars['Int'];
  productions: Scalars['Int'];
};

export type CirclesCountAggregate = {
  __typename?: 'CirclesCountAggregate';
  _all: Scalars['Int'];
  closed: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  descriptionMd: Scalars['Int'];
  disabled: Scalars['Int'];
  expire: Scalars['Int'];
  goal: Scalars['Int'];
  id: Scalars['Int'];
  postFacebook: Scalars['Int'];
  postInstagram: Scalars['Int'];
  postTwitter: Scalars['Int'];
  published: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CirclesCreateInput = {
  circleGenres?: InputMaybe<CircleGenresCreateNestedManyWithoutCircleInput>;
  circleSkills?: InputMaybe<CircleSkillsCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productions?: InputMaybe<ProductionsCreateNestedManyWithoutCircleInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutCirclesInput;
};

export type CirclesCreateManyUserInput = {
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type CirclesCreateManyUserInputEnvelope = {
  data: Array<CirclesCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CirclesCreateNestedOneWithoutAppliersInput = {
  connect?: InputMaybe<CirclesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CirclesCreateOrConnectWithoutAppliersInput>;
  create?: InputMaybe<CirclesCreateWithoutAppliersInput>;
};

export type CirclesCreateNestedOneWithoutCircleCommentsInput = {
  connect?: InputMaybe<CirclesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CirclesCreateOrConnectWithoutCircleCommentsInput>;
  create?: InputMaybe<CirclesCreateWithoutCircleCommentsInput>;
};

export type CirclesCreateNestedOneWithoutCircleGenresInput = {
  connect?: InputMaybe<CirclesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CirclesCreateOrConnectWithoutCircleGenresInput>;
  create?: InputMaybe<CirclesCreateWithoutCircleGenresInput>;
};

export type CirclesCreateNestedOneWithoutCircleSkillsInput = {
  connect?: InputMaybe<CirclesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CirclesCreateOrConnectWithoutCircleSkillsInput>;
  create?: InputMaybe<CirclesCreateWithoutCircleSkillsInput>;
};

export type CirclesCreateNestedOneWithoutMembersInput = {
  connect?: InputMaybe<CirclesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CirclesCreateOrConnectWithoutMembersInput>;
  create?: InputMaybe<CirclesCreateWithoutMembersInput>;
};

export type CirclesCreateNestedOneWithoutProductionsInput = {
  connect?: InputMaybe<CirclesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CirclesCreateOrConnectWithoutProductionsInput>;
  create?: InputMaybe<CirclesCreateWithoutProductionsInput>;
};

export type CirclesCreateOrConnectWithoutAppliersInput = {
  create: CirclesCreateWithoutAppliersInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesCreateOrConnectWithoutCircleCommentsInput = {
  create: CirclesCreateWithoutCircleCommentsInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesCreateOrConnectWithoutCircleGenresInput = {
  create: CirclesCreateWithoutCircleGenresInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesCreateOrConnectWithoutCircleSkillsInput = {
  create: CirclesCreateWithoutCircleSkillsInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesCreateOrConnectWithoutMembersInput = {
  create: CirclesCreateWithoutMembersInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesCreateOrConnectWithoutProductionsInput = {
  create: CirclesCreateWithoutProductionsInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesCreateOrConnectWithoutUserInput = {
  create: CirclesCreateWithoutUserInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesCreateWithoutAppliersInput = {
  circleGenres?: InputMaybe<CircleGenresCreateNestedManyWithoutCircleInput>;
  circleSkills?: InputMaybe<CircleSkillsCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productions?: InputMaybe<ProductionsCreateNestedManyWithoutCircleInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutCirclesInput;
};

export type CirclesCreateWithoutCircleCommentsInput = {
  circleGenres?: InputMaybe<CircleGenresCreateNestedManyWithoutCircleInput>;
  circleSkills?: InputMaybe<CircleSkillsCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productions?: InputMaybe<ProductionsCreateNestedManyWithoutCircleInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutCirclesInput;
};

export type CirclesCreateWithoutCircleGenresInput = {
  circleSkills?: InputMaybe<CircleSkillsCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productions?: InputMaybe<ProductionsCreateNestedManyWithoutCircleInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutCirclesInput;
};

export type CirclesCreateWithoutCircleSkillsInput = {
  circleGenres?: InputMaybe<CircleGenresCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productions?: InputMaybe<ProductionsCreateNestedManyWithoutCircleInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutCirclesInput;
};

export type CirclesCreateWithoutMembersInput = {
  circleGenres?: InputMaybe<CircleGenresCreateNestedManyWithoutCircleInput>;
  circleSkills?: InputMaybe<CircleSkillsCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productions?: InputMaybe<ProductionsCreateNestedManyWithoutCircleInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutCirclesInput;
};

export type CirclesCreateWithoutProductionsInput = {
  circleGenres?: InputMaybe<CircleGenresCreateNestedManyWithoutCircleInput>;
  circleSkills?: InputMaybe<CircleSkillsCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutCirclesInput;
};

export type CirclesCreateWithoutUserInput = {
  circleGenres?: InputMaybe<CircleGenresCreateNestedManyWithoutCircleInput>;
  circleSkills?: InputMaybe<CircleSkillsCreateNestedManyWithoutCircleInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  expire?: InputMaybe<Scalars['DateTime']>;
  goal: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productions?: InputMaybe<ProductionsCreateNestedManyWithoutCircleInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type CirclesListRelationFilter = {
  every?: InputMaybe<CirclesWhereInput>;
  none?: InputMaybe<CirclesWhereInput>;
  some?: InputMaybe<CirclesWhereInput>;
};

export type CirclesMaxAggregate = {
  __typename?: 'CirclesMaxAggregate';
  closed?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  expire?: Maybe<Scalars['DateTime']>;
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  postFacebook?: Maybe<Scalars['Boolean']>;
  postInstagram?: Maybe<Scalars['Boolean']>;
  postTwitter?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CirclesMinAggregate = {
  __typename?: 'CirclesMinAggregate';
  closed?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  expire?: Maybe<Scalars['DateTime']>;
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  postFacebook?: Maybe<Scalars['Boolean']>;
  postInstagram?: Maybe<Scalars['Boolean']>;
  postTwitter?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CirclesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CirclesOrderByWithRelationInput = {
  appliers?: InputMaybe<ApplyCirclesOrderByRelationAggregateInput>;
  circleComments?: InputMaybe<CircleCommentsOrderByRelationAggregateInput>;
  circleGenres?: InputMaybe<CircleGenresOrderByRelationAggregateInput>;
  circleSkills?: InputMaybe<CircleSkillsOrderByRelationAggregateInput>;
  closed?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionMd?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  expire?: InputMaybe<SortOrder>;
  goal?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  members?: InputMaybe<CircleMembersOrderByRelationAggregateInput>;
  postFacebook?: InputMaybe<SortOrder>;
  postInstagram?: InputMaybe<SortOrder>;
  postTwitter?: InputMaybe<SortOrder>;
  productions?: InputMaybe<ProductionsOrderByRelationAggregateInput>;
  published?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type CirclesRelationFilter = {
  is?: InputMaybe<CirclesWhereInput>;
  isNot?: InputMaybe<CirclesWhereInput>;
};

export enum CirclesScalarFieldEnum {
  Closed = 'closed',
  CreatedAt = 'createdAt',
  Description = 'description',
  DescriptionMd = 'descriptionMd',
  Disabled = 'disabled',
  Expire = 'expire',
  Goal = 'goal',
  Id = 'id',
  PostFacebook = 'postFacebook',
  PostInstagram = 'postInstagram',
  PostTwitter = 'postTwitter',
  Published = 'published',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type CirclesScalarWhereInput = {
  AND?: InputMaybe<Array<CirclesScalarWhereInput>>;
  NOT?: InputMaybe<Array<CirclesScalarWhereInput>>;
  OR?: InputMaybe<Array<CirclesScalarWhereInput>>;
  closed?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  descriptionMd?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  expire?: InputMaybe<DateTimeNullableFilter>;
  goal?: InputMaybe<StringFilter>;
  id?: InputMaybe<BigIntFilter>;
  postFacebook?: InputMaybe<BoolFilter>;
  postInstagram?: InputMaybe<BoolFilter>;
  postTwitter?: InputMaybe<BoolFilter>;
  published?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CirclesSumAggregate = {
  __typename?: 'CirclesSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CirclesUpdateInput = {
  circleGenres?: InputMaybe<CircleGenresUpdateManyWithoutCircleNestedInput>;
  circleSkills?: InputMaybe<CircleSkillsUpdateManyWithoutCircleNestedInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expire?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  goal?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productions?: InputMaybe<ProductionsUpdateManyWithoutCircleNestedInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UsersUpdateOneRequiredWithoutCirclesNestedInput>;
};

export type CirclesUpdateManyMutationInput = {
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expire?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  goal?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CirclesUpdateManyWithWhereWithoutUserInput = {
  data: CirclesUpdateManyMutationInput;
  where: CirclesScalarWhereInput;
};

export type CirclesUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CirclesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CirclesCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CirclesCreateWithoutUserInput>>;
  createMany?: InputMaybe<CirclesCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CirclesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CirclesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CirclesWhereUniqueInput>>;
  set?: InputMaybe<Array<CirclesWhereUniqueInput>>;
  update?: InputMaybe<Array<CirclesUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CirclesUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CirclesUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CirclesUpdateOneWithoutProductionsNestedInput = {
  connect?: InputMaybe<CirclesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CirclesCreateOrConnectWithoutProductionsInput>;
  create?: InputMaybe<CirclesCreateWithoutProductionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CirclesUpdateWithoutProductionsInput>;
  upsert?: InputMaybe<CirclesUpsertWithoutProductionsInput>;
};

export type CirclesUpdateWithWhereUniqueWithoutUserInput = {
  data: CirclesUpdateWithoutUserInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesUpdateWithoutProductionsInput = {
  circleGenres?: InputMaybe<CircleGenresUpdateManyWithoutCircleNestedInput>;
  circleSkills?: InputMaybe<CircleSkillsUpdateManyWithoutCircleNestedInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expire?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  goal?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UsersUpdateOneRequiredWithoutCirclesNestedInput>;
};

export type CirclesUpdateWithoutUserInput = {
  circleGenres?: InputMaybe<CircleGenresUpdateManyWithoutCircleNestedInput>;
  circleSkills?: InputMaybe<CircleSkillsUpdateManyWithoutCircleNestedInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expire?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  goal?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productions?: InputMaybe<ProductionsUpdateManyWithoutCircleNestedInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CirclesUpsertWithWhereUniqueWithoutUserInput = {
  create: CirclesCreateWithoutUserInput;
  update: CirclesUpdateWithoutUserInput;
  where: CirclesWhereUniqueInput;
};

export type CirclesUpsertWithoutProductionsInput = {
  create: CirclesCreateWithoutProductionsInput;
  update: CirclesUpdateWithoutProductionsInput;
};

export type CirclesWhereInput = {
  AND?: InputMaybe<Array<CirclesWhereInput>>;
  NOT?: InputMaybe<Array<CirclesWhereInput>>;
  OR?: InputMaybe<Array<CirclesWhereInput>>;
  appliers?: InputMaybe<ApplyCirclesListRelationFilter>;
  circleComments?: InputMaybe<CircleCommentsListRelationFilter>;
  circleGenres?: InputMaybe<CircleGenresListRelationFilter>;
  circleSkills?: InputMaybe<CircleSkillsListRelationFilter>;
  closed?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  descriptionMd?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  expire?: InputMaybe<DateTimeNullableFilter>;
  goal?: InputMaybe<StringFilter>;
  id?: InputMaybe<BigIntFilter>;
  members?: InputMaybe<CircleMembersListRelationFilter>;
  postFacebook?: InputMaybe<BoolFilter>;
  postInstagram?: InputMaybe<BoolFilter>;
  postTwitter?: InputMaybe<BoolFilter>;
  productions?: InputMaybe<ProductionsListRelationFilter>;
  published?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type CirclesWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * 広告
 */
export type Commercials = {
  __typename?: 'Commercials';
  bannerUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disabled?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  linkUrl: Scalars['String'];
  published: Scalars['DateTime'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommercialsAvgAggregate = {
  __typename?: 'CommercialsAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type CommercialsCountAggregate = {
  __typename?: 'CommercialsCountAggregate';
  _all: Scalars['Int'];
  bannerUrl: Scalars['Int'];
  createdAt: Scalars['Int'];
  disabled: Scalars['Int'];
  id: Scalars['Int'];
  linkUrl: Scalars['Int'];
  published: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CommercialsCreateInput = {
  bannerUrl?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  linkUrl: Scalars['String'];
  published: Scalars['DateTime'];
  title: Scalars['String'];
};

export type CommercialsMaxAggregate = {
  __typename?: 'CommercialsMaxAggregate';
  bannerUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disabled?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  linkUrl?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommercialsMinAggregate = {
  __typename?: 'CommercialsMinAggregate';
  bannerUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  disabled?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  linkUrl?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommercialsOrderByWithRelationInput = {
  bannerUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkUrl?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum CommercialsScalarFieldEnum {
  BannerUrl = 'bannerUrl',
  CreatedAt = 'createdAt',
  Disabled = 'disabled',
  Id = 'id',
  LinkUrl = 'linkUrl',
  Published = 'published',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type CommercialsSumAggregate = {
  __typename?: 'CommercialsSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
};

export type CommercialsUpdateInput = {
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  linkUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  published?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CommercialsWhereInput = {
  AND?: InputMaybe<Array<CommercialsWhereInput>>;
  NOT?: InputMaybe<Array<CommercialsWhereInput>>;
  OR?: InputMaybe<Array<CommercialsWhereInput>>;
  bannerUrl?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  linkUrl?: InputMaybe<StringFilter>;
  published?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CommercialsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

/**
 *
 * 編集者からのおすすめ
 */
export type EditorRecommendations = {
  __typename?: 'EditorRecommendations';
  /** おすすめ文章 */
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  id: Scalars['BigInt'];
  productionId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EditorRecommendationsListRelationFilter = {
  every?: InputMaybe<EditorRecommendationsWhereInput>;
  none?: InputMaybe<EditorRecommendationsWhereInput>;
  some?: InputMaybe<EditorRecommendationsWhereInput>;
};

export type EditorRecommendationsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EditorRecommendationsOrderByWithRelationInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayOrder?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum EditorRecommendationsScalarFieldEnum {
  Body = 'body',
  CreatedAt = 'createdAt',
  DisplayOrder = 'displayOrder',
  Id = 'id',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt'
}

export type EditorRecommendationsWhereInput = {
  AND?: InputMaybe<Array<EditorRecommendationsWhereInput>>;
  NOT?: InputMaybe<Array<EditorRecommendationsWhereInput>>;
  OR?: InputMaybe<Array<EditorRecommendationsWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayOrder?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type EditorRecommendationsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * メールアドレス変更
 */
export type EmailResets = {
  __typename?: 'EmailResets';
  cognitoAccessToken: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  newEmail: Scalars['String'];
  oldEmail: Scalars['String'];
  token: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['BigInt'];
};

export type EmailResetsCreateManyUserInput = {
  cognitoAccessToken: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  newEmail: Scalars['String'];
  oldEmail: Scalars['String'];
  token: Scalars['String'];
};

export type EmailResetsCreateManyUserInputEnvelope = {
  data: Array<EmailResetsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EmailResetsCreateOrConnectWithoutUserInput = {
  create: EmailResetsCreateWithoutUserInput;
  where: EmailResetsWhereUniqueInput;
};

export type EmailResetsCreateWithoutUserInput = {
  cognitoAccessToken: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  newEmail: Scalars['String'];
  oldEmail: Scalars['String'];
  token: Scalars['String'];
};

export type EmailResetsListRelationFilter = {
  every?: InputMaybe<EmailResetsWhereInput>;
  none?: InputMaybe<EmailResetsWhereInput>;
  some?: InputMaybe<EmailResetsWhereInput>;
};

export type EmailResetsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EmailResetsOrderByWithRelationInput = {
  cognitoAccessToken?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newEmail?: InputMaybe<SortOrder>;
  oldEmail?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum EmailResetsScalarFieldEnum {
  CognitoAccessToken = 'cognitoAccessToken',
  CreatedAt = 'createdAt',
  Id = 'id',
  NewEmail = 'newEmail',
  OldEmail = 'oldEmail',
  Token = 'token',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type EmailResetsScalarWhereInput = {
  AND?: InputMaybe<Array<EmailResetsScalarWhereInput>>;
  NOT?: InputMaybe<Array<EmailResetsScalarWhereInput>>;
  OR?: InputMaybe<Array<EmailResetsScalarWhereInput>>;
  cognitoAccessToken?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  newEmail?: InputMaybe<StringFilter>;
  oldEmail?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type EmailResetsUpdateManyMutationInput = {
  cognitoAccessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  newEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EmailResetsUpdateManyWithWhereWithoutUserInput = {
  data: EmailResetsUpdateManyMutationInput;
  where: EmailResetsScalarWhereInput;
};

export type EmailResetsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<EmailResetsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailResetsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<EmailResetsCreateWithoutUserInput>>;
  createMany?: InputMaybe<EmailResetsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<EmailResetsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailResetsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailResetsWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailResetsWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailResetsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<EmailResetsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<EmailResetsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type EmailResetsUpdateWithWhereUniqueWithoutUserInput = {
  data: EmailResetsUpdateWithoutUserInput;
  where: EmailResetsWhereUniqueInput;
};

export type EmailResetsUpdateWithoutUserInput = {
  cognitoAccessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  newEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EmailResetsUpsertWithWhereUniqueWithoutUserInput = {
  create: EmailResetsCreateWithoutUserInput;
  update: EmailResetsUpdateWithoutUserInput;
  where: EmailResetsWhereUniqueInput;
};

export type EmailResetsWhereInput = {
  AND?: InputMaybe<Array<EmailResetsWhereInput>>;
  NOT?: InputMaybe<Array<EmailResetsWhereInput>>;
  OR?: InputMaybe<Array<EmailResetsWhereInput>>;
  cognitoAccessToken?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  newEmail?: InputMaybe<StringFilter>;
  oldEmail?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type EmailResetsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * お気に入り作品(Bookmark)
 */
export type FavoriteProductions = {
  __typename?: 'FavoriteProductions';
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  production: Productions;
  productionId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
};

export type FavoriteProductionsAvgAggregate = {
  __typename?: 'FavoriteProductionsAvgAggregate';
  id?: Maybe<Scalars['Float']>;
  productionId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type FavoriteProductionsCountAggregate = {
  __typename?: 'FavoriteProductionsCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  productionId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type FavoriteProductionsCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutFavoriteProductionsInput;
  user: UsersCreateNestedOneWithoutFavoriteProductionsInput;
};

export type FavoriteProductionsCreateManyUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  productionId: Scalars['BigInt'];
};

export type FavoriteProductionsCreateManyUserInputEnvelope = {
  data: Array<FavoriteProductionsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FavoriteProductionsCreateOrConnectWithoutUserInput = {
  create: FavoriteProductionsCreateWithoutUserInput;
  where: FavoriteProductionsWhereUniqueInput;
};

export type FavoriteProductionsCreateWithoutUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutFavoriteProductionsInput;
};

export type FavoriteProductionsListRelationFilter = {
  every?: InputMaybe<FavoriteProductionsWhereInput>;
  none?: InputMaybe<FavoriteProductionsWhereInput>;
  some?: InputMaybe<FavoriteProductionsWhereInput>;
};

export type FavoriteProductionsMaxAggregate = {
  __typename?: 'FavoriteProductionsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type FavoriteProductionsMinAggregate = {
  __typename?: 'FavoriteProductionsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type FavoriteProductionsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FavoriteProductionsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type FavoriteProductionsProductionIdUserIdCompoundUniqueInput = {
  productionId: Scalars['BigInt'];
  userId: Scalars['BigInt'];
};

export enum FavoriteProductionsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type FavoriteProductionsScalarWhereInput = {
  AND?: InputMaybe<Array<FavoriteProductionsScalarWhereInput>>;
  NOT?: InputMaybe<Array<FavoriteProductionsScalarWhereInput>>;
  OR?: InputMaybe<Array<FavoriteProductionsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type FavoriteProductionsSumAggregate = {
  __typename?: 'FavoriteProductionsSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type FavoriteProductionsUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type FavoriteProductionsUpdateManyWithWhereWithoutUserInput = {
  data: FavoriteProductionsUpdateManyMutationInput;
  where: FavoriteProductionsScalarWhereInput;
};

export type FavoriteProductionsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<FavoriteProductionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoriteProductionsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<FavoriteProductionsCreateWithoutUserInput>>;
  createMany?: InputMaybe<FavoriteProductionsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<FavoriteProductionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FavoriteProductionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FavoriteProductionsWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoriteProductionsWhereUniqueInput>>;
  update?: InputMaybe<Array<FavoriteProductionsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<FavoriteProductionsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<FavoriteProductionsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type FavoriteProductionsUpdateWithWhereUniqueWithoutUserInput = {
  data: FavoriteProductionsUpdateWithoutUserInput;
  where: FavoriteProductionsWhereUniqueInput;
};

export type FavoriteProductionsUpdateWithoutUserInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type FavoriteProductionsUpsertWithWhereUniqueWithoutUserInput = {
  create: FavoriteProductionsCreateWithoutUserInput;
  update: FavoriteProductionsUpdateWithoutUserInput;
  where: FavoriteProductionsWhereUniqueInput;
};

export type FavoriteProductionsWhereInput = {
  AND?: InputMaybe<Array<FavoriteProductionsWhereInput>>;
  NOT?: InputMaybe<Array<FavoriteProductionsWhereInput>>;
  OR?: InputMaybe<Array<FavoriteProductionsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type FavoriteProductionsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  productionId_userId?: InputMaybe<FavoriteProductionsProductionIdUserIdCompoundUniqueInput>;
};

/**
 *
 * 作品形式マスタ
 */
export type Forms = {
  __typename?: 'Forms';
  _count?: Maybe<FormsCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  productions: Array<Productions>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/**
 *
 * 作品形式マスタ
 */
export type FormsProductionsArgs = {
  cursor?: InputMaybe<ProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionsWhereInput>;
};

export type FormsCount = {
  __typename?: 'FormsCount';
  productions: Scalars['Int'];
};

export type FormsCreateNestedOneWithoutProductionsInput = {
  connect?: InputMaybe<FormsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormsCreateOrConnectWithoutProductionsInput>;
  create?: InputMaybe<FormsCreateWithoutProductionsInput>;
};

export type FormsCreateOrConnectWithoutProductionsInput = {
  create: FormsCreateWithoutProductionsInput;
  where: FormsWhereUniqueInput;
};

export type FormsCreateWithoutProductionsInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FormsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productions?: InputMaybe<ProductionsOrderByRelationAggregateInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FormsRelationFilter = {
  is?: InputMaybe<FormsWhereInput>;
  isNot?: InputMaybe<FormsWhereInput>;
};

export enum FormsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type FormsUpdateOneRequiredWithoutProductionsNestedInput = {
  connect?: InputMaybe<FormsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormsCreateOrConnectWithoutProductionsInput>;
  create?: InputMaybe<FormsCreateWithoutProductionsInput>;
  update?: InputMaybe<FormsUpdateWithoutProductionsInput>;
  upsert?: InputMaybe<FormsUpsertWithoutProductionsInput>;
};

export type FormsUpdateWithoutProductionsInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormsUpsertWithoutProductionsInput = {
  create: FormsCreateWithoutProductionsInput;
  update: FormsUpdateWithoutProductionsInput;
};

export type FormsWhereInput = {
  AND?: InputMaybe<Array<FormsWhereInput>>;
  NOT?: InputMaybe<Array<FormsWhereInput>>;
  OR?: InputMaybe<Array<FormsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  productions?: InputMaybe<ProductionsListRelationFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FormsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

/**
 *
 * ジャンルマスタ
 */
export type Genres = {
  __typename?: 'Genres';
  _count?: Maybe<GenresCount>;
  /** このジャンルに属しているサークル */
  circleGenres: Array<CircleGenres>;
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  /** ジャンル名 */
  name: Scalars['String'];
  /** このジャンルに属している投稿作品 */
  productionGenres: Array<ProductionGenres>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/**
 *
 * ジャンルマスタ
 */
export type GenresCircleGenresArgs = {
  cursor?: InputMaybe<CircleGenresWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleGenresScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleGenresWhereInput>;
};


/**
 *
 * ジャンルマスタ
 */
export type GenresProductionGenresArgs = {
  cursor?: InputMaybe<ProductionGenresWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionGenresScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionGenresWhereInput>;
};

export type GenresAvgAggregate = {
  __typename?: 'GenresAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type GenresCount = {
  __typename?: 'GenresCount';
  circleGenres: Scalars['Int'];
  productionGenres: Scalars['Int'];
};

export type GenresCountAggregate = {
  __typename?: 'GenresCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type GenresCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
};

export type GenresCreateNestedOneWithoutCircleGenresInput = {
  connect?: InputMaybe<GenresWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GenresCreateOrConnectWithoutCircleGenresInput>;
  create?: InputMaybe<GenresCreateWithoutCircleGenresInput>;
};

export type GenresCreateNestedOneWithoutProductionGenresInput = {
  connect?: InputMaybe<GenresWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GenresCreateOrConnectWithoutProductionGenresInput>;
  create?: InputMaybe<GenresCreateWithoutProductionGenresInput>;
};

export type GenresCreateOrConnectWithoutCircleGenresInput = {
  create: GenresCreateWithoutCircleGenresInput;
  where: GenresWhereUniqueInput;
};

export type GenresCreateOrConnectWithoutProductionGenresInput = {
  create: GenresCreateWithoutProductionGenresInput;
  where: GenresWhereUniqueInput;
};

export type GenresCreateWithoutCircleGenresInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
};

export type GenresCreateWithoutProductionGenresInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
};

export type GenresMaxAggregate = {
  __typename?: 'GenresMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GenresMinAggregate = {
  __typename?: 'GenresMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GenresOrderByWithRelationInput = {
  circleGenres?: InputMaybe<CircleGenresOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productionGenres?: InputMaybe<ProductionGenresOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type GenresRelationFilter = {
  is?: InputMaybe<GenresWhereInput>;
  isNot?: InputMaybe<GenresWhereInput>;
};

export enum GenresScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type GenresSumAggregate = {
  __typename?: 'GenresSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
};

export type GenresUpdateInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GenresWhereInput = {
  AND?: InputMaybe<Array<GenresWhereInput>>;
  NOT?: InputMaybe<Array<GenresWhereInput>>;
  OR?: InputMaybe<Array<GenresWhereInput>>;
  circleGenres?: InputMaybe<CircleGenresListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  productionGenres?: InputMaybe<ProductionGenresListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type GenresWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

/**
 *
 * いいね
 */
export type GoodProductions = {
  __typename?: 'GoodProductions';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  /** 対象作品 */
  production: Productions;
  productionId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** 自分自身 */
  user: Users;
  userId: Scalars['BigInt'];
};

export type GoodProductionsAvgAggregate = {
  __typename?: 'GoodProductionsAvgAggregate';
  id?: Maybe<Scalars['Float']>;
  productionId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type GoodProductionsCountAggregate = {
  __typename?: 'GoodProductionsCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  productionId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type GoodProductionsCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutGoodProductionsInput;
  user: UsersCreateNestedOneWithoutGoodProductionsInput;
};

export type GoodProductionsCreateManyUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  productionId: Scalars['BigInt'];
};

export type GoodProductionsCreateManyUserInputEnvelope = {
  data: Array<GoodProductionsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type GoodProductionsCreateOrConnectWithoutUserInput = {
  create: GoodProductionsCreateWithoutUserInput;
  where: GoodProductionsWhereUniqueInput;
};

export type GoodProductionsCreateWithoutUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutGoodProductionsInput;
};

export type GoodProductionsListRelationFilter = {
  every?: InputMaybe<GoodProductionsWhereInput>;
  none?: InputMaybe<GoodProductionsWhereInput>;
  some?: InputMaybe<GoodProductionsWhereInput>;
};

export type GoodProductionsMaxAggregate = {
  __typename?: 'GoodProductionsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type GoodProductionsMinAggregate = {
  __typename?: 'GoodProductionsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type GoodProductionsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GoodProductionsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum GoodProductionsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type GoodProductionsScalarWhereInput = {
  AND?: InputMaybe<Array<GoodProductionsScalarWhereInput>>;
  NOT?: InputMaybe<Array<GoodProductionsScalarWhereInput>>;
  OR?: InputMaybe<Array<GoodProductionsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type GoodProductionsSumAggregate = {
  __typename?: 'GoodProductionsSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type GoodProductionsUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type GoodProductionsUpdateManyWithWhereWithoutUserInput = {
  data: GoodProductionsUpdateManyMutationInput;
  where: GoodProductionsScalarWhereInput;
};

export type GoodProductionsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<GoodProductionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GoodProductionsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<GoodProductionsCreateWithoutUserInput>>;
  createMany?: InputMaybe<GoodProductionsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<GoodProductionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GoodProductionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GoodProductionsWhereUniqueInput>>;
  set?: InputMaybe<Array<GoodProductionsWhereUniqueInput>>;
  update?: InputMaybe<Array<GoodProductionsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<GoodProductionsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<GoodProductionsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type GoodProductionsUpdateWithWhereUniqueWithoutUserInput = {
  data: GoodProductionsUpdateWithoutUserInput;
  where: GoodProductionsWhereUniqueInput;
};

export type GoodProductionsUpdateWithoutUserInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  production?: InputMaybe<ProductionsUpdateOneRequiredWithoutGoodProductionsNestedInput>;
};

export type GoodProductionsUpsertWithWhereUniqueWithoutUserInput = {
  create: GoodProductionsCreateWithoutUserInput;
  update: GoodProductionsUpdateWithoutUserInput;
  where: GoodProductionsWhereUniqueInput;
};

export type GoodProductionsUserIdProductionIdCompoundUniqueInput = {
  productionId: Scalars['BigInt'];
  userId: Scalars['BigInt'];
};

export type GoodProductionsWhereInput = {
  AND?: InputMaybe<Array<GoodProductionsWhereInput>>;
  NOT?: InputMaybe<Array<GoodProductionsWhereInput>>;
  OR?: InputMaybe<Array<GoodProductionsWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type GoodProductionsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  userId_productionId?: InputMaybe<GoodProductionsUserIdProductionIdCompoundUniqueInput>;
};

/**
 *
 * お問い合わせ
 */
export type Inquiries = {
  __typename?: 'Inquiries';
  _count?: Maybe<InquiriesCount>;
  createdAt: Scalars['DateTime'];
  /** お問い合わせ内容 */
  description: Scalars['String'];
  /** 連絡先メールアドレス */
  email: Scalars['String'];
  id: Scalars['BigInt'];
  /** タイトル */
  name: Scalars['String'];
  /** 連絡先電話番号 */
  phone: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InquiriesCount = {
  __typename?: 'InquiriesCount';
  reports: Scalars['Int'];
};

export type InquiriesCreateInput = {
  description: Scalars['String'];
  email: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  reports?: InputMaybe<ReportsCreateNestedManyWithoutInquiryInput>;
};

export type InquiriesCreateNestedOneWithoutReportsInput = {
  connect?: InputMaybe<InquiriesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InquiriesCreateOrConnectWithoutReportsInput>;
  create?: InputMaybe<InquiriesCreateWithoutReportsInput>;
};

export type InquiriesCreateOrConnectWithoutReportsInput = {
  create: InquiriesCreateWithoutReportsInput;
  where: InquiriesWhereUniqueInput;
};

export type InquiriesCreateWithoutReportsInput = {
  description: Scalars['String'];
  email: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type InquiriesOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  reports?: InputMaybe<ReportsOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type InquiriesRelationFilter = {
  is?: InputMaybe<InquiriesWhereInput>;
  isNot?: InputMaybe<InquiriesWhereInput>;
};

export enum InquiriesScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Email = 'email',
  Id = 'id',
  Name = 'name',
  Phone = 'phone',
  UpdatedAt = 'updatedAt'
}

export type InquiriesWhereInput = {
  AND?: InputMaybe<Array<InquiriesWhereInput>>;
  NOT?: InputMaybe<Array<InquiriesWhereInput>>;
  OR?: InputMaybe<Array<InquiriesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  reports?: InputMaybe<ReportsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InquiriesWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/**
 *
 * 新着作品
 */
export type LatestProductions = {
  __typename?: 'LatestProductions';
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  /** 対象作品 */
  production: Productions;
  productionId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LatestProductionsAvgAggregate = {
  __typename?: 'LatestProductionsAvgAggregate';
  id?: Maybe<Scalars['Float']>;
  productionId?: Maybe<Scalars['Float']>;
};

export type LatestProductionsCountAggregate = {
  __typename?: 'LatestProductionsCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  productionId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LatestProductionsCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutNewProductionsInput;
};

export type LatestProductionsListRelationFilter = {
  every?: InputMaybe<LatestProductionsWhereInput>;
  none?: InputMaybe<LatestProductionsWhereInput>;
  some?: InputMaybe<LatestProductionsWhereInput>;
};

export type LatestProductionsMaxAggregate = {
  __typename?: 'LatestProductionsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LatestProductionsMinAggregate = {
  __typename?: 'LatestProductionsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LatestProductionsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LatestProductionsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum LatestProductionsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt'
}

export type LatestProductionsSumAggregate = {
  __typename?: 'LatestProductionsSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
};

export type LatestProductionsWhereInput = {
  AND?: InputMaybe<Array<LatestProductionsWhereInput>>;
  NOT?: InputMaybe<Array<LatestProductionsWhereInput>>;
  OR?: InputMaybe<Array<LatestProductionsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type LatestProductionsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createManyUserSkills: AffectedRowsOutput;
  createOneApplyCircles: ApplyCircles;
  createOneCircleComments: CircleComments;
  createOneCircleGenres: CircleGenres;
  createOneCircleMembers: CircleMembers;
  createOneCircleSkills: CircleSkills;
  createOneCircles: Circles;
  createOneCommercials: Commercials;
  createOneFavoriteProductions: FavoriteProductions;
  createOneGenres: Genres;
  createOneGoodProductions: GoodProductions;
  createOneInquiries: Inquiries;
  createOneLatestProductions: LatestProductions;
  createOneNotices: Notices;
  createOnePopularProductions: PopularProductions;
  createOneProductionComments: ProductionComments;
  createOneProductionGenres: ProductionGenres;
  createOneProductionSeries: ProductionSeries;
  createOneProductionTags: ProductionTags;
  createOneProductions: Productions;
  createOneReports: Reports;
  createOneSeries: Series;
  createOneTags: Tags;
  deleteOneApplyCircles?: Maybe<ApplyCircles>;
  deleteOneCircleComments?: Maybe<CircleComments>;
  deleteOneCircleGenres?: Maybe<CircleGenres>;
  deleteOneCircleMembers?: Maybe<CircleMembers>;
  deleteOneCircleSkills?: Maybe<CircleSkills>;
  deleteOneCircles?: Maybe<Circles>;
  deleteOneCommercials?: Maybe<Commercials>;
  deleteOneFavoriteProductions?: Maybe<FavoriteProductions>;
  deleteOneGenres?: Maybe<Genres>;
  deleteOneGoodProductions?: Maybe<GoodProductions>;
  deleteOneLatestProductions?: Maybe<LatestProductions>;
  deleteOneNotices?: Maybe<Notices>;
  deleteOnePopularProductions?: Maybe<PopularProductions>;
  deleteOneProductionGenres?: Maybe<ProductionGenres>;
  deleteOneProductionSeries?: Maybe<ProductionSeries>;
  deleteOneProductionTags?: Maybe<ProductionTags>;
  deleteOneProductions?: Maybe<Productions>;
  deleteOneSeries?: Maybe<Series>;
  incrementViewCount?: Maybe<Scalars['Float']>;
  updateManyUserSkills: AffectedRowsOutput;
  updateOneCircles?: Maybe<Circles>;
  updateOneCommercials?: Maybe<Commercials>;
  updateOneGenres?: Maybe<Genres>;
  updateOneNotices?: Maybe<Notices>;
  updateOneProductions?: Maybe<Productions>;
  updateOneSeries?: Maybe<Series>;
  updateOneUsers?: Maybe<Users>;
};


export type MutationCreateManyUserSkillsArgs = {
  data: Array<UserSkillsCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateOneApplyCirclesArgs = {
  data: ApplyCirclesCreateInput;
};


export type MutationCreateOneCircleCommentsArgs = {
  data: CircleCommentsCreateInput;
};


export type MutationCreateOneCircleGenresArgs = {
  data: CircleGenresCreateInput;
};


export type MutationCreateOneCircleMembersArgs = {
  data: CircleMembersCreateInput;
};


export type MutationCreateOneCircleSkillsArgs = {
  data: CircleSkillsCreateInput;
};


export type MutationCreateOneCirclesArgs = {
  data: CirclesCreateInput;
};


export type MutationCreateOneCommercialsArgs = {
  data: CommercialsCreateInput;
};


export type MutationCreateOneFavoriteProductionsArgs = {
  data: FavoriteProductionsCreateInput;
};


export type MutationCreateOneGenresArgs = {
  data: GenresCreateInput;
};


export type MutationCreateOneGoodProductionsArgs = {
  data: GoodProductionsCreateInput;
};


export type MutationCreateOneInquiriesArgs = {
  data: InquiriesCreateInput;
};


export type MutationCreateOneLatestProductionsArgs = {
  data: LatestProductionsCreateInput;
};


export type MutationCreateOneNoticesArgs = {
  data: NoticesCreateInput;
};


export type MutationCreateOnePopularProductionsArgs = {
  data: PopularProductionsCreateInput;
};


export type MutationCreateOneProductionCommentsArgs = {
  data: ProductionCommentsCreateInput;
};


export type MutationCreateOneProductionGenresArgs = {
  data: ProductionGenresCreateInput;
};


export type MutationCreateOneProductionSeriesArgs = {
  data: ProductionSeriesCreateInput;
};


export type MutationCreateOneProductionTagsArgs = {
  data: ProductionTagsCreateInput;
};


export type MutationCreateOneProductionsArgs = {
  data: ProductionsCreateInput;
};


export type MutationCreateOneReportsArgs = {
  data: ReportsCreateInput;
};


export type MutationCreateOneSeriesArgs = {
  data: SeriesCreateInput;
};


export type MutationCreateOneTagsArgs = {
  data: TagsCreateInput;
};


export type MutationDeleteOneApplyCirclesArgs = {
  where: ApplyCirclesWhereUniqueInput;
};


export type MutationDeleteOneCircleCommentsArgs = {
  where: CircleCommentsWhereUniqueInput;
};


export type MutationDeleteOneCircleGenresArgs = {
  where: CircleGenresWhereUniqueInput;
};


export type MutationDeleteOneCircleMembersArgs = {
  where: CircleMembersWhereUniqueInput;
};


export type MutationDeleteOneCircleSkillsArgs = {
  where: CircleSkillsWhereUniqueInput;
};


export type MutationDeleteOneCirclesArgs = {
  where: CirclesWhereUniqueInput;
};


export type MutationDeleteOneCommercialsArgs = {
  where: CommercialsWhereUniqueInput;
};


export type MutationDeleteOneFavoriteProductionsArgs = {
  where: FavoriteProductionsWhereUniqueInput;
};


export type MutationDeleteOneGenresArgs = {
  where: GenresWhereUniqueInput;
};


export type MutationDeleteOneGoodProductionsArgs = {
  where: GoodProductionsWhereUniqueInput;
};


export type MutationDeleteOneLatestProductionsArgs = {
  where: LatestProductionsWhereUniqueInput;
};


export type MutationDeleteOneNoticesArgs = {
  where: NoticesWhereUniqueInput;
};


export type MutationDeleteOnePopularProductionsArgs = {
  where: PopularProductionsWhereUniqueInput;
};


export type MutationDeleteOneProductionGenresArgs = {
  where: ProductionGenresWhereUniqueInput;
};


export type MutationDeleteOneProductionSeriesArgs = {
  where: ProductionSeriesWhereUniqueInput;
};


export type MutationDeleteOneProductionTagsArgs = {
  where: ProductionTagsWhereUniqueInput;
};


export type MutationDeleteOneProductionsArgs = {
  where: ProductionsWhereUniqueInput;
};


export type MutationDeleteOneSeriesArgs = {
  where: SeriesWhereUniqueInput;
};


export type MutationIncrementViewCountArgs = {
  productionId: Scalars['Float'];
};


export type MutationUpdateManyUserSkillsArgs = {
  data: UserSkillsUpdateManyMutationInput;
  where?: InputMaybe<UserSkillsWhereInput>;
};


export type MutationUpdateOneCirclesArgs = {
  data: CirclesUpdateInput;
  where: CirclesWhereUniqueInput;
};


export type MutationUpdateOneCommercialsArgs = {
  data: CommercialsUpdateInput;
  where: CommercialsWhereUniqueInput;
};


export type MutationUpdateOneGenresArgs = {
  data: GenresUpdateInput;
  where: GenresWhereUniqueInput;
};


export type MutationUpdateOneNoticesArgs = {
  data: NoticesUpdateInput;
  where: NoticesWhereUniqueInput;
};


export type MutationUpdateOneProductionsArgs = {
  data: ProductionsUpdateInput;
  where: ProductionsWhereUniqueInput;
};


export type MutationUpdateOneSeriesArgs = {
  data: SeriesUpdateInput;
  where: SeriesWhereUniqueInput;
};


export type MutationUpdateOneUsersArgs = {
  data: UsersUpdateInput;
  where: UsersWhereUniqueInput;
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type NestedBigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

/**
 *
 * お知らせ
 */
export type Notices = {
  __typename?: 'Notices';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  imageUrl?: Maybe<Scalars['String']>;
  publish: Scalars['DateTime'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NoticesAvgAggregate = {
  __typename?: 'NoticesAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type NoticesCountAggregate = {
  __typename?: 'NoticesCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  descriptionMd: Scalars['Int'];
  disabled: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  publish: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type NoticesCreateInput = {
  description: Scalars['String'];
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  publish: Scalars['DateTime'];
  title: Scalars['String'];
};

export type NoticesMaxAggregate = {
  __typename?: 'NoticesMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  publish?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NoticesMinAggregate = {
  __typename?: 'NoticesMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  publish?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NoticesOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionMd?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  publish?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum NoticesScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  DescriptionMd = 'descriptionMd',
  Disabled = 'disabled',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Publish = 'publish',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type NoticesSumAggregate = {
  __typename?: 'NoticesSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
};

export type NoticesUpdateInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publish?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NoticesWhereInput = {
  AND?: InputMaybe<Array<NoticesWhereInput>>;
  NOT?: InputMaybe<Array<NoticesWhereInput>>;
  OR?: InputMaybe<Array<NoticesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  descriptionMd?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  publish?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type NoticesWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

/**
 *
 * 人気作品
 */
export type PopularProductions = {
  __typename?: 'PopularProductions';
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  id: Scalars['BigInt'];
  production: Productions;
  productionId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PopularProductionsAvgAggregate = {
  __typename?: 'PopularProductionsAvgAggregate';
  displayOrder?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  productionId?: Maybe<Scalars['Float']>;
};

export type PopularProductionsCountAggregate = {
  __typename?: 'PopularProductionsCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
  productionId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PopularProductionsCreateInput = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutPopularProductionsInput;
};

export type PopularProductionsListRelationFilter = {
  every?: InputMaybe<PopularProductionsWhereInput>;
  none?: InputMaybe<PopularProductionsWhereInput>;
  some?: InputMaybe<PopularProductionsWhereInput>;
};

export type PopularProductionsMaxAggregate = {
  __typename?: 'PopularProductionsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PopularProductionsMinAggregate = {
  __typename?: 'PopularProductionsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PopularProductionsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PopularProductionsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  displayOrder?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PopularProductionsScalarFieldEnum {
  CreatedAt = 'createdAt',
  DisplayOrder = 'displayOrder',
  Id = 'id',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt'
}

export type PopularProductionsSumAggregate = {
  __typename?: 'PopularProductionsSumAggregate';
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
};

export type PopularProductionsWhereInput = {
  AND?: InputMaybe<Array<PopularProductionsWhereInput>>;
  NOT?: InputMaybe<Array<PopularProductionsWhereInput>>;
  OR?: InputMaybe<Array<PopularProductionsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayOrder?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PopularProductionsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * 投稿作品に付けられたコメント
 */
export type ProductionComments = {
  __typename?: 'ProductionComments';
  /** コメント */
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 削除日 */
  disabled?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  production: Productions;
  productionId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
};

export type ProductionCommentsCreateInput = {
  comment: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutProductionCommentsInput;
  user: UsersCreateNestedOneWithoutProductionCommentsInput;
};

export type ProductionCommentsCreateManyUserInput = {
  comment: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  productionId: Scalars['BigInt'];
};

export type ProductionCommentsCreateManyUserInputEnvelope = {
  data: Array<ProductionCommentsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionCommentsCreateOrConnectWithoutUserInput = {
  create: ProductionCommentsCreateWithoutUserInput;
  where: ProductionCommentsWhereUniqueInput;
};

export type ProductionCommentsCreateWithoutUserInput = {
  comment: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutProductionCommentsInput;
};

export type ProductionCommentsListRelationFilter = {
  every?: InputMaybe<ProductionCommentsWhereInput>;
  none?: InputMaybe<ProductionCommentsWhereInput>;
  some?: InputMaybe<ProductionCommentsWhereInput>;
};

export type ProductionCommentsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductionCommentsOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum ProductionCommentsScalarFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  Disabled = 'disabled',
  Id = 'id',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ProductionCommentsScalarWhereInput = {
  AND?: InputMaybe<Array<ProductionCommentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductionCommentsScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductionCommentsScalarWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ProductionCommentsUpdateManyMutationInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionCommentsUpdateManyWithWhereWithoutUserInput = {
  data: ProductionCommentsUpdateManyMutationInput;
  where: ProductionCommentsScalarWhereInput;
};

export type ProductionCommentsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ProductionCommentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionCommentsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ProductionCommentsCreateWithoutUserInput>>;
  createMany?: InputMaybe<ProductionCommentsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ProductionCommentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionCommentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionCommentsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionCommentsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionCommentsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ProductionCommentsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ProductionCommentsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ProductionCommentsUpdateWithWhereUniqueWithoutUserInput = {
  data: ProductionCommentsUpdateWithoutUserInput;
  where: ProductionCommentsWhereUniqueInput;
};

export type ProductionCommentsUpdateWithoutUserInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionCommentsUpsertWithWhereUniqueWithoutUserInput = {
  create: ProductionCommentsCreateWithoutUserInput;
  update: ProductionCommentsUpdateWithoutUserInput;
  where: ProductionCommentsWhereUniqueInput;
};

export type ProductionCommentsWhereInput = {
  AND?: InputMaybe<Array<ProductionCommentsWhereInput>>;
  NOT?: InputMaybe<Array<ProductionCommentsWhereInput>>;
  OR?: InputMaybe<Array<ProductionCommentsWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ProductionCommentsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * その投稿作品のジャンル
 */
export type ProductionGenres = {
  __typename?: 'ProductionGenres';
  createdAt: Scalars['DateTime'];
  genre: Genres;
  genreId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  production: Productions;
  productionId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionGenresAvgAggregate = {
  __typename?: 'ProductionGenresAvgAggregate';
  genreId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  productionId?: Maybe<Scalars['Float']>;
};

export type ProductionGenresCountAggregate = {
  __typename?: 'ProductionGenresCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  genreId: Scalars['Int'];
  id: Scalars['Int'];
  productionId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductionGenresCreateInput = {
  genre: GenresCreateNestedOneWithoutProductionGenresInput;
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutProductionGenresInput;
};

export type ProductionGenresCreateManyProductionInput = {
  genreId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ProductionGenresCreateManyProductionInputEnvelope = {
  data: Array<ProductionGenresCreateManyProductionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionGenresCreateNestedManyWithoutProductionInput = {
  connect?: InputMaybe<Array<ProductionGenresWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionGenresCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionGenresCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionGenresCreateManyProductionInputEnvelope>;
};

export type ProductionGenresCreateOrConnectWithoutProductionInput = {
  create: ProductionGenresCreateWithoutProductionInput;
  where: ProductionGenresWhereUniqueInput;
};

export type ProductionGenresCreateWithoutProductionInput = {
  genre: GenresCreateNestedOneWithoutProductionGenresInput;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ProductionGenresListRelationFilter = {
  every?: InputMaybe<ProductionGenresWhereInput>;
  none?: InputMaybe<ProductionGenresWhereInput>;
  some?: InputMaybe<ProductionGenresWhereInput>;
};

export type ProductionGenresMaxAggregate = {
  __typename?: 'ProductionGenresMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  genreId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionGenresMinAggregate = {
  __typename?: 'ProductionGenresMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  genreId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionGenresOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductionGenresOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  genre?: InputMaybe<GenresOrderByWithRelationInput>;
  genreId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductionGenresProductionIdGenreIdCompoundUniqueInput = {
  genreId: Scalars['BigInt'];
  productionId: Scalars['BigInt'];
};

export enum ProductionGenresScalarFieldEnum {
  CreatedAt = 'createdAt',
  GenreId = 'genreId',
  Id = 'id',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt'
}

export type ProductionGenresScalarWhereInput = {
  AND?: InputMaybe<Array<ProductionGenresScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductionGenresScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductionGenresScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  genreId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionGenresSumAggregate = {
  __typename?: 'ProductionGenresSumAggregate';
  genreId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
};

export type ProductionGenresUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionGenresUpdateManyWithWhereWithoutProductionInput = {
  data: ProductionGenresUpdateManyMutationInput;
  where: ProductionGenresScalarWhereInput;
};

export type ProductionGenresUpdateManyWithoutProductionNestedInput = {
  connect?: InputMaybe<Array<ProductionGenresWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionGenresCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionGenresCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionGenresCreateManyProductionInputEnvelope>;
  delete?: InputMaybe<Array<ProductionGenresWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionGenresScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionGenresWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionGenresWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionGenresUpdateWithWhereUniqueWithoutProductionInput>>;
  updateMany?: InputMaybe<Array<ProductionGenresUpdateManyWithWhereWithoutProductionInput>>;
  upsert?: InputMaybe<Array<ProductionGenresUpsertWithWhereUniqueWithoutProductionInput>>;
};

export type ProductionGenresUpdateWithWhereUniqueWithoutProductionInput = {
  data: ProductionGenresUpdateWithoutProductionInput;
  where: ProductionGenresWhereUniqueInput;
};

export type ProductionGenresUpdateWithoutProductionInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionGenresUpsertWithWhereUniqueWithoutProductionInput = {
  create: ProductionGenresCreateWithoutProductionInput;
  update: ProductionGenresUpdateWithoutProductionInput;
  where: ProductionGenresWhereUniqueInput;
};

export type ProductionGenresWhereInput = {
  AND?: InputMaybe<Array<ProductionGenresWhereInput>>;
  NOT?: InputMaybe<Array<ProductionGenresWhereInput>>;
  OR?: InputMaybe<Array<ProductionGenresWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  genre?: InputMaybe<GenresRelationFilter>;
  genreId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionGenresWhereUniqueInput = {
  productionId_genreId?: InputMaybe<ProductionGenresProductionIdGenreIdCompoundUniqueInput>;
};

/**
 *
 * 投稿作品の画像コンテンツ（マンガとか）
 */
export type ProductionImages = {
  __typename?: 'ProductionImages';
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  image: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  productionId: Scalars['BigInt'];
  thumbUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionImagesCreateManyProductionInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  image: Scalars['String'];
};

export type ProductionImagesCreateManyProductionInputEnvelope = {
  data: Array<ProductionImagesCreateManyProductionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionImagesCreateNestedManyWithoutProductionInput = {
  connect?: InputMaybe<Array<ProductionImagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionImagesCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionImagesCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionImagesCreateManyProductionInputEnvelope>;
};

export type ProductionImagesCreateOrConnectWithoutProductionInput = {
  create: ProductionImagesCreateWithoutProductionInput;
  where: ProductionImagesWhereUniqueInput;
};

export type ProductionImagesCreateWithoutProductionInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  image: Scalars['String'];
};

export type ProductionImagesListRelationFilter = {
  every?: InputMaybe<ProductionImagesWhereInput>;
  none?: InputMaybe<ProductionImagesWhereInput>;
  some?: InputMaybe<ProductionImagesWhereInput>;
};

export type ProductionImagesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductionImagesOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProductionImagesScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Image = 'image',
  ProductionId = 'productionId',
  UpdatedAt = 'updatedAt'
}

export type ProductionImagesScalarWhereInput = {
  AND?: InputMaybe<Array<ProductionImagesScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductionImagesScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductionImagesScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  image?: InputMaybe<StringFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionImagesUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductionImagesUpdateManyWithWhereWithoutProductionInput = {
  data: ProductionImagesUpdateManyMutationInput;
  where: ProductionImagesScalarWhereInput;
};

export type ProductionImagesUpdateManyWithoutProductionNestedInput = {
  connect?: InputMaybe<Array<ProductionImagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionImagesCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionImagesCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionImagesCreateManyProductionInputEnvelope>;
  delete?: InputMaybe<Array<ProductionImagesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionImagesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionImagesWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionImagesWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionImagesUpdateWithWhereUniqueWithoutProductionInput>>;
  updateMany?: InputMaybe<Array<ProductionImagesUpdateManyWithWhereWithoutProductionInput>>;
  upsert?: InputMaybe<Array<ProductionImagesUpsertWithWhereUniqueWithoutProductionInput>>;
};

export type ProductionImagesUpdateWithWhereUniqueWithoutProductionInput = {
  data: ProductionImagesUpdateWithoutProductionInput;
  where: ProductionImagesWhereUniqueInput;
};

export type ProductionImagesUpdateWithoutProductionInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductionImagesUpsertWithWhereUniqueWithoutProductionInput = {
  create: ProductionImagesCreateWithoutProductionInput;
  update: ProductionImagesUpdateWithoutProductionInput;
  where: ProductionImagesWhereUniqueInput;
};

export type ProductionImagesWhereInput = {
  AND?: InputMaybe<Array<ProductionImagesWhereInput>>;
  NOT?: InputMaybe<Array<ProductionImagesWhereInput>>;
  OR?: InputMaybe<Array<ProductionImagesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  image?: InputMaybe<StringFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionImagesWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ProductionSeries = {
  __typename?: 'ProductionSeries';
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  production: Productions;
  productionId: Scalars['BigInt'];
  series: Series;
  seriesId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionSeriesAvgAggregate = {
  __typename?: 'ProductionSeriesAvgAggregate';
  id?: Maybe<Scalars['Float']>;
  productionId?: Maybe<Scalars['Float']>;
  seriesId?: Maybe<Scalars['Float']>;
};

export type ProductionSeriesCountAggregate = {
  __typename?: 'ProductionSeriesCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  productionId: Scalars['Int'];
  seriesId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductionSeriesCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutProductionSeriesInput;
  series: SeriesCreateNestedOneWithoutProductionSeriesInput;
};

export type ProductionSeriesCreateManyProductionInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  seriesId: Scalars['BigInt'];
};

export type ProductionSeriesCreateManyProductionInputEnvelope = {
  data: Array<ProductionSeriesCreateManyProductionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionSeriesCreateManySeriesInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  productionId: Scalars['BigInt'];
};

export type ProductionSeriesCreateManySeriesInputEnvelope = {
  data: Array<ProductionSeriesCreateManySeriesInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionSeriesCreateNestedManyWithoutProductionInput = {
  connect?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionSeriesCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionSeriesCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionSeriesCreateManyProductionInputEnvelope>;
};

export type ProductionSeriesCreateNestedManyWithoutSeriesInput = {
  connect?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionSeriesCreateOrConnectWithoutSeriesInput>>;
  create?: InputMaybe<Array<ProductionSeriesCreateWithoutSeriesInput>>;
  createMany?: InputMaybe<ProductionSeriesCreateManySeriesInputEnvelope>;
};

export type ProductionSeriesCreateOrConnectWithoutProductionInput = {
  create: ProductionSeriesCreateWithoutProductionInput;
  where: ProductionSeriesWhereUniqueInput;
};

export type ProductionSeriesCreateOrConnectWithoutSeriesInput = {
  create: ProductionSeriesCreateWithoutSeriesInput;
  where: ProductionSeriesWhereUniqueInput;
};

export type ProductionSeriesCreateWithoutProductionInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  series: SeriesCreateNestedOneWithoutProductionSeriesInput;
};

export type ProductionSeriesCreateWithoutSeriesInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutProductionSeriesInput;
};

export type ProductionSeriesListRelationFilter = {
  every?: InputMaybe<ProductionSeriesWhereInput>;
  none?: InputMaybe<ProductionSeriesWhereInput>;
  some?: InputMaybe<ProductionSeriesWhereInput>;
};

export type ProductionSeriesMaxAggregate = {
  __typename?: 'ProductionSeriesMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  seriesId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionSeriesMinAggregate = {
  __typename?: 'ProductionSeriesMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  seriesId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionSeriesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductionSeriesOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  series?: InputMaybe<SeriesOrderByWithRelationInput>;
  seriesId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductionSeriesProductionIdSeriesIdCompoundUniqueInput = {
  productionId: Scalars['BigInt'];
  seriesId: Scalars['BigInt'];
};

export enum ProductionSeriesScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProductionId = 'productionId',
  SeriesId = 'seriesId',
  UpdatedAt = 'updatedAt'
}

export type ProductionSeriesScalarWhereInput = {
  AND?: InputMaybe<Array<ProductionSeriesScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductionSeriesScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductionSeriesScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  seriesId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionSeriesSumAggregate = {
  __typename?: 'ProductionSeriesSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  seriesId?: Maybe<Scalars['BigInt']>;
};

export type ProductionSeriesUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionSeriesUpdateManyWithWhereWithoutProductionInput = {
  data: ProductionSeriesUpdateManyMutationInput;
  where: ProductionSeriesScalarWhereInput;
};

export type ProductionSeriesUpdateManyWithWhereWithoutSeriesInput = {
  data: ProductionSeriesUpdateManyMutationInput;
  where: ProductionSeriesScalarWhereInput;
};

export type ProductionSeriesUpdateManyWithoutProductionNestedInput = {
  connect?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionSeriesCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionSeriesCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionSeriesCreateManyProductionInputEnvelope>;
  delete?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionSeriesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionSeriesUpdateWithWhereUniqueWithoutProductionInput>>;
  updateMany?: InputMaybe<Array<ProductionSeriesUpdateManyWithWhereWithoutProductionInput>>;
  upsert?: InputMaybe<Array<ProductionSeriesUpsertWithWhereUniqueWithoutProductionInput>>;
};

export type ProductionSeriesUpdateManyWithoutSeriesNestedInput = {
  connect?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionSeriesCreateOrConnectWithoutSeriesInput>>;
  create?: InputMaybe<Array<ProductionSeriesCreateWithoutSeriesInput>>;
  createMany?: InputMaybe<ProductionSeriesCreateManySeriesInputEnvelope>;
  delete?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionSeriesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionSeriesWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionSeriesUpdateWithWhereUniqueWithoutSeriesInput>>;
  updateMany?: InputMaybe<Array<ProductionSeriesUpdateManyWithWhereWithoutSeriesInput>>;
  upsert?: InputMaybe<Array<ProductionSeriesUpsertWithWhereUniqueWithoutSeriesInput>>;
};

export type ProductionSeriesUpdateWithWhereUniqueWithoutProductionInput = {
  data: ProductionSeriesUpdateWithoutProductionInput;
  where: ProductionSeriesWhereUniqueInput;
};

export type ProductionSeriesUpdateWithWhereUniqueWithoutSeriesInput = {
  data: ProductionSeriesUpdateWithoutSeriesInput;
  where: ProductionSeriesWhereUniqueInput;
};

export type ProductionSeriesUpdateWithoutProductionInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionSeriesUpdateWithoutSeriesInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionSeriesUpsertWithWhereUniqueWithoutProductionInput = {
  create: ProductionSeriesCreateWithoutProductionInput;
  update: ProductionSeriesUpdateWithoutProductionInput;
  where: ProductionSeriesWhereUniqueInput;
};

export type ProductionSeriesUpsertWithWhereUniqueWithoutSeriesInput = {
  create: ProductionSeriesCreateWithoutSeriesInput;
  update: ProductionSeriesUpdateWithoutSeriesInput;
  where: ProductionSeriesWhereUniqueInput;
};

export type ProductionSeriesWhereInput = {
  AND?: InputMaybe<Array<ProductionSeriesWhereInput>>;
  NOT?: InputMaybe<Array<ProductionSeriesWhereInput>>;
  OR?: InputMaybe<Array<ProductionSeriesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  series?: InputMaybe<SeriesRelationFilter>;
  seriesId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionSeriesWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  productionId_seriesId?: InputMaybe<ProductionSeriesProductionIdSeriesIdCompoundUniqueInput>;
};

/**
 *
 * 投稿作品に付与されたタグ
 */
export type ProductionTags = {
  __typename?: 'ProductionTags';
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  production: Productions;
  productionId: Scalars['BigInt'];
  tag: Tags;
  tagId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionTagsAvgAggregate = {
  __typename?: 'ProductionTagsAvgAggregate';
  id?: Maybe<Scalars['Float']>;
  productionId?: Maybe<Scalars['Float']>;
  tagId?: Maybe<Scalars['Float']>;
};

export type ProductionTagsCountAggregate = {
  __typename?: 'ProductionTagsCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  productionId: Scalars['Int'];
  tagId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductionTagsCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutProductionTagsInput;
  tag: TagsCreateNestedOneWithoutProductionTagsInput;
};

export type ProductionTagsCreateManyProductionInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  tagId: Scalars['BigInt'];
};

export type ProductionTagsCreateManyProductionInputEnvelope = {
  data: Array<ProductionTagsCreateManyProductionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionTagsCreateManyTagInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  productionId: Scalars['BigInt'];
};

export type ProductionTagsCreateManyTagInputEnvelope = {
  data: Array<ProductionTagsCreateManyTagInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionTagsCreateNestedManyWithoutProductionInput = {
  connect?: InputMaybe<Array<ProductionTagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionTagsCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionTagsCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionTagsCreateManyProductionInputEnvelope>;
};

export type ProductionTagsCreateNestedManyWithoutTagInput = {
  connect?: InputMaybe<Array<ProductionTagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionTagsCreateOrConnectWithoutTagInput>>;
  create?: InputMaybe<Array<ProductionTagsCreateWithoutTagInput>>;
  createMany?: InputMaybe<ProductionTagsCreateManyTagInputEnvelope>;
};

export type ProductionTagsCreateOrConnectWithoutProductionInput = {
  create: ProductionTagsCreateWithoutProductionInput;
  where: ProductionTagsWhereUniqueInput;
};

export type ProductionTagsCreateOrConnectWithoutTagInput = {
  create: ProductionTagsCreateWithoutTagInput;
  where: ProductionTagsWhereUniqueInput;
};

export type ProductionTagsCreateWithoutProductionInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  tag: TagsCreateNestedOneWithoutProductionTagsInput;
};

export type ProductionTagsCreateWithoutTagInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  production: ProductionsCreateNestedOneWithoutProductionTagsInput;
};

export type ProductionTagsListRelationFilter = {
  every?: InputMaybe<ProductionTagsWhereInput>;
  none?: InputMaybe<ProductionTagsWhereInput>;
  some?: InputMaybe<ProductionTagsWhereInput>;
};

export type ProductionTagsMaxAggregate = {
  __typename?: 'ProductionTagsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  tagId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionTagsMinAggregate = {
  __typename?: 'ProductionTagsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  tagId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductionTagsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductionTagsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  production?: InputMaybe<ProductionsOrderByWithRelationInput>;
  productionId?: InputMaybe<SortOrder>;
  tag?: InputMaybe<TagsOrderByWithRelationInput>;
  tagId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductionTagsProductionIdTagIdCompoundUniqueInput = {
  productionId: Scalars['BigInt'];
  tagId: Scalars['BigInt'];
};

export enum ProductionTagsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ProductionId = 'productionId',
  TagId = 'tagId',
  UpdatedAt = 'updatedAt'
}

export type ProductionTagsScalarWhereInput = {
  AND?: InputMaybe<Array<ProductionTagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductionTagsScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductionTagsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  tagId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionTagsSumAggregate = {
  __typename?: 'ProductionTagsSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
  productionId?: Maybe<Scalars['BigInt']>;
  tagId?: Maybe<Scalars['BigInt']>;
};

export type ProductionTagsUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionTagsUpdateManyWithWhereWithoutProductionInput = {
  data: ProductionTagsUpdateManyMutationInput;
  where: ProductionTagsScalarWhereInput;
};

export type ProductionTagsUpdateManyWithoutProductionNestedInput = {
  connect?: InputMaybe<Array<ProductionTagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionTagsCreateOrConnectWithoutProductionInput>>;
  create?: InputMaybe<Array<ProductionTagsCreateWithoutProductionInput>>;
  createMany?: InputMaybe<ProductionTagsCreateManyProductionInputEnvelope>;
  delete?: InputMaybe<Array<ProductionTagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionTagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionTagsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionTagsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionTagsUpdateWithWhereUniqueWithoutProductionInput>>;
  updateMany?: InputMaybe<Array<ProductionTagsUpdateManyWithWhereWithoutProductionInput>>;
  upsert?: InputMaybe<Array<ProductionTagsUpsertWithWhereUniqueWithoutProductionInput>>;
};

export type ProductionTagsUpdateWithWhereUniqueWithoutProductionInput = {
  data: ProductionTagsUpdateWithoutProductionInput;
  where: ProductionTagsWhereUniqueInput;
};

export type ProductionTagsUpdateWithoutProductionInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type ProductionTagsUpsertWithWhereUniqueWithoutProductionInput = {
  create: ProductionTagsCreateWithoutProductionInput;
  update: ProductionTagsUpdateWithoutProductionInput;
  where: ProductionTagsWhereUniqueInput;
};

export type ProductionTagsWhereInput = {
  AND?: InputMaybe<Array<ProductionTagsWhereInput>>;
  NOT?: InputMaybe<Array<ProductionTagsWhereInput>>;
  OR?: InputMaybe<Array<ProductionTagsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  production?: InputMaybe<ProductionsRelationFilter>;
  productionId?: InputMaybe<BigIntFilter>;
  tag?: InputMaybe<TagsRelationFilter>;
  tagId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ProductionTagsWhereUniqueInput = {
  productionId_tagId?: InputMaybe<ProductionTagsProductionIdTagIdCompoundUniqueInput>;
};

/**
 *
 * 投稿作品
 */
export type Productions = {
  __typename?: 'Productions';
  _count?: Maybe<ProductionsCount>;
  body?: Maybe<Scalars['String']>;
  bodyMd?: Maybe<Scalars['String']>;
  circle?: Maybe<Circles>;
  circleId?: Maybe<Scalars['BigInt']>;
  closed?: Maybe<Scalars['DateTime']>;
  commentAcceptable: Scalars['Boolean'];
  commentsCount?: Maybe<Scalars['Float']>;
  countBookmarks: Scalars['Int'];
  countComments: Scalars['Int'];
  countPages: Scalars['Int'];
  countViews: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  editorRecommendations: Array<EditorRecommendations>;
  favoriteProductions: Array<FavoriteProductions>;
  favoritesCount?: Maybe<Scalars['Float']>;
  form: Forms;
  formId: Scalars['BigInt'];
  goodCount?: Maybe<Scalars['Float']>;
  goodProductions: Array<GoodProductions>;
  id: Scalars['BigInt'];
  layout?: Maybe<Scalars['String']>;
  newProductions: Array<LatestProductions>;
  onCircle: Scalars['Boolean'];
  popularProductions: Array<PopularProductions>;
  postFacebook: Scalars['Boolean'];
  postInstagram: Scalars['Boolean'];
  postTwitter: Scalars['Boolean'];
  productionComments: Array<ProductionComments>;
  productionGenres: Array<ProductionGenres>;
  productionImages: Array<ProductionImages>;
  productionSeries: Array<ProductionSeries>;
  productionTags: Array<ProductionTags>;
  published?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
  viewCount?: Maybe<Scalars['Float']>;
  viewerUrl?: Maybe<Scalars['String']>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsEditorRecommendationsArgs = {
  cursor?: InputMaybe<EditorRecommendationsWhereUniqueInput>;
  distinct?: InputMaybe<Array<EditorRecommendationsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EditorRecommendationsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EditorRecommendationsWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsFavoriteProductionsArgs = {
  cursor?: InputMaybe<FavoriteProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoriteProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoriteProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FavoriteProductionsWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsGoodProductionsArgs = {
  cursor?: InputMaybe<GoodProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<GoodProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GoodProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GoodProductionsWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsNewProductionsArgs = {
  cursor?: InputMaybe<LatestProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<LatestProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LatestProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LatestProductionsWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsPopularProductionsArgs = {
  cursor?: InputMaybe<PopularProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopularProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopularProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PopularProductionsWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsProductionCommentsArgs = {
  cursor?: InputMaybe<ProductionCommentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionCommentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionCommentsWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsProductionGenresArgs = {
  cursor?: InputMaybe<ProductionGenresWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionGenresScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionGenresWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsProductionImagesArgs = {
  cursor?: InputMaybe<ProductionImagesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionImagesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionImagesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionImagesWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsProductionSeriesArgs = {
  cursor?: InputMaybe<ProductionSeriesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionSeriesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionSeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionSeriesWhereInput>;
};


/**
 *
 * 投稿作品
 */
export type ProductionsProductionTagsArgs = {
  cursor?: InputMaybe<ProductionTagsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionTagsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionTagsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionTagsWhereInput>;
};

export type ProductionsAvgAggregate = {
  __typename?: 'ProductionsAvgAggregate';
  circleId?: Maybe<Scalars['Float']>;
  countBookmarks?: Maybe<Scalars['Float']>;
  countComments?: Maybe<Scalars['Float']>;
  countPages?: Maybe<Scalars['Float']>;
  countViews?: Maybe<Scalars['Float']>;
  formId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type ProductionsCount = {
  __typename?: 'ProductionsCount';
  editorRecommendations: Scalars['Int'];
  favoriteProductions: Scalars['Int'];
  goodProductions: Scalars['Int'];
  newProductions: Scalars['Int'];
  popularProductions: Scalars['Int'];
  productionComments: Scalars['Int'];
  productionGenres: Scalars['Int'];
  productionImages: Scalars['Int'];
  productionSeries: Scalars['Int'];
  productionTags: Scalars['Int'];
};

export type ProductionsCountAggregate = {
  __typename?: 'ProductionsCountAggregate';
  _all: Scalars['Int'];
  body: Scalars['Int'];
  bodyMd: Scalars['Int'];
  circleId: Scalars['Int'];
  closed: Scalars['Int'];
  commentAcceptable: Scalars['Int'];
  countBookmarks: Scalars['Int'];
  countComments: Scalars['Int'];
  countPages: Scalars['Int'];
  countViews: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  descriptionMd: Scalars['Int'];
  disabled: Scalars['Int'];
  formId: Scalars['Int'];
  id: Scalars['Int'];
  layout: Scalars['Int'];
  onCircle: Scalars['Int'];
  postFacebook: Scalars['Int'];
  postInstagram: Scalars['Int'];
  postTwitter: Scalars['Int'];
  published: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ProductionsCreateInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateManyCircleInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  formId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  userId: Scalars['BigInt'];
};

export type ProductionsCreateManyCircleInputEnvelope = {
  data: Array<ProductionsCreateManyCircleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionsCreateManyUserInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circleId?: InputMaybe<Scalars['BigInt']>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  formId: Scalars['BigInt'];
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type ProductionsCreateManyUserInputEnvelope = {
  data: Array<ProductionsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductionsCreateNestedManyWithoutCircleInput = {
  connect?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionsCreateOrConnectWithoutCircleInput>>;
  create?: InputMaybe<Array<ProductionsCreateWithoutCircleInput>>;
  createMany?: InputMaybe<ProductionsCreateManyCircleInputEnvelope>;
};

export type ProductionsCreateNestedOneWithoutFavoriteProductionsInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutFavoriteProductionsInput>;
  create?: InputMaybe<ProductionsCreateWithoutFavoriteProductionsInput>;
};

export type ProductionsCreateNestedOneWithoutGoodProductionsInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutGoodProductionsInput>;
  create?: InputMaybe<ProductionsCreateWithoutGoodProductionsInput>;
};

export type ProductionsCreateNestedOneWithoutNewProductionsInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutNewProductionsInput>;
  create?: InputMaybe<ProductionsCreateWithoutNewProductionsInput>;
};

export type ProductionsCreateNestedOneWithoutPopularProductionsInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutPopularProductionsInput>;
  create?: InputMaybe<ProductionsCreateWithoutPopularProductionsInput>;
};

export type ProductionsCreateNestedOneWithoutProductionCommentsInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutProductionCommentsInput>;
  create?: InputMaybe<ProductionsCreateWithoutProductionCommentsInput>;
};

export type ProductionsCreateNestedOneWithoutProductionGenresInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutProductionGenresInput>;
  create?: InputMaybe<ProductionsCreateWithoutProductionGenresInput>;
};

export type ProductionsCreateNestedOneWithoutProductionSeriesInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutProductionSeriesInput>;
  create?: InputMaybe<ProductionsCreateWithoutProductionSeriesInput>;
};

export type ProductionsCreateNestedOneWithoutProductionTagsInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutProductionTagsInput>;
  create?: InputMaybe<ProductionsCreateWithoutProductionTagsInput>;
};

export type ProductionsCreateOrConnectWithoutCircleInput = {
  create: ProductionsCreateWithoutCircleInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutFavoriteProductionsInput = {
  create: ProductionsCreateWithoutFavoriteProductionsInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutGoodProductionsInput = {
  create: ProductionsCreateWithoutGoodProductionsInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutNewProductionsInput = {
  create: ProductionsCreateWithoutNewProductionsInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutPopularProductionsInput = {
  create: ProductionsCreateWithoutPopularProductionsInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutProductionCommentsInput = {
  create: ProductionsCreateWithoutProductionCommentsInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutProductionGenresInput = {
  create: ProductionsCreateWithoutProductionGenresInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutProductionSeriesInput = {
  create: ProductionsCreateWithoutProductionSeriesInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutProductionTagsInput = {
  create: ProductionsCreateWithoutProductionTagsInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateOrConnectWithoutUserInput = {
  create: ProductionsCreateWithoutUserInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsCreateWithoutCircleInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutFavoriteProductionsInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutGoodProductionsInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutNewProductionsInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutPopularProductionsInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutProductionCommentsInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutProductionGenresInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutProductionSeriesInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutProductionTagsInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutProductionsInput;
};

export type ProductionsCreateWithoutUserInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyMd?: InputMaybe<Scalars['String']>;
  circle?: InputMaybe<CirclesCreateNestedOneWithoutProductionsInput>;
  closed?: InputMaybe<Scalars['DateTime']>;
  commentAcceptable?: InputMaybe<Scalars['Boolean']>;
  countBookmarks?: InputMaybe<Scalars['Int']>;
  countComments?: InputMaybe<Scalars['Int']>;
  countPages?: InputMaybe<Scalars['Int']>;
  countViews?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionMd?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['DateTime']>;
  form: FormsCreateNestedOneWithoutProductionsInput;
  id?: InputMaybe<Scalars['BigInt']>;
  layout?: InputMaybe<Scalars['String']>;
  onCircle?: InputMaybe<Scalars['Boolean']>;
  postFacebook?: InputMaybe<Scalars['Boolean']>;
  postInstagram?: InputMaybe<Scalars['Boolean']>;
  postTwitter?: InputMaybe<Scalars['Boolean']>;
  productionGenres?: InputMaybe<ProductionGenresCreateNestedManyWithoutProductionInput>;
  productionImages?: InputMaybe<ProductionImagesCreateNestedManyWithoutProductionInput>;
  productionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutProductionInput>;
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutProductionInput>;
  published?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type ProductionsListRelationFilter = {
  every?: InputMaybe<ProductionsWhereInput>;
  none?: InputMaybe<ProductionsWhereInput>;
  some?: InputMaybe<ProductionsWhereInput>;
};

export type ProductionsMaxAggregate = {
  __typename?: 'ProductionsMaxAggregate';
  body?: Maybe<Scalars['String']>;
  bodyMd?: Maybe<Scalars['String']>;
  circleId?: Maybe<Scalars['BigInt']>;
  closed?: Maybe<Scalars['DateTime']>;
  commentAcceptable?: Maybe<Scalars['Boolean']>;
  countBookmarks?: Maybe<Scalars['Int']>;
  countComments?: Maybe<Scalars['Int']>;
  countPages?: Maybe<Scalars['Int']>;
  countViews?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  formId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  layout?: Maybe<Scalars['String']>;
  onCircle?: Maybe<Scalars['Boolean']>;
  postFacebook?: Maybe<Scalars['Boolean']>;
  postInstagram?: Maybe<Scalars['Boolean']>;
  postTwitter?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type ProductionsMinAggregate = {
  __typename?: 'ProductionsMinAggregate';
  body?: Maybe<Scalars['String']>;
  bodyMd?: Maybe<Scalars['String']>;
  circleId?: Maybe<Scalars['BigInt']>;
  closed?: Maybe<Scalars['DateTime']>;
  commentAcceptable?: Maybe<Scalars['Boolean']>;
  countBookmarks?: Maybe<Scalars['Int']>;
  countComments?: Maybe<Scalars['Int']>;
  countPages?: Maybe<Scalars['Int']>;
  countViews?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionMd?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['DateTime']>;
  formId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  layout?: Maybe<Scalars['String']>;
  onCircle?: Maybe<Scalars['Boolean']>;
  postFacebook?: Maybe<Scalars['Boolean']>;
  postInstagram?: Maybe<Scalars['Boolean']>;
  postTwitter?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type ProductionsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductionsOrderByWithRelationInput = {
  body?: InputMaybe<SortOrder>;
  bodyMd?: InputMaybe<SortOrder>;
  circle?: InputMaybe<CirclesOrderByWithRelationInput>;
  circleId?: InputMaybe<SortOrder>;
  closed?: InputMaybe<SortOrder>;
  commentAcceptable?: InputMaybe<SortOrder>;
  countBookmarks?: InputMaybe<SortOrder>;
  countComments?: InputMaybe<SortOrder>;
  countPages?: InputMaybe<SortOrder>;
  countViews?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionMd?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  editorRecommendations?: InputMaybe<EditorRecommendationsOrderByRelationAggregateInput>;
  favoriteProductions?: InputMaybe<FavoriteProductionsOrderByRelationAggregateInput>;
  form?: InputMaybe<FormsOrderByWithRelationInput>;
  formId?: InputMaybe<SortOrder>;
  goodProductions?: InputMaybe<GoodProductionsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  layout?: InputMaybe<SortOrder>;
  newProductions?: InputMaybe<LatestProductionsOrderByRelationAggregateInput>;
  onCircle?: InputMaybe<SortOrder>;
  popularProductions?: InputMaybe<PopularProductionsOrderByRelationAggregateInput>;
  postFacebook?: InputMaybe<SortOrder>;
  postInstagram?: InputMaybe<SortOrder>;
  postTwitter?: InputMaybe<SortOrder>;
  productionComments?: InputMaybe<ProductionCommentsOrderByRelationAggregateInput>;
  productionGenres?: InputMaybe<ProductionGenresOrderByRelationAggregateInput>;
  productionImages?: InputMaybe<ProductionImagesOrderByRelationAggregateInput>;
  productionSeries?: InputMaybe<ProductionSeriesOrderByRelationAggregateInput>;
  productionTags?: InputMaybe<ProductionTagsOrderByRelationAggregateInput>;
  published?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type ProductionsRelationFilter = {
  is?: InputMaybe<ProductionsWhereInput>;
  isNot?: InputMaybe<ProductionsWhereInput>;
};

export enum ProductionsScalarFieldEnum {
  Body = 'body',
  BodyMd = 'bodyMd',
  CircleId = 'circleId',
  Closed = 'closed',
  CommentAcceptable = 'commentAcceptable',
  CountBookmarks = 'countBookmarks',
  CountComments = 'countComments',
  CountPages = 'countPages',
  CountViews = 'countViews',
  CreatedAt = 'createdAt',
  Description = 'description',
  DescriptionMd = 'descriptionMd',
  Disabled = 'disabled',
  FormId = 'formId',
  Id = 'id',
  Layout = 'layout',
  OnCircle = 'onCircle',
  PostFacebook = 'postFacebook',
  PostInstagram = 'postInstagram',
  PostTwitter = 'postTwitter',
  Published = 'published',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ProductionsScalarWhereInput = {
  AND?: InputMaybe<Array<ProductionsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductionsScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductionsScalarWhereInput>>;
  body?: InputMaybe<StringNullableFilter>;
  bodyMd?: InputMaybe<StringNullableFilter>;
  circleId?: InputMaybe<BigIntNullableFilter>;
  closed?: InputMaybe<DateTimeNullableFilter>;
  commentAcceptable?: InputMaybe<BoolFilter>;
  countBookmarks?: InputMaybe<IntFilter>;
  countComments?: InputMaybe<IntFilter>;
  countPages?: InputMaybe<IntFilter>;
  countViews?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  descriptionMd?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  formId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  layout?: InputMaybe<StringNullableFilter>;
  onCircle?: InputMaybe<BoolFilter>;
  postFacebook?: InputMaybe<BoolFilter>;
  postInstagram?: InputMaybe<BoolFilter>;
  postTwitter?: InputMaybe<BoolFilter>;
  published?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ProductionsSumAggregate = {
  __typename?: 'ProductionsSumAggregate';
  circleId?: Maybe<Scalars['BigInt']>;
  countBookmarks?: Maybe<Scalars['Int']>;
  countComments?: Maybe<Scalars['Int']>;
  countPages?: Maybe<Scalars['Int']>;
  countViews?: Maybe<Scalars['Int']>;
  formId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type ProductionsUpdateInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bodyMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  circle?: InputMaybe<CirclesUpdateOneWithoutProductionsNestedInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commentAcceptable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  countBookmarks?: InputMaybe<IntFieldUpdateOperationsInput>;
  countComments?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPages?: InputMaybe<IntFieldUpdateOperationsInput>;
  countViews?: InputMaybe<IntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  form?: InputMaybe<FormsUpdateOneRequiredWithoutProductionsNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  layout?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onCircle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productionGenres?: InputMaybe<ProductionGenresUpdateManyWithoutProductionNestedInput>;
  productionImages?: InputMaybe<ProductionImagesUpdateManyWithoutProductionNestedInput>;
  productionSeries?: InputMaybe<ProductionSeriesUpdateManyWithoutProductionNestedInput>;
  productionTags?: InputMaybe<ProductionTagsUpdateManyWithoutProductionNestedInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UsersUpdateOneRequiredWithoutProductionsNestedInput>;
};

export type ProductionsUpdateManyMutationInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bodyMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commentAcceptable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  countBookmarks?: InputMaybe<IntFieldUpdateOperationsInput>;
  countComments?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPages?: InputMaybe<IntFieldUpdateOperationsInput>;
  countViews?: InputMaybe<IntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  layout?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onCircle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductionsUpdateManyWithWhereWithoutCircleInput = {
  data: ProductionsUpdateManyMutationInput;
  where: ProductionsScalarWhereInput;
};

export type ProductionsUpdateManyWithWhereWithoutUserInput = {
  data: ProductionsUpdateManyMutationInput;
  where: ProductionsScalarWhereInput;
};

export type ProductionsUpdateManyWithoutCircleNestedInput = {
  connect?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionsCreateOrConnectWithoutCircleInput>>;
  create?: InputMaybe<Array<ProductionsCreateWithoutCircleInput>>;
  createMany?: InputMaybe<ProductionsCreateManyCircleInputEnvelope>;
  delete?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionsUpdateWithWhereUniqueWithoutCircleInput>>;
  updateMany?: InputMaybe<Array<ProductionsUpdateManyWithWhereWithoutCircleInput>>;
  upsert?: InputMaybe<Array<ProductionsUpsertWithWhereUniqueWithoutCircleInput>>;
};

export type ProductionsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductionsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ProductionsCreateWithoutUserInput>>;
  createMany?: InputMaybe<ProductionsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductionsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductionsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ProductionsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ProductionsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ProductionsUpdateOneRequiredWithoutGoodProductionsNestedInput = {
  connect?: InputMaybe<ProductionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductionsCreateOrConnectWithoutGoodProductionsInput>;
  create?: InputMaybe<ProductionsCreateWithoutGoodProductionsInput>;
  update?: InputMaybe<ProductionsUpdateWithoutGoodProductionsInput>;
  upsert?: InputMaybe<ProductionsUpsertWithoutGoodProductionsInput>;
};

export type ProductionsUpdateWithWhereUniqueWithoutCircleInput = {
  data: ProductionsUpdateWithoutCircleInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsUpdateWithWhereUniqueWithoutUserInput = {
  data: ProductionsUpdateWithoutUserInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsUpdateWithoutCircleInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bodyMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commentAcceptable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  countBookmarks?: InputMaybe<IntFieldUpdateOperationsInput>;
  countComments?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPages?: InputMaybe<IntFieldUpdateOperationsInput>;
  countViews?: InputMaybe<IntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  form?: InputMaybe<FormsUpdateOneRequiredWithoutProductionsNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  layout?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onCircle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productionGenres?: InputMaybe<ProductionGenresUpdateManyWithoutProductionNestedInput>;
  productionImages?: InputMaybe<ProductionImagesUpdateManyWithoutProductionNestedInput>;
  productionSeries?: InputMaybe<ProductionSeriesUpdateManyWithoutProductionNestedInput>;
  productionTags?: InputMaybe<ProductionTagsUpdateManyWithoutProductionNestedInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UsersUpdateOneRequiredWithoutProductionsNestedInput>;
};

export type ProductionsUpdateWithoutGoodProductionsInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bodyMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  circle?: InputMaybe<CirclesUpdateOneWithoutProductionsNestedInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commentAcceptable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  countBookmarks?: InputMaybe<IntFieldUpdateOperationsInput>;
  countComments?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPages?: InputMaybe<IntFieldUpdateOperationsInput>;
  countViews?: InputMaybe<IntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  form?: InputMaybe<FormsUpdateOneRequiredWithoutProductionsNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  layout?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onCircle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productionGenres?: InputMaybe<ProductionGenresUpdateManyWithoutProductionNestedInput>;
  productionImages?: InputMaybe<ProductionImagesUpdateManyWithoutProductionNestedInput>;
  productionSeries?: InputMaybe<ProductionSeriesUpdateManyWithoutProductionNestedInput>;
  productionTags?: InputMaybe<ProductionTagsUpdateManyWithoutProductionNestedInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UsersUpdateOneRequiredWithoutProductionsNestedInput>;
};

export type ProductionsUpdateWithoutUserInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bodyMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  circle?: InputMaybe<CirclesUpdateOneWithoutProductionsNestedInput>;
  closed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commentAcceptable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  countBookmarks?: InputMaybe<IntFieldUpdateOperationsInput>;
  countComments?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPages?: InputMaybe<IntFieldUpdateOperationsInput>;
  countViews?: InputMaybe<IntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  form?: InputMaybe<FormsUpdateOneRequiredWithoutProductionsNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  layout?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onCircle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postFacebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postInstagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  postTwitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productionGenres?: InputMaybe<ProductionGenresUpdateManyWithoutProductionNestedInput>;
  productionImages?: InputMaybe<ProductionImagesUpdateManyWithoutProductionNestedInput>;
  productionSeries?: InputMaybe<ProductionSeriesUpdateManyWithoutProductionNestedInput>;
  productionTags?: InputMaybe<ProductionTagsUpdateManyWithoutProductionNestedInput>;
  published?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductionsUpsertWithWhereUniqueWithoutCircleInput = {
  create: ProductionsCreateWithoutCircleInput;
  update: ProductionsUpdateWithoutCircleInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsUpsertWithWhereUniqueWithoutUserInput = {
  create: ProductionsCreateWithoutUserInput;
  update: ProductionsUpdateWithoutUserInput;
  where: ProductionsWhereUniqueInput;
};

export type ProductionsUpsertWithoutGoodProductionsInput = {
  create: ProductionsCreateWithoutGoodProductionsInput;
  update: ProductionsUpdateWithoutGoodProductionsInput;
};

export type ProductionsWhereInput = {
  AND?: InputMaybe<Array<ProductionsWhereInput>>;
  NOT?: InputMaybe<Array<ProductionsWhereInput>>;
  OR?: InputMaybe<Array<ProductionsWhereInput>>;
  body?: InputMaybe<StringNullableFilter>;
  bodyMd?: InputMaybe<StringNullableFilter>;
  circle?: InputMaybe<CirclesRelationFilter>;
  circleId?: InputMaybe<BigIntNullableFilter>;
  closed?: InputMaybe<DateTimeNullableFilter>;
  commentAcceptable?: InputMaybe<BoolFilter>;
  countBookmarks?: InputMaybe<IntFilter>;
  countComments?: InputMaybe<IntFilter>;
  countPages?: InputMaybe<IntFilter>;
  countViews?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  descriptionMd?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  editorRecommendations?: InputMaybe<EditorRecommendationsListRelationFilter>;
  favoriteProductions?: InputMaybe<FavoriteProductionsListRelationFilter>;
  form?: InputMaybe<FormsRelationFilter>;
  formId?: InputMaybe<BigIntFilter>;
  goodProductions?: InputMaybe<GoodProductionsListRelationFilter>;
  id?: InputMaybe<BigIntFilter>;
  layout?: InputMaybe<StringNullableFilter>;
  newProductions?: InputMaybe<LatestProductionsListRelationFilter>;
  onCircle?: InputMaybe<BoolFilter>;
  popularProductions?: InputMaybe<PopularProductionsListRelationFilter>;
  postFacebook?: InputMaybe<BoolFilter>;
  postInstagram?: InputMaybe<BoolFilter>;
  postTwitter?: InputMaybe<BoolFilter>;
  productionComments?: InputMaybe<ProductionCommentsListRelationFilter>;
  productionGenres?: InputMaybe<ProductionGenresListRelationFilter>;
  productionImages?: InputMaybe<ProductionImagesListRelationFilter>;
  productionSeries?: InputMaybe<ProductionSeriesListRelationFilter>;
  productionTags?: InputMaybe<ProductionTagsListRelationFilter>;
  published?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type ProductionsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Query = {
  __typename?: 'Query';
  aggregateApplyCircles: AggregateApplyCircles;
  aggregateCircleComments: AggregateCircleComments;
  aggregateCircleGenres: AggregateCircleGenres;
  aggregateCircleMembers: AggregateCircleMembers;
  aggregateCircleSkills: AggregateCircleSkills;
  aggregateCircles: AggregateCircles;
  aggregateCommercials: AggregateCommercials;
  aggregateFavoriteProductions: AggregateFavoriteProductions;
  aggregateGenres: AggregateGenres;
  aggregateGoodProductions: AggregateGoodProductions;
  aggregateLatestProductions: AggregateLatestProductions;
  aggregateNotices: AggregateNotices;
  aggregatePopularProductions: AggregatePopularProductions;
  aggregateProductionGenres: AggregateProductionGenres;
  aggregateProductionSeries: AggregateProductionSeries;
  aggregateProductionTags: AggregateProductionTags;
  aggregateProductions: AggregateProductions;
  aggregateSeries: AggregateSeries;
  aggregateTags: AggregateTags;
  findFirstSeries?: Maybe<Series>;
  findFirstTags?: Maybe<Tags>;
  findFirstUsers?: Maybe<Users>;
  findManyApplyCircles: Array<ApplyCircles>;
  findManyCircleComments: Array<CircleComments>;
  findManyCircleGenres: Array<CircleGenres>;
  findManyCircleMembers: Array<CircleMembers>;
  findManyCircleSkills: Array<CircleSkills>;
  findManyCircles: Array<Circles>;
  findManyCommercials: Array<Commercials>;
  findManyFavoriteProductions: Array<FavoriteProductions>;
  findManyForms: Array<Forms>;
  findManyGenres: Array<Genres>;
  findManyGoodProductions: Array<GoodProductions>;
  findManyInquiries: Array<Inquiries>;
  findManyLatestProductions: Array<LatestProductions>;
  findManyNotices: Array<Notices>;
  findManyPopularProductions: Array<PopularProductions>;
  findManyProductionComments: Array<ProductionComments>;
  findManyProductionGenres: Array<ProductionGenres>;
  findManyProductionSeries: Array<ProductionSeries>;
  findManyProductionTags: Array<ProductionTags>;
  findManyProductions: Array<Productions>;
  findManySeries: Array<Series>;
  findManySkills: Array<Skills>;
  findManyTags: Array<Tags>;
  findManyUsers: Array<Users>;
  findUniqueApplyCircles?: Maybe<ApplyCircles>;
  findUniqueCircleComments?: Maybe<CircleComments>;
  findUniqueCircleGenres?: Maybe<CircleGenres>;
  findUniqueCircleMembers?: Maybe<CircleMembers>;
  findUniqueCircleSkills?: Maybe<CircleSkills>;
  findUniqueCircles?: Maybe<Circles>;
  findUniqueCommercials?: Maybe<Commercials>;
  findUniqueFavoriteProductions?: Maybe<FavoriteProductions>;
  findUniqueGenres?: Maybe<Genres>;
  findUniqueGoodProductions?: Maybe<GoodProductions>;
  findUniqueNotices?: Maybe<Notices>;
  findUniqueProductions?: Maybe<Productions>;
  findUniqueReports?: Maybe<Reports>;
  findUniqueSeries?: Maybe<Series>;
  findUniqueUsers?: Maybe<Users>;
  getMe?: Maybe<Users>;
};


export type QueryAggregateApplyCirclesArgs = {
  cursor?: InputMaybe<ApplyCirclesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ApplyCirclesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplyCirclesWhereInput>;
};


export type QueryAggregateCircleCommentsArgs = {
  cursor?: InputMaybe<CircleCommentsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CircleCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleCommentsWhereInput>;
};


export type QueryAggregateCircleGenresArgs = {
  cursor?: InputMaybe<CircleGenresWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CircleGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleGenresWhereInput>;
};


export type QueryAggregateCircleMembersArgs = {
  cursor?: InputMaybe<CircleMembersWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CircleMembersOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleMembersWhereInput>;
};


export type QueryAggregateCircleSkillsArgs = {
  cursor?: InputMaybe<CircleSkillsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CircleSkillsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleSkillsWhereInput>;
};


export type QueryAggregateCirclesArgs = {
  cursor?: InputMaybe<CirclesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CirclesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CirclesWhereInput>;
};


export type QueryAggregateCommercialsArgs = {
  cursor?: InputMaybe<CommercialsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CommercialsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommercialsWhereInput>;
};


export type QueryAggregateFavoriteProductionsArgs = {
  cursor?: InputMaybe<FavoriteProductionsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<FavoriteProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FavoriteProductionsWhereInput>;
};


export type QueryAggregateGenresArgs = {
  cursor?: InputMaybe<GenresWhereUniqueInput>;
  orderBy?: InputMaybe<Array<GenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GenresWhereInput>;
};


export type QueryAggregateGoodProductionsArgs = {
  cursor?: InputMaybe<GoodProductionsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<GoodProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GoodProductionsWhereInput>;
};


export type QueryAggregateLatestProductionsArgs = {
  cursor?: InputMaybe<LatestProductionsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<LatestProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LatestProductionsWhereInput>;
};


export type QueryAggregateNoticesArgs = {
  cursor?: InputMaybe<NoticesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<NoticesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NoticesWhereInput>;
};


export type QueryAggregatePopularProductionsArgs = {
  cursor?: InputMaybe<PopularProductionsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PopularProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PopularProductionsWhereInput>;
};


export type QueryAggregateProductionGenresArgs = {
  cursor?: InputMaybe<ProductionGenresWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductionGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionGenresWhereInput>;
};


export type QueryAggregateProductionSeriesArgs = {
  cursor?: InputMaybe<ProductionSeriesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductionSeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionSeriesWhereInput>;
};


export type QueryAggregateProductionTagsArgs = {
  cursor?: InputMaybe<ProductionTagsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductionTagsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionTagsWhereInput>;
};


export type QueryAggregateProductionsArgs = {
  cursor?: InputMaybe<ProductionsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionsWhereInput>;
};


export type QueryAggregateSeriesArgs = {
  cursor?: InputMaybe<SeriesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<SeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeriesWhereInput>;
};


export type QueryAggregateTagsArgs = {
  cursor?: InputMaybe<TagsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TagsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagsWhereInput>;
};


export type QueryFindFirstSeriesArgs = {
  cursor?: InputMaybe<SeriesWhereUniqueInput>;
  distinct?: InputMaybe<Array<SeriesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeriesWhereInput>;
};


export type QueryFindFirstTagsArgs = {
  cursor?: InputMaybe<TagsWhereUniqueInput>;
  distinct?: InputMaybe<Array<TagsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TagsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagsWhereInput>;
};


export type QueryFindFirstUsersArgs = {
  cursor?: InputMaybe<UsersWhereUniqueInput>;
  distinct?: InputMaybe<Array<UsersScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UsersOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UsersWhereInput>;
};


export type QueryFindManyApplyCirclesArgs = {
  cursor?: InputMaybe<ApplyCirclesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplyCirclesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplyCirclesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplyCirclesWhereInput>;
};


export type QueryFindManyCircleCommentsArgs = {
  cursor?: InputMaybe<CircleCommentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleCommentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleCommentsWhereInput>;
};


export type QueryFindManyCircleGenresArgs = {
  cursor?: InputMaybe<CircleGenresWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleGenresScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleGenresWhereInput>;
};


export type QueryFindManyCircleMembersArgs = {
  cursor?: InputMaybe<CircleMembersWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleMembersScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleMembersOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleMembersWhereInput>;
};


export type QueryFindManyCircleSkillsArgs = {
  cursor?: InputMaybe<CircleSkillsWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleSkillsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleSkillsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleSkillsWhereInput>;
};


export type QueryFindManyCirclesArgs = {
  cursor?: InputMaybe<CirclesWhereUniqueInput>;
  distinct?: InputMaybe<Array<CirclesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CirclesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CirclesWhereInput>;
};


export type QueryFindManyCommercialsArgs = {
  cursor?: InputMaybe<CommercialsWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommercialsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommercialsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommercialsWhereInput>;
};


export type QueryFindManyFavoriteProductionsArgs = {
  cursor?: InputMaybe<FavoriteProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoriteProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoriteProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FavoriteProductionsWhereInput>;
};


export type QueryFindManyFormsArgs = {
  cursor?: InputMaybe<FormsWhereUniqueInput>;
  distinct?: InputMaybe<Array<FormsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FormsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FormsWhereInput>;
};


export type QueryFindManyGenresArgs = {
  cursor?: InputMaybe<GenresWhereUniqueInput>;
  distinct?: InputMaybe<Array<GenresScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GenresWhereInput>;
};


export type QueryFindManyGoodProductionsArgs = {
  cursor?: InputMaybe<GoodProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<GoodProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GoodProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GoodProductionsWhereInput>;
};


export type QueryFindManyInquiriesArgs = {
  cursor?: InputMaybe<InquiriesWhereUniqueInput>;
  distinct?: InputMaybe<Array<InquiriesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InquiriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InquiriesWhereInput>;
};


export type QueryFindManyLatestProductionsArgs = {
  cursor?: InputMaybe<LatestProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<LatestProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LatestProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LatestProductionsWhereInput>;
};


export type QueryFindManyNoticesArgs = {
  cursor?: InputMaybe<NoticesWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoticesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoticesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NoticesWhereInput>;
};


export type QueryFindManyPopularProductionsArgs = {
  cursor?: InputMaybe<PopularProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopularProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopularProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PopularProductionsWhereInput>;
};


export type QueryFindManyProductionCommentsArgs = {
  cursor?: InputMaybe<ProductionCommentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionCommentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionCommentsWhereInput>;
};


export type QueryFindManyProductionGenresArgs = {
  cursor?: InputMaybe<ProductionGenresWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionGenresScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionGenresOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionGenresWhereInput>;
};


export type QueryFindManyProductionSeriesArgs = {
  cursor?: InputMaybe<ProductionSeriesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionSeriesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionSeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionSeriesWhereInput>;
};


export type QueryFindManyProductionTagsArgs = {
  cursor?: InputMaybe<ProductionTagsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionTagsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionTagsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionTagsWhereInput>;
};


export type QueryFindManyProductionsArgs = {
  cursor?: InputMaybe<ProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionsWhereInput>;
};


export type QueryFindManySeriesArgs = {
  cursor?: InputMaybe<SeriesWhereUniqueInput>;
  distinct?: InputMaybe<Array<SeriesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeriesWhereInput>;
};


export type QueryFindManySkillsArgs = {
  cursor?: InputMaybe<SkillsWhereUniqueInput>;
  distinct?: InputMaybe<Array<SkillsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SkillsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkillsWhereInput>;
};


export type QueryFindManyTagsArgs = {
  cursor?: InputMaybe<TagsWhereUniqueInput>;
  distinct?: InputMaybe<Array<TagsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TagsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagsWhereInput>;
};


export type QueryFindManyUsersArgs = {
  cursor?: InputMaybe<UsersWhereUniqueInput>;
  distinct?: InputMaybe<Array<UsersScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UsersOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UsersWhereInput>;
};


export type QueryFindUniqueApplyCirclesArgs = {
  where: ApplyCirclesWhereUniqueInput;
};


export type QueryFindUniqueCircleCommentsArgs = {
  where: CircleCommentsWhereUniqueInput;
};


export type QueryFindUniqueCircleGenresArgs = {
  where: CircleGenresWhereUniqueInput;
};


export type QueryFindUniqueCircleMembersArgs = {
  where: CircleMembersWhereUniqueInput;
};


export type QueryFindUniqueCircleSkillsArgs = {
  where: CircleSkillsWhereUniqueInput;
};


export type QueryFindUniqueCirclesArgs = {
  where: CirclesWhereUniqueInput;
};


export type QueryFindUniqueCommercialsArgs = {
  where: CommercialsWhereUniqueInput;
};


export type QueryFindUniqueFavoriteProductionsArgs = {
  where: FavoriteProductionsWhereUniqueInput;
};


export type QueryFindUniqueGenresArgs = {
  where: GenresWhereUniqueInput;
};


export type QueryFindUniqueGoodProductionsArgs = {
  where: GoodProductionsWhereUniqueInput;
};


export type QueryFindUniqueNoticesArgs = {
  where: NoticesWhereUniqueInput;
};


export type QueryFindUniqueProductionsArgs = {
  where: ProductionsWhereUniqueInput;
};


export type QueryFindUniqueReportsArgs = {
  where: ReportsWhereUniqueInput;
};


export type QueryFindUniqueSeriesArgs = {
  where: SeriesWhereUniqueInput;
};


export type QueryFindUniqueUsersArgs = {
  where: UsersWhereUniqueInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

/**
 *
 * 違反報告など
 */
export type Reports = {
  __typename?: 'Reports';
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  inquiry: Inquiries;
  inquiryId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReportsCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  inquiry: InquiriesCreateNestedOneWithoutReportsInput;
};

export type ReportsCreateManyInquiryInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ReportsCreateManyInquiryInputEnvelope = {
  data: Array<ReportsCreateManyInquiryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ReportsCreateNestedManyWithoutInquiryInput = {
  connect?: InputMaybe<Array<ReportsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReportsCreateOrConnectWithoutInquiryInput>>;
  create?: InputMaybe<Array<ReportsCreateWithoutInquiryInput>>;
  createMany?: InputMaybe<ReportsCreateManyInquiryInputEnvelope>;
};

export type ReportsCreateOrConnectWithoutInquiryInput = {
  create: ReportsCreateWithoutInquiryInput;
  where: ReportsWhereUniqueInput;
};

export type ReportsCreateWithoutInquiryInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ReportsListRelationFilter = {
  every?: InputMaybe<ReportsWhereInput>;
  none?: InputMaybe<ReportsWhereInput>;
  some?: InputMaybe<ReportsWhereInput>;
};

export type ReportsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReportsWhereInput = {
  AND?: InputMaybe<Array<ReportsWhereInput>>;
  NOT?: InputMaybe<Array<ReportsWhereInput>>;
  OR?: InputMaybe<Array<ReportsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  inquiry?: InputMaybe<InquiriesRelationFilter>;
  inquiryId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ReportsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * 作品のシリーズ
 */
export type Series = {
  __typename?: 'Series';
  ProductionSeries: Array<ProductionSeries>;
  _count?: Maybe<SeriesCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
};


/**
 *
 * 作品のシリーズ
 */
export type SeriesProductionSeriesArgs = {
  cursor?: InputMaybe<ProductionSeriesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionSeriesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionSeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionSeriesWhereInput>;
};

export type SeriesAvgAggregate = {
  __typename?: 'SeriesAvgAggregate';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type SeriesCount = {
  __typename?: 'SeriesCount';
  ProductionSeries: Scalars['Int'];
};

export type SeriesCountAggregate = {
  __typename?: 'SeriesCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type SeriesCreateInput = {
  ProductionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutSeriesInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutSeriesInput;
};

export type SeriesCreateManyUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  title: Scalars['String'];
};

export type SeriesCreateManyUserInputEnvelope = {
  data: Array<SeriesCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SeriesCreateNestedOneWithoutProductionSeriesInput = {
  connect?: InputMaybe<SeriesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SeriesCreateOrConnectWithoutProductionSeriesInput>;
  create?: InputMaybe<SeriesCreateWithoutProductionSeriesInput>;
};

export type SeriesCreateOrConnectWithoutProductionSeriesInput = {
  create: SeriesCreateWithoutProductionSeriesInput;
  where: SeriesWhereUniqueInput;
};

export type SeriesCreateOrConnectWithoutUserInput = {
  create: SeriesCreateWithoutUserInput;
  where: SeriesWhereUniqueInput;
};

export type SeriesCreateWithoutProductionSeriesInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  title: Scalars['String'];
  user: UsersCreateNestedOneWithoutSeriesInput;
};

export type SeriesCreateWithoutUserInput = {
  ProductionSeries?: InputMaybe<ProductionSeriesCreateNestedManyWithoutSeriesInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  title: Scalars['String'];
};

export type SeriesListRelationFilter = {
  every?: InputMaybe<SeriesWhereInput>;
  none?: InputMaybe<SeriesWhereInput>;
  some?: InputMaybe<SeriesWhereInput>;
};

export type SeriesMaxAggregate = {
  __typename?: 'SeriesMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type SeriesMinAggregate = {
  __typename?: 'SeriesMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type SeriesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SeriesOrderByWithRelationInput = {
  ProductionSeries?: InputMaybe<ProductionSeriesOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type SeriesRelationFilter = {
  is?: InputMaybe<SeriesWhereInput>;
  isNot?: InputMaybe<SeriesWhereInput>;
};

export enum SeriesScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type SeriesScalarWhereInput = {
  AND?: InputMaybe<Array<SeriesScalarWhereInput>>;
  NOT?: InputMaybe<Array<SeriesScalarWhereInput>>;
  OR?: InputMaybe<Array<SeriesScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type SeriesSumAggregate = {
  __typename?: 'SeriesSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type SeriesUpdateInput = {
  ProductionSeries?: InputMaybe<ProductionSeriesUpdateManyWithoutSeriesNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UsersUpdateOneRequiredWithoutSeriesNestedInput>;
};

export type SeriesUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SeriesUpdateManyWithWhereWithoutUserInput = {
  data: SeriesUpdateManyMutationInput;
  where: SeriesScalarWhereInput;
};

export type SeriesUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<SeriesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SeriesCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SeriesCreateWithoutUserInput>>;
  createMany?: InputMaybe<SeriesCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<SeriesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SeriesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SeriesWhereUniqueInput>>;
  set?: InputMaybe<Array<SeriesWhereUniqueInput>>;
  update?: InputMaybe<Array<SeriesUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<SeriesUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<SeriesUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SeriesUpdateWithWhereUniqueWithoutUserInput = {
  data: SeriesUpdateWithoutUserInput;
  where: SeriesWhereUniqueInput;
};

export type SeriesUpdateWithoutUserInput = {
  ProductionSeries?: InputMaybe<ProductionSeriesUpdateManyWithoutSeriesNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SeriesUpsertWithWhereUniqueWithoutUserInput = {
  create: SeriesCreateWithoutUserInput;
  update: SeriesUpdateWithoutUserInput;
  where: SeriesWhereUniqueInput;
};

export type SeriesWhereInput = {
  AND?: InputMaybe<Array<SeriesWhereInput>>;
  NOT?: InputMaybe<Array<SeriesWhereInput>>;
  OR?: InputMaybe<Array<SeriesWhereInput>>;
  ProductionSeries?: InputMaybe<ProductionSeriesListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type SeriesWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * スキル定義
 */
export type Skills = {
  __typename?: 'Skills';
  _count?: Maybe<SkillsCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SkillsCount = {
  __typename?: 'SkillsCount';
  applyCircles: Scalars['Int'];
  circleMembers: Scalars['Int'];
  circleSkills: Scalars['Int'];
  userSkills: Scalars['Int'];
};

export type SkillsCreateNestedOneWithoutApplyCirclesInput = {
  connect?: InputMaybe<SkillsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SkillsCreateOrConnectWithoutApplyCirclesInput>;
  create?: InputMaybe<SkillsCreateWithoutApplyCirclesInput>;
};

export type SkillsCreateNestedOneWithoutCircleMembersInput = {
  connect?: InputMaybe<SkillsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SkillsCreateOrConnectWithoutCircleMembersInput>;
  create?: InputMaybe<SkillsCreateWithoutCircleMembersInput>;
};

export type SkillsCreateNestedOneWithoutCircleSkillsInput = {
  connect?: InputMaybe<SkillsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SkillsCreateOrConnectWithoutCircleSkillsInput>;
  create?: InputMaybe<SkillsCreateWithoutCircleSkillsInput>;
};

export type SkillsCreateNestedOneWithoutUserSkillsInput = {
  connect?: InputMaybe<SkillsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SkillsCreateOrConnectWithoutUserSkillsInput>;
  create?: InputMaybe<SkillsCreateWithoutUserSkillsInput>;
};

export type SkillsCreateOrConnectWithoutApplyCirclesInput = {
  create: SkillsCreateWithoutApplyCirclesInput;
  where: SkillsWhereUniqueInput;
};

export type SkillsCreateOrConnectWithoutCircleMembersInput = {
  create: SkillsCreateWithoutCircleMembersInput;
  where: SkillsWhereUniqueInput;
};

export type SkillsCreateOrConnectWithoutCircleSkillsInput = {
  create: SkillsCreateWithoutCircleSkillsInput;
  where: SkillsWhereUniqueInput;
};

export type SkillsCreateOrConnectWithoutUserSkillsInput = {
  create: SkillsCreateWithoutUserSkillsInput;
  where: SkillsWhereUniqueInput;
};

export type SkillsCreateWithoutApplyCirclesInput = {
  circleMembers?: InputMaybe<CircleMembersCreateNestedManyWithoutSkillInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SkillsCreateWithoutCircleMembersInput = {
  applyCircles?: InputMaybe<ApplyCirclesCreateNestedManyWithoutSkillInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SkillsCreateWithoutCircleSkillsInput = {
  applyCircles?: InputMaybe<ApplyCirclesCreateNestedManyWithoutSkillInput>;
  circleMembers?: InputMaybe<CircleMembersCreateNestedManyWithoutSkillInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SkillsCreateWithoutUserSkillsInput = {
  applyCircles?: InputMaybe<ApplyCirclesCreateNestedManyWithoutSkillInput>;
  circleMembers?: InputMaybe<CircleMembersCreateNestedManyWithoutSkillInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SkillsOrderByWithRelationInput = {
  applyCircles?: InputMaybe<ApplyCirclesOrderByRelationAggregateInput>;
  circleMembers?: InputMaybe<CircleMembersOrderByRelationAggregateInput>;
  circleSkills?: InputMaybe<CircleSkillsOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userSkills?: InputMaybe<UserSkillsOrderByRelationAggregateInput>;
};

export type SkillsRelationFilter = {
  is?: InputMaybe<SkillsWhereInput>;
  isNot?: InputMaybe<SkillsWhereInput>;
};

export enum SkillsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type SkillsWhereInput = {
  AND?: InputMaybe<Array<SkillsWhereInput>>;
  NOT?: InputMaybe<Array<SkillsWhereInput>>;
  OR?: InputMaybe<Array<SkillsWhereInput>>;
  applyCircles?: InputMaybe<ApplyCirclesListRelationFilter>;
  circleMembers?: InputMaybe<CircleMembersListRelationFilter>;
  circleSkills?: InputMaybe<CircleSkillsListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userSkills?: InputMaybe<UserSkillsListRelationFilter>;
};

export type SkillsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

/**
 *
 * いろいろなものに付けられるタグ
 */
export type Tags = {
  __typename?: 'Tags';
  _count?: Maybe<TagsCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  productionTags: Array<ProductionTags>;
  slugName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/**
 *
 * いろいろなものに付けられるタグ
 */
export type TagsProductionTagsArgs = {
  cursor?: InputMaybe<ProductionTagsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionTagsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionTagsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionTagsWhereInput>;
};

export type TagsAvgAggregate = {
  __typename?: 'TagsAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type TagsCount = {
  __typename?: 'TagsCount';
  productionTags: Scalars['Int'];
};

export type TagsCountAggregate = {
  __typename?: 'TagsCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  slugName: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type TagsCreateInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
  productionTags?: InputMaybe<ProductionTagsCreateNestedManyWithoutTagInput>;
  slugName?: InputMaybe<Scalars['String']>;
};

export type TagsCreateNestedOneWithoutProductionTagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutProductionTagsInput>;
  create?: InputMaybe<TagsCreateWithoutProductionTagsInput>;
};

export type TagsCreateOrConnectWithoutProductionTagsInput = {
  create: TagsCreateWithoutProductionTagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateWithoutProductionTagsInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
  slugName?: InputMaybe<Scalars['String']>;
};

export type TagsMaxAggregate = {
  __typename?: 'TagsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagsMinAggregate = {
  __typename?: 'TagsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productionTags?: InputMaybe<ProductionTagsOrderByRelationAggregateInput>;
  slugName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TagsRelationFilter = {
  is?: InputMaybe<TagsWhereInput>;
  isNot?: InputMaybe<TagsWhereInput>;
};

export enum TagsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  SlugName = 'slugName',
  UpdatedAt = 'updatedAt'
}

export type TagsSumAggregate = {
  __typename?: 'TagsSumAggregate';
  id?: Maybe<Scalars['BigInt']>;
};

export type TagsWhereInput = {
  AND?: InputMaybe<Array<TagsWhereInput>>;
  NOT?: InputMaybe<Array<TagsWhereInput>>;
  OR?: InputMaybe<Array<TagsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  productionTags?: InputMaybe<ProductionTagsListRelationFilter>;
  slugName?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TagsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  slugName?: InputMaybe<Scalars['String']>;
};

/**
 *
 * 会員（作者）のスキル
 */
export type UserSkills = {
  __typename?: 'UserSkills';
  createdAt: Scalars['DateTime'];
  id: Scalars['BigInt'];
  level: Scalars['Int'];
  /** 公開するか？ */
  onPublic: Scalars['Boolean'];
  skill: Skills;
  skillId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: Users;
  userId: Scalars['BigInt'];
};

export type UserSkillsCreateManyInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  level?: InputMaybe<Scalars['Int']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  skillId: Scalars['BigInt'];
  userId: Scalars['BigInt'];
};

export type UserSkillsCreateManyUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  level?: InputMaybe<Scalars['Int']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  skillId: Scalars['BigInt'];
};

export type UserSkillsCreateManyUserInputEnvelope = {
  data: Array<UserSkillsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserSkillsCreateOrConnectWithoutUserInput = {
  create: UserSkillsCreateWithoutUserInput;
  where: UserSkillsWhereUniqueInput;
};

export type UserSkillsCreateWithoutUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  level?: InputMaybe<Scalars['Int']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  skill: SkillsCreateNestedOneWithoutUserSkillsInput;
};

export type UserSkillsListRelationFilter = {
  every?: InputMaybe<UserSkillsWhereInput>;
  none?: InputMaybe<UserSkillsWhereInput>;
  some?: InputMaybe<UserSkillsWhereInput>;
};

export type UserSkillsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserSkillsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  level?: InputMaybe<SortOrder>;
  onPublic?: InputMaybe<SortOrder>;
  skill?: InputMaybe<SkillsOrderByWithRelationInput>;
  skillId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UsersOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserSkillsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Level = 'level',
  OnPublic = 'onPublic',
  SkillId = 'skillId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type UserSkillsScalarWhereInput = {
  AND?: InputMaybe<Array<UserSkillsScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserSkillsScalarWhereInput>>;
  OR?: InputMaybe<Array<UserSkillsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  level?: InputMaybe<IntFilter>;
  onPublic?: InputMaybe<BoolFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserSkillsUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  level?: InputMaybe<IntFieldUpdateOperationsInput>;
  onPublic?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserSkillsUpdateManyWithWhereWithoutUserInput = {
  data: UserSkillsUpdateManyMutationInput;
  where: UserSkillsScalarWhereInput;
};

export type UserSkillsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserSkillsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSkillsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserSkillsCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserSkillsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserSkillsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserSkillsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserSkillsWhereUniqueInput>>;
  set?: InputMaybe<Array<UserSkillsWhereUniqueInput>>;
  update?: InputMaybe<Array<UserSkillsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserSkillsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserSkillsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserSkillsUpdateWithWhereUniqueWithoutUserInput = {
  data: UserSkillsUpdateWithoutUserInput;
  where: UserSkillsWhereUniqueInput;
};

export type UserSkillsUpdateWithoutUserInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  level?: InputMaybe<IntFieldUpdateOperationsInput>;
  onPublic?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserSkillsUpsertWithWhereUniqueWithoutUserInput = {
  create: UserSkillsCreateWithoutUserInput;
  update: UserSkillsUpdateWithoutUserInput;
  where: UserSkillsWhereUniqueInput;
};

export type UserSkillsWhereInput = {
  AND?: InputMaybe<Array<UserSkillsWhereInput>>;
  NOT?: InputMaybe<Array<UserSkillsWhereInput>>;
  OR?: InputMaybe<Array<UserSkillsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  level?: InputMaybe<IntFilter>;
  onPublic?: InputMaybe<BoolFilter>;
  skill?: InputMaybe<SkillsRelationFilter>;
  skillId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UsersRelationFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type UserSkillsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 *
 * 会員（作者）
 */
export type Users = {
  __typename?: 'Users';
  Series: Array<Series>;
  _count?: Maybe<UsersCount>;
  applyCircles: Array<ApplyCircles>;
  /** 地域 */
  area?: Maybe<Scalars['String']>;
  /** 地域　公開非公開 */
  areaPub: Scalars['Boolean'];
  /** 生年月日 */
  birthday?: Maybe<Scalars['DateTime']>;
  /** 生年月日　公開非公開 */
  birthdayPub: Scalars['Boolean'];
  circleComments: Array<CircleComments>;
  circleMembers: Array<CircleMembers>;
  circles: Array<Circles>;
  /** Cognitoの一意キー */
  cognitoUsername: Scalars['String'];
  createdAt: Scalars['DateTime'];
  disabled?: Maybe<Scalars['DateTime']>;
  /** 連絡用メールアドレス */
  email: Scalars['String'];
  emailResets: Array<EmailResets>;
  /** メールVerifyした日 */
  emailVerifiedAt?: Maybe<Scalars['DateTime']>;
  /** fb アカウント */
  facebookId?: Maybe<Scalars['String']>;
  facebookUse: Scalars['Int'];
  favoriteProductions: Array<FavoriteProductions>;
  /** 性別 */
  gender?: Maybe<Scalars['Int']>;
  /** 性別公開非公開 */
  genderPub?: Maybe<Scalars['Boolean']>;
  goodProductions: Array<GoodProductions>;
  /** 一意キー */
  id: Scalars['BigInt'];
  /** プロフィール画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** インスタID */
  instagramId?: Maybe<Scalars['String']>;
  /** インスタ */
  instagramUse: Scalars['Int'];
  /** 紹介文 */
  introduction?: Maybe<Scalars['String']>;
  introductionMd?: Maybe<Scalars['String']>;
  /** 紹介文　公開非公開 */
  introductionPub?: Maybe<Scalars['Boolean']>;
  /** 管理者かどうか（あんまかんけいない） */
  isAdmin: Scalars['Boolean'];
  /** ニックネーム＊ハンドルネーム */
  nickname?: Maybe<Scalars['String']>;
  /** プロフィール公開非公開 */
  onPublic?: Maybe<Scalars['Boolean']>;
  productionComments: Array<ProductionComments>;
  productions: Array<Productions>;
  registerProfileAt?: Maybe<Scalars['DateTime']>;
  /** スキル全体　公開非公開 */
  skillPub?: Maybe<Scalars['Boolean']>;
  /** SNSアカウント公開非公開 */
  snsPub?: Maybe<Scalars['Boolean']>;
  totalProductionCountOnCircle?: Maybe<Scalars['Float']>;
  totalViewCount?: Maybe<Scalars['Float']>;
  /** twitter アカウント */
  twitterId?: Maybe<Scalars['String']>;
  twitterUse: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSkills: Array<UserSkills>;
};


/**
 *
 * 会員（作者）
 */
export type UsersSeriesArgs = {
  cursor?: InputMaybe<SeriesWhereUniqueInput>;
  distinct?: InputMaybe<Array<SeriesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SeriesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeriesWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersApplyCirclesArgs = {
  cursor?: InputMaybe<ApplyCirclesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplyCirclesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplyCirclesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplyCirclesWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersCircleCommentsArgs = {
  cursor?: InputMaybe<CircleCommentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleCommentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleCommentsWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersCircleMembersArgs = {
  cursor?: InputMaybe<CircleMembersWhereUniqueInput>;
  distinct?: InputMaybe<Array<CircleMembersScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CircleMembersOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CircleMembersWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersCirclesArgs = {
  cursor?: InputMaybe<CirclesWhereUniqueInput>;
  distinct?: InputMaybe<Array<CirclesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CirclesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CirclesWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersEmailResetsArgs = {
  cursor?: InputMaybe<EmailResetsWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmailResetsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmailResetsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EmailResetsWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersFavoriteProductionsArgs = {
  cursor?: InputMaybe<FavoriteProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoriteProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoriteProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FavoriteProductionsWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersGoodProductionsArgs = {
  cursor?: InputMaybe<GoodProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<GoodProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GoodProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GoodProductionsWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersProductionCommentsArgs = {
  cursor?: InputMaybe<ProductionCommentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionCommentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionCommentsWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersProductionsArgs = {
  cursor?: InputMaybe<ProductionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductionsWhereInput>;
};


/**
 *
 * 会員（作者）
 */
export type UsersUserSkillsArgs = {
  cursor?: InputMaybe<UserSkillsWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserSkillsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserSkillsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserSkillsWhereInput>;
};

export type UsersCount = {
  __typename?: 'UsersCount';
  Series: Scalars['Int'];
  applyCircles: Scalars['Int'];
  circleComments: Scalars['Int'];
  circleMembers: Scalars['Int'];
  circles: Scalars['Int'];
  emailResets: Scalars['Int'];
  favoriteProductions: Scalars['Int'];
  goodProductions: Scalars['Int'];
  productionComments: Scalars['Int'];
  productions: Scalars['Int'];
  userSkills: Scalars['Int'];
};

export type UsersCreateNestedOneWithoutApplyCirclesInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutApplyCirclesInput>;
  create?: InputMaybe<UsersCreateWithoutApplyCirclesInput>;
};

export type UsersCreateNestedOneWithoutCircleCommentsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutCircleCommentsInput>;
  create?: InputMaybe<UsersCreateWithoutCircleCommentsInput>;
};

export type UsersCreateNestedOneWithoutCircleMembersInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutCircleMembersInput>;
  create?: InputMaybe<UsersCreateWithoutCircleMembersInput>;
};

export type UsersCreateNestedOneWithoutCirclesInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutCirclesInput>;
  create?: InputMaybe<UsersCreateWithoutCirclesInput>;
};

export type UsersCreateNestedOneWithoutFavoriteProductionsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutFavoriteProductionsInput>;
  create?: InputMaybe<UsersCreateWithoutFavoriteProductionsInput>;
};

export type UsersCreateNestedOneWithoutGoodProductionsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutGoodProductionsInput>;
  create?: InputMaybe<UsersCreateWithoutGoodProductionsInput>;
};

export type UsersCreateNestedOneWithoutProductionCommentsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutProductionCommentsInput>;
  create?: InputMaybe<UsersCreateWithoutProductionCommentsInput>;
};

export type UsersCreateNestedOneWithoutProductionsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutProductionsInput>;
  create?: InputMaybe<UsersCreateWithoutProductionsInput>;
};

export type UsersCreateNestedOneWithoutSeriesInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutSeriesInput>;
  create?: InputMaybe<UsersCreateWithoutSeriesInput>;
};

export type UsersCreateOrConnectWithoutApplyCirclesInput = {
  create: UsersCreateWithoutApplyCirclesInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutCircleCommentsInput = {
  create: UsersCreateWithoutCircleCommentsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutCircleMembersInput = {
  create: UsersCreateWithoutCircleMembersInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutCirclesInput = {
  create: UsersCreateWithoutCirclesInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutFavoriteProductionsInput = {
  create: UsersCreateWithoutFavoriteProductionsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutGoodProductionsInput = {
  create: UsersCreateWithoutGoodProductionsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutProductionCommentsInput = {
  create: UsersCreateWithoutProductionCommentsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutProductionsInput = {
  create: UsersCreateWithoutProductionsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutSeriesInput = {
  create: UsersCreateWithoutSeriesInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateWithoutApplyCirclesInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutCircleCommentsInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutCircleMembersInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutCirclesInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutFavoriteProductionsInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutGoodProductionsInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutProductionCommentsInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutProductionsInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersCreateWithoutSeriesInput = {
  area?: InputMaybe<Scalars['String']>;
  areaPub?: InputMaybe<Scalars['Boolean']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  birthdayPub?: InputMaybe<Scalars['Boolean']>;
  cognitoUsername: Scalars['String'];
  disabled?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  facebookId?: InputMaybe<Scalars['String']>;
  facebookUse?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['Int']>;
  genderPub?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instagramId?: InputMaybe<Scalars['String']>;
  instagramUse?: InputMaybe<Scalars['Int']>;
  introduction?: InputMaybe<Scalars['String']>;
  introductionMd?: InputMaybe<Scalars['String']>;
  introductionPub?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  onPublic?: InputMaybe<Scalars['Boolean']>;
  registerProfileAt?: InputMaybe<Scalars['DateTime']>;
  skillPub?: InputMaybe<Scalars['Boolean']>;
  snsPub?: InputMaybe<Scalars['Boolean']>;
  twitterId?: InputMaybe<Scalars['String']>;
  twitterUse?: InputMaybe<Scalars['Int']>;
};

export type UsersOrderByWithRelationInput = {
  Series?: InputMaybe<SeriesOrderByRelationAggregateInput>;
  applyCircles?: InputMaybe<ApplyCirclesOrderByRelationAggregateInput>;
  area?: InputMaybe<SortOrder>;
  areaPub?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  birthdayPub?: InputMaybe<SortOrder>;
  circleComments?: InputMaybe<CircleCommentsOrderByRelationAggregateInput>;
  circleMembers?: InputMaybe<CircleMembersOrderByRelationAggregateInput>;
  circles?: InputMaybe<CirclesOrderByRelationAggregateInput>;
  cognitoUsername?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailResets?: InputMaybe<EmailResetsOrderByRelationAggregateInput>;
  emailVerifiedAt?: InputMaybe<SortOrder>;
  facebookId?: InputMaybe<SortOrder>;
  facebookUse?: InputMaybe<SortOrder>;
  favoriteProductions?: InputMaybe<FavoriteProductionsOrderByRelationAggregateInput>;
  gender?: InputMaybe<SortOrder>;
  genderPub?: InputMaybe<SortOrder>;
  goodProductions?: InputMaybe<GoodProductionsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  instagramId?: InputMaybe<SortOrder>;
  instagramUse?: InputMaybe<SortOrder>;
  introduction?: InputMaybe<SortOrder>;
  introductionMd?: InputMaybe<SortOrder>;
  introductionPub?: InputMaybe<SortOrder>;
  isAdmin?: InputMaybe<SortOrder>;
  nickname?: InputMaybe<SortOrder>;
  onPublic?: InputMaybe<SortOrder>;
  productionComments?: InputMaybe<ProductionCommentsOrderByRelationAggregateInput>;
  productions?: InputMaybe<ProductionsOrderByRelationAggregateInput>;
  registerProfileAt?: InputMaybe<SortOrder>;
  skillPub?: InputMaybe<SortOrder>;
  snsPub?: InputMaybe<SortOrder>;
  twitterId?: InputMaybe<SortOrder>;
  twitterUse?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userSkills?: InputMaybe<UserSkillsOrderByRelationAggregateInput>;
};

export type UsersRelationFilter = {
  is?: InputMaybe<UsersWhereInput>;
  isNot?: InputMaybe<UsersWhereInput>;
};

export enum UsersScalarFieldEnum {
  Area = 'area',
  AreaPub = 'areaPub',
  Birthday = 'birthday',
  BirthdayPub = 'birthdayPub',
  CognitoUsername = 'cognitoUsername',
  CreatedAt = 'createdAt',
  Disabled = 'disabled',
  Email = 'email',
  EmailVerifiedAt = 'emailVerifiedAt',
  FacebookId = 'facebookId',
  FacebookUse = 'facebookUse',
  Gender = 'gender',
  GenderPub = 'genderPub',
  Id = 'id',
  ImageUrl = 'imageUrl',
  InstagramId = 'instagramId',
  InstagramUse = 'instagramUse',
  Introduction = 'introduction',
  IntroductionMd = 'introductionMd',
  IntroductionPub = 'introductionPub',
  IsAdmin = 'isAdmin',
  Nickname = 'nickname',
  OnPublic = 'onPublic',
  RegisterProfileAt = 'registerProfileAt',
  SkillPub = 'skillPub',
  SnsPub = 'snsPub',
  TwitterId = 'twitterId',
  TwitterUse = 'twitterUse',
  UpdatedAt = 'updatedAt'
}

export type UsersUpdateInput = {
  Series?: InputMaybe<SeriesUpdateManyWithoutUserNestedInput>;
  applyCircles?: InputMaybe<ApplyCirclesUpdateManyWithoutUserNestedInput>;
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  areaPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  circleComments?: InputMaybe<CircleCommentsUpdateManyWithoutUserNestedInput>;
  circleMembers?: InputMaybe<CircleMembersUpdateManyWithoutUserNestedInput>;
  circles?: InputMaybe<CirclesUpdateManyWithoutUserNestedInput>;
  cognitoUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailResets?: InputMaybe<EmailResetsUpdateManyWithoutUserNestedInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  favoriteProductions?: InputMaybe<FavoriteProductionsUpdateManyWithoutUserNestedInput>;
  gender?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  genderPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  goodProductions?: InputMaybe<GoodProductionsUpdateManyWithoutUserNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  introduction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nickname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productionComments?: InputMaybe<ProductionCommentsUpdateManyWithoutUserNestedInput>;
  productions?: InputMaybe<ProductionsUpdateManyWithoutUserNestedInput>;
  registerProfileAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  skillPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  snsPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  twitterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  twitterUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  userSkills?: InputMaybe<UserSkillsUpdateManyWithoutUserNestedInput>;
};

export type UsersUpdateOneRequiredWithoutCirclesNestedInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutCirclesInput>;
  create?: InputMaybe<UsersCreateWithoutCirclesInput>;
  update?: InputMaybe<UsersUpdateWithoutCirclesInput>;
  upsert?: InputMaybe<UsersUpsertWithoutCirclesInput>;
};

export type UsersUpdateOneRequiredWithoutProductionsNestedInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutProductionsInput>;
  create?: InputMaybe<UsersCreateWithoutProductionsInput>;
  update?: InputMaybe<UsersUpdateWithoutProductionsInput>;
  upsert?: InputMaybe<UsersUpsertWithoutProductionsInput>;
};

export type UsersUpdateOneRequiredWithoutSeriesNestedInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutSeriesInput>;
  create?: InputMaybe<UsersCreateWithoutSeriesInput>;
  update?: InputMaybe<UsersUpdateWithoutSeriesInput>;
  upsert?: InputMaybe<UsersUpsertWithoutSeriesInput>;
};

export type UsersUpdateWithoutCirclesInput = {
  Series?: InputMaybe<SeriesUpdateManyWithoutUserNestedInput>;
  applyCircles?: InputMaybe<ApplyCirclesUpdateManyWithoutUserNestedInput>;
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  areaPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  circleComments?: InputMaybe<CircleCommentsUpdateManyWithoutUserNestedInput>;
  circleMembers?: InputMaybe<CircleMembersUpdateManyWithoutUserNestedInput>;
  cognitoUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailResets?: InputMaybe<EmailResetsUpdateManyWithoutUserNestedInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  favoriteProductions?: InputMaybe<FavoriteProductionsUpdateManyWithoutUserNestedInput>;
  gender?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  genderPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  goodProductions?: InputMaybe<GoodProductionsUpdateManyWithoutUserNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  introduction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nickname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productionComments?: InputMaybe<ProductionCommentsUpdateManyWithoutUserNestedInput>;
  productions?: InputMaybe<ProductionsUpdateManyWithoutUserNestedInput>;
  registerProfileAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  skillPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  snsPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  twitterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  twitterUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  userSkills?: InputMaybe<UserSkillsUpdateManyWithoutUserNestedInput>;
};

export type UsersUpdateWithoutProductionsInput = {
  Series?: InputMaybe<SeriesUpdateManyWithoutUserNestedInput>;
  applyCircles?: InputMaybe<ApplyCirclesUpdateManyWithoutUserNestedInput>;
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  areaPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  circleComments?: InputMaybe<CircleCommentsUpdateManyWithoutUserNestedInput>;
  circleMembers?: InputMaybe<CircleMembersUpdateManyWithoutUserNestedInput>;
  circles?: InputMaybe<CirclesUpdateManyWithoutUserNestedInput>;
  cognitoUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailResets?: InputMaybe<EmailResetsUpdateManyWithoutUserNestedInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  favoriteProductions?: InputMaybe<FavoriteProductionsUpdateManyWithoutUserNestedInput>;
  gender?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  genderPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  goodProductions?: InputMaybe<GoodProductionsUpdateManyWithoutUserNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  introduction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nickname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productionComments?: InputMaybe<ProductionCommentsUpdateManyWithoutUserNestedInput>;
  registerProfileAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  skillPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  snsPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  twitterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  twitterUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  userSkills?: InputMaybe<UserSkillsUpdateManyWithoutUserNestedInput>;
};

export type UsersUpdateWithoutSeriesInput = {
  applyCircles?: InputMaybe<ApplyCirclesUpdateManyWithoutUserNestedInput>;
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  areaPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayPub?: InputMaybe<BoolFieldUpdateOperationsInput>;
  circleComments?: InputMaybe<CircleCommentsUpdateManyWithoutUserNestedInput>;
  circleMembers?: InputMaybe<CircleMembersUpdateManyWithoutUserNestedInput>;
  circles?: InputMaybe<CirclesUpdateManyWithoutUserNestedInput>;
  cognitoUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailResets?: InputMaybe<EmailResetsUpdateManyWithoutUserNestedInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  favoriteProductions?: InputMaybe<FavoriteProductionsUpdateManyWithoutUserNestedInput>;
  gender?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  genderPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  goodProductions?: InputMaybe<GoodProductionsUpdateManyWithoutUserNestedInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instagramUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  introduction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionMd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nickname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productionComments?: InputMaybe<ProductionCommentsUpdateManyWithoutUserNestedInput>;
  productions?: InputMaybe<ProductionsUpdateManyWithoutUserNestedInput>;
  registerProfileAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  skillPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  snsPub?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  twitterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  twitterUse?: InputMaybe<IntFieldUpdateOperationsInput>;
  userSkills?: InputMaybe<UserSkillsUpdateManyWithoutUserNestedInput>;
};

export type UsersUpsertWithoutCirclesInput = {
  create: UsersCreateWithoutCirclesInput;
  update: UsersUpdateWithoutCirclesInput;
};

export type UsersUpsertWithoutProductionsInput = {
  create: UsersCreateWithoutProductionsInput;
  update: UsersUpdateWithoutProductionsInput;
};

export type UsersUpsertWithoutSeriesInput = {
  create: UsersCreateWithoutSeriesInput;
  update: UsersUpdateWithoutSeriesInput;
};

export type UsersWhereInput = {
  AND?: InputMaybe<Array<UsersWhereInput>>;
  NOT?: InputMaybe<Array<UsersWhereInput>>;
  OR?: InputMaybe<Array<UsersWhereInput>>;
  Series?: InputMaybe<SeriesListRelationFilter>;
  applyCircles?: InputMaybe<ApplyCirclesListRelationFilter>;
  area?: InputMaybe<StringNullableFilter>;
  areaPub?: InputMaybe<BoolFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  birthdayPub?: InputMaybe<BoolFilter>;
  circleComments?: InputMaybe<CircleCommentsListRelationFilter>;
  circleMembers?: InputMaybe<CircleMembersListRelationFilter>;
  circles?: InputMaybe<CirclesListRelationFilter>;
  cognitoUsername?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  emailResets?: InputMaybe<EmailResetsListRelationFilter>;
  emailVerifiedAt?: InputMaybe<DateTimeNullableFilter>;
  facebookId?: InputMaybe<StringNullableFilter>;
  facebookUse?: InputMaybe<IntFilter>;
  favoriteProductions?: InputMaybe<FavoriteProductionsListRelationFilter>;
  gender?: InputMaybe<IntNullableFilter>;
  genderPub?: InputMaybe<BoolNullableFilter>;
  goodProductions?: InputMaybe<GoodProductionsListRelationFilter>;
  id?: InputMaybe<BigIntFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  instagramId?: InputMaybe<StringNullableFilter>;
  instagramUse?: InputMaybe<IntFilter>;
  introduction?: InputMaybe<StringNullableFilter>;
  introductionMd?: InputMaybe<StringNullableFilter>;
  introductionPub?: InputMaybe<BoolNullableFilter>;
  isAdmin?: InputMaybe<BoolFilter>;
  nickname?: InputMaybe<StringNullableFilter>;
  onPublic?: InputMaybe<BoolNullableFilter>;
  productionComments?: InputMaybe<ProductionCommentsListRelationFilter>;
  productions?: InputMaybe<ProductionsListRelationFilter>;
  registerProfileAt?: InputMaybe<DateTimeNullableFilter>;
  skillPub?: InputMaybe<BoolNullableFilter>;
  snsPub?: InputMaybe<BoolNullableFilter>;
  twitterId?: InputMaybe<StringNullableFilter>;
  twitterUse?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userSkills?: InputMaybe<UserSkillsListRelationFilter>;
};

export type UsersWhereUniqueInput = {
  cognitoUsername?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CreateOneProductionCommentsMutationVariables = Exact<{
  data: ProductionCommentsCreateInput;
}>;


export type CreateOneProductionCommentsMutation = { __typename?: 'Mutation', createOneProductionComments: { __typename?: 'ProductionComments', id: number, productionId: number, userId: number, comment: string, disabled?: any | null, updatedAt?: any | null, createdAt: any } };

export type FindManyProductionCommentsQueryVariables = Exact<{
  where?: InputMaybe<ProductionCommentsWhereInput>;
  orderBy?: InputMaybe<Array<ProductionCommentsOrderByWithRelationInput> | ProductionCommentsOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyProductionCommentsQuery = { __typename?: 'Query', findManyProductionComments: Array<{ __typename?: 'ProductionComments', id: number, productionId: number, userId: number, createdAt: any, updatedAt?: any | null, comment: string, disabled?: any | null, user: { __typename?: 'Users', id: number, imageUrl?: string | null, nickname?: string | null } }> };

export type FindManyFavoriteProductionsQueryVariables = Exact<{
  where?: InputMaybe<FavoriteProductionsWhereInput>;
  orderBy?: InputMaybe<Array<FavoriteProductionsOrderByWithRelationInput> | FavoriteProductionsOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyFavoriteProductionsQuery = { __typename?: 'Query', findManyFavoriteProductions: Array<{ __typename?: 'FavoriteProductions', id: number, productionId: number, userId: number, production: { __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null, favoritesCount?: number | null, goodCount?: number | null, commentsCount?: number | null, user: { __typename?: 'Users', id: number, imageUrl?: string | null, nickname?: string | null }, form: { __typename?: 'Forms', id: number, title?: string | null, createdAt: any, updatedAt?: any | null }, productionTags: Array<{ __typename?: 'ProductionTags', tag: { __typename?: 'Tags', id: number, name: string } }>, productionGenres: Array<{ __typename?: 'ProductionGenres', genre: { __typename?: 'Genres', id: number, name: string } }>, productionSeries: Array<{ __typename?: 'ProductionSeries', series: { __typename?: 'Series', id: number, title: string } }>, productionImages: Array<{ __typename?: 'ProductionImages', id: number, image: string, imageUrl?: string | null, thumbUrl?: string | null }> } }> };

export type AggregateFavoriteProductionsQueryVariables = Exact<{
  where?: InputMaybe<FavoriteProductionsWhereInput>;
}>;


export type AggregateFavoriteProductionsQuery = { __typename?: 'Query', aggregateFavoriteProductions: { __typename?: 'AggregateFavoriteProductions', count?: { __typename?: 'FavoriteProductionsCountAggregate', all: number } | null } };

export type FindUniqueFavoriteProductionsQueryVariables = Exact<{
  where: FavoriteProductionsWhereUniqueInput;
}>;


export type FindUniqueFavoriteProductionsQuery = { __typename?: 'Query', findUniqueFavoriteProductions?: { __typename?: 'FavoriteProductions', id: number, userId: number, productionId: number, createdAt: any, updatedAt?: any | null, production: { __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null, user: { __typename?: 'Users', id: number, imageUrl?: string | null, nickname?: string | null }, form: { __typename?: 'Forms', id: number, title?: string | null, createdAt: any, updatedAt?: any | null }, productionTags: Array<{ __typename?: 'ProductionTags', tag: { __typename?: 'Tags', id: number, name: string } }>, productionGenres: Array<{ __typename?: 'ProductionGenres', genre: { __typename?: 'Genres', id: number, name: string } }>, productionSeries: Array<{ __typename?: 'ProductionSeries', series: { __typename?: 'Series', id: number, title: string } }>, productionImages: Array<{ __typename?: 'ProductionImages', id: number, image: string, imageUrl?: string | null, thumbUrl?: string | null }> } } | null };

export type CreateOneFavoriteProductionsMutationVariables = Exact<{
  data: FavoriteProductionsCreateInput;
}>;


export type CreateOneFavoriteProductionsMutation = { __typename?: 'Mutation', createOneFavoriteProductions: { __typename?: 'FavoriteProductions', id: number, createdAt: any, updatedAt?: any | null, user: { __typename?: 'Users', id: number, email: string }, production: { __typename?: 'Productions', id: number, title: string } } };

export type DeleteOneFavoriteProductionsMutationVariables = Exact<{
  where: FavoriteProductionsWhereUniqueInput;
}>;


export type DeleteOneFavoriteProductionsMutation = { __typename?: 'Mutation', deleteOneFavoriteProductions?: { __typename?: 'FavoriteProductions', id: number, userId: number } | null };

export type FindUniqueGoodProductionsQueryVariables = Exact<{
  where: GoodProductionsWhereUniqueInput;
}>;


export type FindUniqueGoodProductionsQuery = { __typename?: 'Query', findUniqueGoodProductions?: { __typename?: 'GoodProductions', id: number, productionId: number, userId: number, createdAt?: any | null, updatedAt?: any | null } | null };

export type CreateOneGoodProductionsMutationVariables = Exact<{
  data: GoodProductionsCreateInput;
}>;


export type CreateOneGoodProductionsMutation = { __typename?: 'Mutation', createOneGoodProductions: { __typename?: 'GoodProductions', id: number, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'Users', id: number, email: string }, production: { __typename?: 'Productions', id: number, title: string } } };

export type DeleteOneGoodProductionsMutationVariables = Exact<{
  where: GoodProductionsWhereUniqueInput;
}>;


export type DeleteOneGoodProductionsMutation = { __typename?: 'Mutation', deleteOneGoodProductions?: { __typename?: 'GoodProductions', id: number, userId: number } | null };

export type FindManyInquiriesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<InquiriesOrderByWithRelationInput> | InquiriesOrderByWithRelationInput>;
  where?: InputMaybe<InquiriesWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyInquiriesQuery = { __typename?: 'Query', findManyInquiries: Array<{ __typename?: 'Inquiries', id: number, name: string, email: string, phone: string, description: string, createdAt: any, updatedAt?: any | null }> };

export type CreateOneInquiriesMutationVariables = Exact<{
  data: InquiriesCreateInput;
}>;


export type CreateOneInquiriesMutation = { __typename?: 'Mutation', createOneInquiries: { __typename?: 'Inquiries', id: number, name: string, email: string, phone: string, description: string, createdAt: any, updatedAt?: any | null } };

export type FindManyLatestProductionsQueryVariables = Exact<{
  where?: InputMaybe<LatestProductionsWhereInput>;
  orderBy?: InputMaybe<Array<LatestProductionsOrderByWithRelationInput> | LatestProductionsOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyLatestProductionsQuery = { __typename?: 'Query', findManyLatestProductions: Array<{ __typename?: 'LatestProductions', id: number, productionId: number, createdAt: any, updatedAt?: any | null, production: { __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null, favoritesCount?: number | null, goodCount?: number | null, commentsCount?: number | null, user: { __typename?: 'Users', id: number, imageUrl?: string | null, nickname?: string | null }, form: { __typename?: 'Forms', id: number, title?: string | null, createdAt: any, updatedAt?: any | null }, productionTags: Array<{ __typename?: 'ProductionTags', tag: { __typename?: 'Tags', id: number, name: string } }>, productionGenres: Array<{ __typename?: 'ProductionGenres', genre: { __typename?: 'Genres', id: number, name: string } }>, productionSeries: Array<{ __typename?: 'ProductionSeries', series: { __typename?: 'Series', id: number, title: string } }>, productionImages: Array<{ __typename?: 'ProductionImages', id: number, image: string, imageUrl?: string | null, thumbUrl?: string | null }> } }> };

export type FindManyFormsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FormsOrderByWithRelationInput> | FormsOrderByWithRelationInput>;
}>;


export type FindManyFormsQuery = { __typename?: 'Query', findManyForms: Array<{ __typename?: 'Forms', id: number, title?: string | null, updatedAt?: any | null, createdAt: any }> };

export type FindManyGenresQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<GenresOrderByWithRelationInput> | GenresOrderByWithRelationInput>;
}>;


export type FindManyGenresQuery = { __typename?: 'Query', findManyGenres: Array<{ __typename?: 'Genres', id: number, name: string, createdAt: any, updatedAt?: any | null }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe?: { __typename?: 'Users', id: number, cognitoUsername: string, email: string, emailVerifiedAt?: any | null, areaPub: boolean, area?: string | null, birthday?: any | null, birthdayPub: boolean, facebookId?: string | null, facebookUse: number, twitterId?: string | null, twitterUse: number, instagramId?: string | null, instagramUse: number, gender?: number | null, genderPub?: boolean | null, imageUrl?: string | null, introduction?: string | null, introductionPub?: boolean | null, nickname?: string | null, onPublic?: boolean | null, skillPub?: boolean | null, snsPub?: boolean | null, isAdmin: boolean, createdAt: any, updatedAt?: any | null, registerProfileAt?: any | null, totalViewCount?: number | null, Series: Array<{ __typename?: 'Series', id: number, userId: number, title: string, createdAt: any, updatedAt?: any | null }>, userSkills: Array<{ __typename?: 'UserSkills', id: number, userId: number, skillId: number, level: number, onPublic: boolean, createdAt: any, updatedAt?: any | null, skill: { __typename?: 'Skills', id: number, title?: string | null, createdAt: any, updatedAt?: any | null } }>, _count?: { __typename?: 'UsersCount', applyCircles: number, circleComments: number, circleMembers: number, circles: number, emailResets: number, favoriteProductions: number, goodProductions: number, productionComments: number, productions: number, userSkills: number } | null } | null };

export type FindManyNoticesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<NoticesOrderByWithRelationInput> | NoticesOrderByWithRelationInput>;
  where?: InputMaybe<NoticesWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyNoticesQuery = { __typename?: 'Query', findManyNotices: Array<{ __typename?: 'Notices', id: number, title: string, imageUrl?: string | null, description: string, publish: any, disabled?: any | null, createdAt: any, updatedAt?: any | null }> };

export type AggregateNoticesQueryVariables = Exact<{
  where?: InputMaybe<NoticesWhereInput>;
}>;


export type AggregateNoticesQuery = { __typename?: 'Query', aggregateNotices: { __typename?: 'AggregateNotices', count?: { __typename?: 'NoticesCountAggregate', all: number } | null } };

export type FindUniqueNoticesQueryVariables = Exact<{
  where: NoticesWhereUniqueInput;
}>;


export type FindUniqueNoticesQuery = { __typename?: 'Query', findUniqueNotices?: { __typename?: 'Notices', id: number, title: string, imageUrl?: string | null, description: string, publish: any, disabled?: any | null, createdAt: any, updatedAt?: any | null } | null };

export type CreateOneNoticesMutationVariables = Exact<{
  data: NoticesCreateInput;
}>;


export type CreateOneNoticesMutation = { __typename?: 'Mutation', createOneNotices: { __typename?: 'Notices', id: number, title: string, imageUrl?: string | null, description: string, publish: any, disabled?: any | null, createdAt: any, updatedAt?: any | null } };

export type UpdateOneNoticesMutationVariables = Exact<{
  data: NoticesUpdateInput;
  where: NoticesWhereUniqueInput;
}>;


export type UpdateOneNoticesMutation = { __typename?: 'Mutation', updateOneNotices?: { __typename?: 'Notices', id: number, title: string, imageUrl?: string | null, description: string, publish: any, disabled?: any | null, createdAt: any, updatedAt?: any | null } | null };

export type DeleteOneNoticesMutationVariables = Exact<{
  where: NoticesWhereUniqueInput;
}>;


export type DeleteOneNoticesMutation = { __typename?: 'Mutation', deleteOneNotices?: { __typename?: 'Notices', id: number } | null };

export type FindManyPopularProductionsQueryVariables = Exact<{
  where?: InputMaybe<PopularProductionsWhereInput>;
  orderBy?: InputMaybe<Array<PopularProductionsOrderByWithRelationInput> | PopularProductionsOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyPopularProductionsQuery = { __typename?: 'Query', findManyPopularProductions: Array<{ __typename?: 'PopularProductions', id: number, productionId: number, displayOrder: number, createdAt: any, updatedAt?: any | null, production: { __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null, favoritesCount?: number | null, goodCount?: number | null, commentsCount?: number | null, user: { __typename?: 'Users', id: number, imageUrl?: string | null, nickname?: string | null }, form: { __typename?: 'Forms', id: number, title?: string | null, createdAt: any, updatedAt?: any | null }, productionTags: Array<{ __typename?: 'ProductionTags', tag: { __typename?: 'Tags', id: number, name: string } }>, productionGenres: Array<{ __typename?: 'ProductionGenres', genre: { __typename?: 'Genres', id: number, name: string } }>, productionSeries: Array<{ __typename?: 'ProductionSeries', series: { __typename?: 'Series', id: number, title: string } }>, productionImages: Array<{ __typename?: 'ProductionImages', id: number, image: string, imageUrl?: string | null, thumbUrl?: string | null }> } }> };

export type FindManyProductionsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ProductionsOrderByWithRelationInput> | ProductionsOrderByWithRelationInput>;
  where?: InputMaybe<ProductionsWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyProductionsQuery = { __typename?: 'Query', findManyProductions: Array<{ __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null, user: { __typename?: 'Users', id: number, imageUrl?: string | null, nickname?: string | null }, form: { __typename?: 'Forms', id: number, title?: string | null, createdAt: any, updatedAt?: any | null }, productionTags: Array<{ __typename?: 'ProductionTags', tag: { __typename?: 'Tags', id: number, name: string } }>, productionGenres: Array<{ __typename?: 'ProductionGenres', genre: { __typename?: 'Genres', id: number, name: string } }>, productionSeries: Array<{ __typename?: 'ProductionSeries', series: { __typename?: 'Series', id: number, title: string } }>, productionImages: Array<{ __typename?: 'ProductionImages', id: number, image: string, imageUrl?: string | null, thumbUrl?: string | null }>, _count?: { __typename?: 'ProductionsCount', editorRecommendations: number, favoriteProductions: number, goodProductions: number, newProductions: number, popularProductions: number, productionComments: number, productionGenres: number, productionSeries: number, productionImages: number, productionTags: number } | null }> };

export type AggregateProductionsQueryVariables = Exact<{
  where?: InputMaybe<ProductionsWhereInput>;
}>;


export type AggregateProductionsQuery = { __typename?: 'Query', aggregateProductions: { __typename?: 'AggregateProductions', count?: { __typename?: 'ProductionsCountAggregate', all: number } | null } };

export type FindUniqueProductionsQueryVariables = Exact<{
  where: ProductionsWhereUniqueInput;
}>;


export type FindUniqueProductionsQuery = { __typename?: 'Query', findUniqueProductions?: { __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null, user: { __typename?: 'Users', id: number, imageUrl?: string | null, nickname?: string | null }, form: { __typename?: 'Forms', id: number, title?: string | null, createdAt: any, updatedAt?: any | null }, productionTags: Array<{ __typename?: 'ProductionTags', tag: { __typename?: 'Tags', id: number, name: string } }>, productionGenres: Array<{ __typename?: 'ProductionGenres', genre: { __typename?: 'Genres', id: number, name: string } }>, productionSeries: Array<{ __typename?: 'ProductionSeries', series: { __typename?: 'Series', id: number, title: string } }>, productionComments: Array<{ __typename?: 'ProductionComments', id: number, productionId: number, userId: number, comment: string, createdAt: any, updatedAt?: any | null, disabled?: any | null }>, productionImages: Array<{ __typename?: 'ProductionImages', id: number, image: string, imageUrl?: string | null, thumbUrl?: string | null }>, _count?: { __typename?: 'ProductionsCount', editorRecommendations: number, favoriteProductions: number, goodProductions: number, newProductions: number, popularProductions: number, productionComments: number, productionGenres: number, productionSeries: number, productionImages: number, productionTags: number } | null } | null };

export type CreateOneProductionsMutationVariables = Exact<{
  data: ProductionsCreateInput;
}>;


export type CreateOneProductionsMutation = { __typename?: 'Mutation', createOneProductions: { __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null } };

export type UpdateOneProductionsMutationVariables = Exact<{
  data: ProductionsUpdateInput;
  where: ProductionsWhereUniqueInput;
}>;


export type UpdateOneProductionsMutation = { __typename?: 'Mutation', updateOneProductions?: { __typename?: 'Productions', id: number, userId: number, formId: number, circleId?: number | null, closed?: any | null, commentAcceptable: boolean, countBookmarks: number, countComments: number, countViews: number, countPages: number, disabled?: any | null, onCircle: boolean, postFacebook: boolean, postTwitter: boolean, postInstagram: boolean, published?: any | null, title: string, body?: string | null, layout?: string | null, description?: string | null, createdAt: any, updatedAt?: any | null } | null };

export type DeleteOneProductionsMutationVariables = Exact<{
  where: ProductionsWhereUniqueInput;
}>;


export type DeleteOneProductionsMutation = { __typename?: 'Mutation', deleteOneProductions?: { __typename?: 'Productions', id: number, userId: number } | null };

export type IncrementViewCountMutationVariables = Exact<{
  productionId: Scalars['Float'];
}>;


export type IncrementViewCountMutation = { __typename?: 'Mutation', incrementViewCount?: number | null };

export type FindManySeriesQueryVariables = Exact<{
  where?: InputMaybe<SeriesWhereInput>;
  orderBy?: InputMaybe<Array<SeriesOrderByWithRelationInput> | SeriesOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManySeriesQuery = { __typename?: 'Query', findManySeries: Array<{ __typename?: 'Series', id: number, userId: number, title: string, createdAt: any, updatedAt?: any | null, ProductionSeries: Array<{ __typename?: 'ProductionSeries', id: number, productionId: number, seriesId: number, createdAt: any, updatedAt?: any | null, production: { __typename?: 'Productions', id: number } }>, user: { __typename?: 'Users', id: number, email: string, nickname?: string | null } }> };

export type FindFirstSeriesQueryVariables = Exact<{
  where?: InputMaybe<SeriesWhereInput>;
  orderBy?: InputMaybe<Array<SeriesOrderByWithRelationInput> | SeriesOrderByWithRelationInput>;
}>;


export type FindFirstSeriesQuery = { __typename?: 'Query', findFirstSeries?: { __typename?: 'Series', id: number, userId: number, title: string, createdAt: any, updatedAt?: any | null, ProductionSeries: Array<{ __typename?: 'ProductionSeries', id: number, productionId: number, seriesId: number, createdAt: any, updatedAt?: any | null, production: { __typename?: 'Productions', id: number } }>, user: { __typename?: 'Users', id: number, email: string, nickname?: string | null } } | null };

export type CreateOneSeriesMutationVariables = Exact<{
  data: SeriesCreateInput;
}>;


export type CreateOneSeriesMutation = { __typename?: 'Mutation', createOneSeries: { __typename?: 'Series', id: number, userId: number, title: string, createdAt: any, updatedAt?: any | null, ProductionSeries: Array<{ __typename?: 'ProductionSeries', id: number, productionId: number, seriesId: number, createdAt: any, updatedAt?: any | null, production: { __typename?: 'Productions', id: number } }>, user: { __typename?: 'Users', id: number, email: string, nickname?: string | null } } };

export type FindManyTagsQueryVariables = Exact<{
  where?: InputMaybe<TagsWhereInput>;
  orderBy?: InputMaybe<Array<TagsOrderByWithRelationInput> | TagsOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyTagsQuery = { __typename?: 'Query', findManyTags: Array<{ __typename?: 'Tags', id: number, name: string, slugName?: string | null, createdAt: any, updatedAt?: any | null, _count?: { __typename?: 'TagsCount', productionTags: number } | null }> };

export type FindFirstTagsQueryVariables = Exact<{
  where?: InputMaybe<TagsWhereInput>;
}>;


export type FindFirstTagsQuery = { __typename?: 'Query', findFirstTags?: { __typename?: 'Tags', id: number, name: string, slugName?: string | null } | null };

export type CreateOneTagsMutationVariables = Exact<{
  data: TagsCreateInput;
}>;


export type CreateOneTagsMutation = { __typename?: 'Mutation', createOneTags: { __typename?: 'Tags', id: number, name: string, slugName?: string | null, createdAt: any, updatedAt?: any | null } };

export type FindUniqueUsersQueryVariables = Exact<{
  where: UsersWhereUniqueInput;
}>;


export type FindUniqueUsersQuery = { __typename?: 'Query', findUniqueUsers?: { __typename?: 'Users', id: number, cognitoUsername: string, email: string, emailVerifiedAt?: any | null, area?: string | null, areaPub: boolean, birthday?: any | null, birthdayPub: boolean, facebookId?: string | null, facebookUse: number, twitterId?: string | null, twitterUse: number, instagramId?: string | null, instagramUse: number, gender?: number | null, genderPub?: boolean | null, imageUrl?: string | null, introduction?: string | null, introductionPub?: boolean | null, nickname?: string | null, onPublic?: boolean | null, skillPub?: boolean | null, snsPub?: boolean | null, isAdmin: boolean, createdAt: any, updatedAt?: any | null, registerProfileAt?: any | null, totalViewCount?: number | null, userSkills: Array<{ __typename?: 'UserSkills', id: number, userId: number, level: number, skillId: number, onPublic: boolean, createdAt: any, updatedAt?: any | null, skill: { __typename?: 'Skills', id: number, title?: string | null, createdAt: any, updatedAt?: any | null } }>, _count?: { __typename?: 'UsersCount', applyCircles: number, circleComments: number, circleMembers: number, circles: number, emailResets: number, favoriteProductions: number, goodProductions: number, productionComments: number, productions: number, userSkills: number } | null } | null };

export type UpdateOneUsersMutationVariables = Exact<{
  data: UsersUpdateInput;
  where: UsersWhereUniqueInput;
}>;


export type UpdateOneUsersMutation = { __typename?: 'Mutation', updateOneUsers?: { __typename?: 'Users', id: number, cognitoUsername: string, email: string, emailVerifiedAt?: any | null, areaPub: boolean, area?: string | null, birthday?: any | null, birthdayPub: boolean, facebookId?: string | null, facebookUse: number, twitterId?: string | null, twitterUse: number, instagramId?: string | null, instagramUse: number, gender?: number | null, genderPub?: boolean | null, imageUrl?: string | null, introduction?: string | null, nickname?: string | null, onPublic?: boolean | null, skillPub?: boolean | null, snsPub?: boolean | null, isAdmin: boolean, createdAt: any, updatedAt?: any | null, registerProfileAt?: any | null } | null };


export const CreateOneProductionCommentsDocument = gql`
    mutation createOneProductionComments($data: ProductionCommentsCreateInput!) {
  createOneProductionComments(data: $data) {
    id
    productionId
    userId
    comment
    disabled
    updatedAt
    createdAt
  }
}
    `;
export const FindManyProductionCommentsDocument = gql`
    query findManyProductionComments($where: ProductionCommentsWhereInput, $orderBy: [ProductionCommentsOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyProductionComments(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
  ) {
    id
    productionId
    userId
    createdAt
    updatedAt
    comment
    disabled
    user {
      id
      imageUrl
      nickname
    }
  }
}
    `;
export const FindManyFavoriteProductionsDocument = gql`
    query findManyFavoriteProductions($where: FavoriteProductionsWhereInput, $orderBy: [FavoriteProductionsOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyFavoriteProductions(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
  ) {
    id
    productionId
    userId
    production {
      id
      userId
      formId
      circleId
      closed
      commentAcceptable
      countBookmarks
      countComments
      countViews
      countPages
      disabled
      onCircle
      postFacebook
      postTwitter
      postInstagram
      published
      title
      body
      layout
      description
      createdAt
      updatedAt
      user {
        id
        imageUrl
        nickname
      }
      form {
        id
        title
        createdAt
        updatedAt
      }
      productionTags {
        tag {
          id
          name
        }
      }
      productionGenres {
        genre {
          id
          name
        }
      }
      productionSeries {
        series {
          id
          title
        }
      }
      productionImages {
        id
        image
        imageUrl
        thumbUrl
      }
      favoritesCount
      goodCount
      commentsCount
    }
  }
}
    `;
export const AggregateFavoriteProductionsDocument = gql`
    query aggregateFavoriteProductions($where: FavoriteProductionsWhereInput) {
  aggregateFavoriteProductions(where: $where) {
    count: _count {
      all: _all
    }
  }
}
    `;
export const FindUniqueFavoriteProductionsDocument = gql`
    query findUniqueFavoriteProductions($where: FavoriteProductionsWhereUniqueInput!) {
  findUniqueFavoriteProductions(where: $where) {
    id
    userId
    productionId
    createdAt
    updatedAt
    production {
      id
      userId
      formId
      circleId
      closed
      commentAcceptable
      countBookmarks
      countComments
      countViews
      countPages
      disabled
      onCircle
      postFacebook
      postTwitter
      postInstagram
      published
      title
      body
      layout
      description
      createdAt
      updatedAt
      user {
        id
        imageUrl
        nickname
      }
      form {
        id
        title
        createdAt
        updatedAt
      }
      productionTags {
        tag {
          id
          name
        }
      }
      productionGenres {
        genre {
          id
          name
        }
      }
      productionSeries {
        series {
          id
          title
        }
      }
      productionImages {
        id
        image
        imageUrl
        thumbUrl
      }
    }
  }
}
    `;
export const CreateOneFavoriteProductionsDocument = gql`
    mutation createOneFavoriteProductions($data: FavoriteProductionsCreateInput!) {
  createOneFavoriteProductions(data: $data) {
    id
    user {
      id
      email
    }
    production {
      id
      title
    }
    createdAt
    updatedAt
  }
}
    `;
export const DeleteOneFavoriteProductionsDocument = gql`
    mutation deleteOneFavoriteProductions($where: FavoriteProductionsWhereUniqueInput!) {
  deleteOneFavoriteProductions(where: $where) {
    id
    userId
  }
}
    `;
export const FindUniqueGoodProductionsDocument = gql`
    query findUniqueGoodProductions($where: GoodProductionsWhereUniqueInput!) {
  findUniqueGoodProductions(where: $where) {
    id
    productionId
    userId
    createdAt
    updatedAt
  }
}
    `;
export const CreateOneGoodProductionsDocument = gql`
    mutation createOneGoodProductions($data: GoodProductionsCreateInput!) {
  createOneGoodProductions(data: $data) {
    id
    user {
      id
      email
    }
    production {
      id
      title
    }
    createdAt
    updatedAt
  }
}
    `;
export const DeleteOneGoodProductionsDocument = gql`
    mutation deleteOneGoodProductions($where: GoodProductionsWhereUniqueInput!) {
  deleteOneGoodProductions(where: $where) {
    id
    userId
  }
}
    `;
export const FindManyInquiriesDocument = gql`
    query findManyInquiries($orderBy: [InquiriesOrderByWithRelationInput!], $where: InquiriesWhereInput, $take: Int, $skip: Int) {
  findManyInquiries(orderBy: $orderBy, where: $where, take: $take, skip: $skip) {
    id
    name
    email
    phone
    description
    createdAt
    updatedAt
  }
}
    `;
export const CreateOneInquiriesDocument = gql`
    mutation createOneInquiries($data: InquiriesCreateInput!) {
  createOneInquiries(data: $data) {
    id
    name
    email
    phone
    description
    createdAt
    updatedAt
  }
}
    `;
export const FindManyLatestProductionsDocument = gql`
    query findManyLatestProductions($where: LatestProductionsWhereInput, $orderBy: [LatestProductionsOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyLatestProductions(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
  ) {
    id
    productionId
    createdAt
    updatedAt
    production {
      id
      userId
      formId
      circleId
      closed
      commentAcceptable
      countBookmarks
      countComments
      countViews
      countPages
      disabled
      onCircle
      postFacebook
      postTwitter
      postInstagram
      published
      title
      body
      layout
      description
      createdAt
      updatedAt
      user {
        id
        imageUrl
        nickname
      }
      form {
        id
        title
        createdAt
        updatedAt
      }
      productionTags {
        tag {
          id
          name
        }
      }
      productionGenres {
        genre {
          id
          name
        }
      }
      productionSeries {
        series {
          id
          title
        }
      }
      productionImages {
        id
        image
        imageUrl
        thumbUrl
      }
      favoritesCount
      goodCount
      commentsCount
    }
  }
}
    `;
export const FindManyFormsDocument = gql`
    query findManyForms($orderBy: [FormsOrderByWithRelationInput!]) {
  findManyForms(orderBy: $orderBy) {
    id
    title
    updatedAt
    createdAt
  }
}
    `;
export const FindManyGenresDocument = gql`
    query findManyGenres($orderBy: [GenresOrderByWithRelationInput!]) {
  findManyGenres(orderBy: $orderBy) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export const GetMeDocument = gql`
    query getMe {
  getMe {
    id
    cognitoUsername
    email
    emailVerifiedAt
    areaPub
    area
    birthday
    birthdayPub
    facebookId
    facebookUse
    twitterId
    twitterUse
    instagramId
    instagramUse
    gender
    genderPub
    imageUrl
    introduction
    introductionPub
    nickname
    onPublic
    skillPub
    snsPub
    isAdmin
    createdAt
    updatedAt
    registerProfileAt
    totalViewCount
    Series {
      id
      userId
      title
      createdAt
      updatedAt
    }
    userSkills {
      id
      userId
      skillId
      level
      onPublic
      createdAt
      updatedAt
      skill {
        id
        title
        createdAt
        updatedAt
      }
    }
    _count {
      applyCircles
      circleComments
      circleMembers
      circles
      emailResets
      favoriteProductions
      goodProductions
      productionComments
      productions
      userSkills
    }
  }
}
    `;
export const FindManyNoticesDocument = gql`
    query findManyNotices($orderBy: [NoticesOrderByWithRelationInput!], $where: NoticesWhereInput, $take: Int, $skip: Int) {
  findManyNotices(orderBy: $orderBy, where: $where, take: $take, skip: $skip) {
    id
    title
    imageUrl
    description
    publish
    disabled
    createdAt
    updatedAt
  }
}
    `;
export const AggregateNoticesDocument = gql`
    query aggregateNotices($where: NoticesWhereInput) {
  aggregateNotices(where: $where) {
    count: _count {
      all: _all
    }
  }
}
    `;
export const FindUniqueNoticesDocument = gql`
    query findUniqueNotices($where: NoticesWhereUniqueInput!) {
  findUniqueNotices(where: $where) {
    id
    title
    imageUrl
    description
    publish
    disabled
    createdAt
    updatedAt
  }
}
    `;
export const CreateOneNoticesDocument = gql`
    mutation createOneNotices($data: NoticesCreateInput!) {
  createOneNotices(data: $data) {
    id
    title
    imageUrl
    description
    publish
    disabled
    createdAt
    updatedAt
  }
}
    `;
export const UpdateOneNoticesDocument = gql`
    mutation updateOneNotices($data: NoticesUpdateInput!, $where: NoticesWhereUniqueInput!) {
  updateOneNotices(data: $data, where: $where) {
    id
    title
    imageUrl
    description
    publish
    disabled
    createdAt
    updatedAt
  }
}
    `;
export const DeleteOneNoticesDocument = gql`
    mutation deleteOneNotices($where: NoticesWhereUniqueInput!) {
  deleteOneNotices(where: $where) {
    id
  }
}
    `;
export const FindManyPopularProductionsDocument = gql`
    query findManyPopularProductions($where: PopularProductionsWhereInput, $orderBy: [PopularProductionsOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyPopularProductions(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
  ) {
    id
    productionId
    displayOrder
    createdAt
    updatedAt
    production {
      id
      userId
      formId
      circleId
      closed
      commentAcceptable
      countBookmarks
      countComments
      countViews
      countPages
      disabled
      onCircle
      postFacebook
      postTwitter
      postInstagram
      published
      title
      body
      layout
      description
      createdAt
      updatedAt
      user {
        id
        imageUrl
        nickname
      }
      form {
        id
        title
        createdAt
        updatedAt
      }
      productionTags {
        tag {
          id
          name
        }
      }
      productionGenres {
        genre {
          id
          name
        }
      }
      productionSeries {
        series {
          id
          title
        }
      }
      productionImages {
        id
        image
        imageUrl
        thumbUrl
      }
      favoritesCount
      goodCount
      commentsCount
    }
  }
}
    `;
export const FindManyProductionsDocument = gql`
    query findManyProductions($orderBy: [ProductionsOrderByWithRelationInput!], $where: ProductionsWhereInput, $take: Int, $skip: Int) {
  findManyProductions(orderBy: $orderBy, where: $where, take: $take, skip: $skip) {
    id
    userId
    formId
    circleId
    closed
    commentAcceptable
    countBookmarks
    countComments
    countViews
    countPages
    disabled
    onCircle
    postFacebook
    postTwitter
    postInstagram
    published
    title
    body
    layout
    description
    createdAt
    updatedAt
    user {
      id
      imageUrl
      nickname
    }
    form {
      id
      title
      createdAt
      updatedAt
    }
    productionTags {
      tag {
        id
        name
      }
    }
    productionGenres {
      genre {
        id
        name
      }
    }
    productionSeries {
      series {
        id
        title
      }
    }
    productionImages {
      id
      image
      imageUrl
      thumbUrl
    }
    _count {
      editorRecommendations
      favoriteProductions
      goodProductions
      newProductions
      popularProductions
      productionComments
      productionGenres
      productionSeries
      productionImages
      productionTags
    }
  }
}
    `;
export const AggregateProductionsDocument = gql`
    query aggregateProductions($where: ProductionsWhereInput) {
  aggregateProductions(where: $where) {
    count: _count {
      all: _all
    }
  }
}
    `;
export const FindUniqueProductionsDocument = gql`
    query findUniqueProductions($where: ProductionsWhereUniqueInput!) {
  findUniqueProductions(where: $where) {
    id
    userId
    formId
    circleId
    closed
    commentAcceptable
    countBookmarks
    countComments
    countViews
    countPages
    disabled
    onCircle
    postFacebook
    postTwitter
    postInstagram
    published
    title
    body
    layout
    description
    createdAt
    updatedAt
    user {
      id
      imageUrl
      nickname
    }
    form {
      id
      title
      createdAt
      updatedAt
    }
    productionTags {
      tag {
        id
        name
      }
    }
    productionGenres {
      genre {
        id
        name
      }
    }
    productionSeries {
      series {
        id
        title
      }
    }
    productionComments {
      id
      productionId
      userId
      comment
      createdAt
      updatedAt
      disabled
    }
    productionImages {
      id
      image
      imageUrl
      thumbUrl
    }
    _count {
      editorRecommendations
      favoriteProductions
      goodProductions
      newProductions
      popularProductions
      productionComments
      productionGenres
      productionSeries
      productionImages
      productionTags
    }
  }
}
    `;
export const CreateOneProductionsDocument = gql`
    mutation createOneProductions($data: ProductionsCreateInput!) {
  createOneProductions(data: $data) {
    id
    userId
    formId
    circleId
    closed
    commentAcceptable
    countBookmarks
    countComments
    countViews
    countPages
    disabled
    onCircle
    postFacebook
    postTwitter
    postInstagram
    published
    title
    body
    layout
    description
    createdAt
    updatedAt
  }
}
    `;
export const UpdateOneProductionsDocument = gql`
    mutation updateOneProductions($data: ProductionsUpdateInput!, $where: ProductionsWhereUniqueInput!) {
  updateOneProductions(data: $data, where: $where) {
    id
    userId
    formId
    circleId
    closed
    commentAcceptable
    countBookmarks
    countComments
    countViews
    countPages
    disabled
    onCircle
    postFacebook
    postTwitter
    postInstagram
    published
    title
    body
    layout
    description
    createdAt
    updatedAt
  }
}
    `;
export const DeleteOneProductionsDocument = gql`
    mutation deleteOneProductions($where: ProductionsWhereUniqueInput!) {
  deleteOneProductions(where: $where) {
    id
    userId
  }
}
    `;
export const IncrementViewCountDocument = gql`
    mutation incrementViewCount($productionId: Float!) {
  incrementViewCount(productionId: $productionId)
}
    `;
export const FindManySeriesDocument = gql`
    query findManySeries($where: SeriesWhereInput, $orderBy: [SeriesOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManySeries(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    userId
    title
    createdAt
    updatedAt
    ProductionSeries {
      id
      productionId
      seriesId
      createdAt
      updatedAt
      production {
        id
      }
    }
    user {
      id
      email
      nickname
    }
  }
}
    `;
export const FindFirstSeriesDocument = gql`
    query findFirstSeries($where: SeriesWhereInput, $orderBy: [SeriesOrderByWithRelationInput!]) {
  findFirstSeries(where: $where, orderBy: $orderBy) {
    id
    userId
    title
    createdAt
    updatedAt
    ProductionSeries {
      id
      productionId
      seriesId
      createdAt
      updatedAt
      production {
        id
      }
    }
    user {
      id
      email
      nickname
    }
  }
}
    `;
export const CreateOneSeriesDocument = gql`
    mutation createOneSeries($data: SeriesCreateInput!) {
  createOneSeries(data: $data) {
    id
    userId
    title
    createdAt
    updatedAt
    ProductionSeries {
      id
      productionId
      seriesId
      createdAt
      updatedAt
      production {
        id
      }
    }
    user {
      id
      email
      nickname
    }
  }
}
    `;
export const FindManyTagsDocument = gql`
    query findManyTags($where: TagsWhereInput, $orderBy: [TagsOrderByWithRelationInput!], $take: Int, $skip: Int) {
  findManyTags(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    name
    slugName
    createdAt
    updatedAt
    _count {
      productionTags
    }
  }
}
    `;
export const FindFirstTagsDocument = gql`
    query findFirstTags($where: TagsWhereInput) {
  findFirstTags(where: $where) {
    id
    name
    slugName
  }
}
    `;
export const CreateOneTagsDocument = gql`
    mutation createOneTags($data: TagsCreateInput!) {
  createOneTags(data: $data) {
    id
    name
    slugName
    createdAt
    updatedAt
  }
}
    `;
export const FindUniqueUsersDocument = gql`
    query findUniqueUsers($where: UsersWhereUniqueInput!) {
  findUniqueUsers(where: $where) {
    id
    cognitoUsername
    email
    emailVerifiedAt
    area
    areaPub
    birthday
    birthdayPub
    facebookId
    facebookUse
    twitterId
    twitterUse
    instagramId
    instagramUse
    gender
    genderPub
    imageUrl
    introduction
    introductionPub
    nickname
    onPublic
    skillPub
    snsPub
    isAdmin
    createdAt
    updatedAt
    registerProfileAt
    userSkills {
      id
      userId
      level
      skillId
      onPublic
      createdAt
      updatedAt
      skill {
        id
        title
        createdAt
        updatedAt
      }
    }
    totalViewCount
    _count {
      applyCircles
      circleComments
      circleMembers
      circles
      emailResets
      favoriteProductions
      goodProductions
      productionComments
      productions
      userSkills
    }
  }
}
    `;
export const UpdateOneUsersDocument = gql`
    mutation updateOneUsers($data: UsersUpdateInput!, $where: UsersWhereUniqueInput!) {
  updateOneUsers(data: $data, where: $where) {
    id
    cognitoUsername
    email
    emailVerifiedAt
    areaPub
    area
    birthday
    birthdayPub
    facebookId
    facebookUse
    twitterId
    twitterUse
    instagramId
    instagramUse
    gender
    genderPub
    imageUrl
    introduction
    nickname
    onPublic
    skillPub
    snsPub
    isAdmin
    createdAt
    updatedAt
    registerProfileAt
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    createOneProductionComments(variables: CreateOneProductionCommentsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneProductionCommentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneProductionCommentsMutation>(CreateOneProductionCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneProductionComments', 'mutation');
    },
    findManyProductionComments(variables?: FindManyProductionCommentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyProductionCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyProductionCommentsQuery>(FindManyProductionCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyProductionComments', 'query');
    },
    findManyFavoriteProductions(variables?: FindManyFavoriteProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyFavoriteProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyFavoriteProductionsQuery>(FindManyFavoriteProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyFavoriteProductions', 'query');
    },
    aggregateFavoriteProductions(variables?: AggregateFavoriteProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AggregateFavoriteProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AggregateFavoriteProductionsQuery>(AggregateFavoriteProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'aggregateFavoriteProductions', 'query');
    },
    findUniqueFavoriteProductions(variables: FindUniqueFavoriteProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindUniqueFavoriteProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindUniqueFavoriteProductionsQuery>(FindUniqueFavoriteProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findUniqueFavoriteProductions', 'query');
    },
    createOneFavoriteProductions(variables: CreateOneFavoriteProductionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneFavoriteProductionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneFavoriteProductionsMutation>(CreateOneFavoriteProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneFavoriteProductions', 'mutation');
    },
    deleteOneFavoriteProductions(variables: DeleteOneFavoriteProductionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteOneFavoriteProductionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOneFavoriteProductionsMutation>(DeleteOneFavoriteProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOneFavoriteProductions', 'mutation');
    },
    findUniqueGoodProductions(variables: FindUniqueGoodProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindUniqueGoodProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindUniqueGoodProductionsQuery>(FindUniqueGoodProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findUniqueGoodProductions', 'query');
    },
    createOneGoodProductions(variables: CreateOneGoodProductionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneGoodProductionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneGoodProductionsMutation>(CreateOneGoodProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneGoodProductions', 'mutation');
    },
    deleteOneGoodProductions(variables: DeleteOneGoodProductionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteOneGoodProductionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOneGoodProductionsMutation>(DeleteOneGoodProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOneGoodProductions', 'mutation');
    },
    findManyInquiries(variables?: FindManyInquiriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyInquiriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyInquiriesQuery>(FindManyInquiriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyInquiries', 'query');
    },
    createOneInquiries(variables: CreateOneInquiriesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneInquiriesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneInquiriesMutation>(CreateOneInquiriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneInquiries', 'mutation');
    },
    findManyLatestProductions(variables?: FindManyLatestProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyLatestProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyLatestProductionsQuery>(FindManyLatestProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyLatestProductions', 'query');
    },
    findManyForms(variables?: FindManyFormsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyFormsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyFormsQuery>(FindManyFormsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyForms', 'query');
    },
    findManyGenres(variables?: FindManyGenresQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyGenresQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyGenresQuery>(FindManyGenresDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyGenres', 'query');
    },
    getMe(variables?: GetMeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMeQuery>(GetMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMe', 'query');
    },
    findManyNotices(variables?: FindManyNoticesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyNoticesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyNoticesQuery>(FindManyNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyNotices', 'query');
    },
    aggregateNotices(variables?: AggregateNoticesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AggregateNoticesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AggregateNoticesQuery>(AggregateNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'aggregateNotices', 'query');
    },
    findUniqueNotices(variables: FindUniqueNoticesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindUniqueNoticesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindUniqueNoticesQuery>(FindUniqueNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findUniqueNotices', 'query');
    },
    createOneNotices(variables: CreateOneNoticesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneNoticesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneNoticesMutation>(CreateOneNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneNotices', 'mutation');
    },
    updateOneNotices(variables: UpdateOneNoticesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOneNoticesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOneNoticesMutation>(UpdateOneNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOneNotices', 'mutation');
    },
    deleteOneNotices(variables: DeleteOneNoticesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteOneNoticesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOneNoticesMutation>(DeleteOneNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOneNotices', 'mutation');
    },
    findManyPopularProductions(variables?: FindManyPopularProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyPopularProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyPopularProductionsQuery>(FindManyPopularProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyPopularProductions', 'query');
    },
    findManyProductions(variables?: FindManyProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyProductionsQuery>(FindManyProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyProductions', 'query');
    },
    aggregateProductions(variables?: AggregateProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AggregateProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AggregateProductionsQuery>(AggregateProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'aggregateProductions', 'query');
    },
    findUniqueProductions(variables: FindUniqueProductionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindUniqueProductionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindUniqueProductionsQuery>(FindUniqueProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findUniqueProductions', 'query');
    },
    createOneProductions(variables: CreateOneProductionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneProductionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneProductionsMutation>(CreateOneProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneProductions', 'mutation');
    },
    updateOneProductions(variables: UpdateOneProductionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOneProductionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOneProductionsMutation>(UpdateOneProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOneProductions', 'mutation');
    },
    deleteOneProductions(variables: DeleteOneProductionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteOneProductionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOneProductionsMutation>(DeleteOneProductionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOneProductions', 'mutation');
    },
    incrementViewCount(variables: IncrementViewCountMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IncrementViewCountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncrementViewCountMutation>(IncrementViewCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incrementViewCount', 'mutation');
    },
    findManySeries(variables?: FindManySeriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManySeriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManySeriesQuery>(FindManySeriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManySeries', 'query');
    },
    findFirstSeries(variables?: FindFirstSeriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindFirstSeriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstSeriesQuery>(FindFirstSeriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstSeries', 'query');
    },
    createOneSeries(variables: CreateOneSeriesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneSeriesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneSeriesMutation>(CreateOneSeriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneSeries', 'mutation');
    },
    findManyTags(variables?: FindManyTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindManyTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyTagsQuery>(FindManyTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyTags', 'query');
    },
    findFirstTags(variables?: FindFirstTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindFirstTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstTagsQuery>(FindFirstTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstTags', 'query');
    },
    createOneTags(variables: CreateOneTagsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOneTagsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneTagsMutation>(CreateOneTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneTags', 'mutation');
    },
    findUniqueUsers(variables: FindUniqueUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FindUniqueUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindUniqueUsersQuery>(FindUniqueUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findUniqueUsers', 'query');
    },
    updateOneUsers(variables: UpdateOneUsersMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOneUsersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOneUsersMutation>(UpdateOneUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOneUsers', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;